{
  "admin": {
    "detail": {
      "reload_error": "Handlinga er avslutta, men dei oppdaterte opplysningane kunne ikkje lastast. Oppdater før du gjer fleire endringar.",
      "reload_retry": "Prøv å oppdatere igjen",
      "history_error": "Kunne ikkje laste historikken. Prøv igjen.",
      "leave_draft": "Vil du forlate sida og forkaste endringane du ikkje har lagra?",
      "discard_draft": "Vil du forkaste endringane du ikkje har lagra?",
      "credit_reason_required": "Skriv ei grunngjeving for krediteringa.",
      "company_field_blank": "Fyll ut feltet.",
      "company_field_invalid": "Skriv ein gyldig verdi.",
      "company_field_too_long": "Kort ned verdien.",
      "company_field_unpermitted": "Feltet kan ikkje endrast lokalt."
    },
    "case_documents": {
      "preview_ready": "Førehandsvisinga er klar – opne PDF",
      "refresh_error": "Dokumentet blei oppdatert, men saka kunne ikkje hentast på nytt. Prøv å oppdatere saka før du gjer fleire endringar.",
      "sharing_error": "Kunne ikkje endre delinga av dokumentet. Prøv igjen."
    },
    "billing": {
      "reconcile_queued": "Avstemming er lagd i kø. Oppdater for å kontrollere resultatet.",
      "refresh_error": "Kunne ikkje oppdatere køyringa. Viser sist henta status; prøv å oppdatere igjen.",
      "title": "Fakturering",
      "subtitle": "Nye meistrar blir fakturerte dagleg. Betaling blir kontrollert mot Tripletex kvar kveld.",
      "waiting": "Ventar på første betaling",
      "invoices": "Fakturaer",
      "person": "Person",
      "trade": "Fag",
      "period": "År",
      "amount": "Beløp",
      "state": "Status",
      "invoice": "Fakturanummer",
      "invoice_line": "Årsgebyr %{year}",
      "kid": "KID",
      "checked": "Sist kontrollert",
      "action": "Handling",
      "issue": "Send faktura",
      "retry": "Prøv igjen",
      "reconcile": "Kontroller betaling",
      "refresh": "Oppdater oversikta",
      "done": "Handlinga er utført. Ein betalingskontroll blir vist når jobben er ferdig.",
      "error": "Handlinga kunne ikkje fullførast. Sjå status og kontroller opplysningane før du prøver igjen.",
      "uncertain_title": "Ei overføring må kontrollerast i Tripletex",
      "uncertain_body": "Vi veit ikkje sikkert om Tripletex fullførte overføringa. Automatisk gjentaking er stoppa for å unngå dobbeltfakturering. Oppgi person, fag og år til rekneskapsansvarleg.",
      "empty": "Ingen fakturaer eller nye meistrar i denne oversikta.",
      "pagination": "Sider i fakturaoversikta",
      "previous": "Førre",
      "next": "Neste",
      "count": "Side %{page} · %{total} oppføringar",
      "status": {
        "ready": "Klar til fakturering",
        "draft": "Klar til overføring",
        "sent": "Ventar på betaling",
        "paid": "Betalt",
        "credited": "Kreditert",
        "uncertain": "Må kontrollerast i Tripletex",
        "failed": "Overføring feila",
        "not_billable": "Skal ikkje fakturerast",
        "already_covered": "Årsgebyret er allereie dekt",
        "register_review": "Ventar på registerkontroll",
        "reconciliation_failed": "Avstemming må kontrollerast"
      },
      "dashboard": {
        "records": "Postar i grunnlaget",
        "processed": "%{count} av %{total} postar behandla",
        "progress_help": "Behandla postar inkluderer fullførte og utelatne postar og postar med feil.",
        "failed_help": "%{count} postar feila. Kontroller resultata i tabellen før du prøver igjen."
      },
      "reconciliation": {
        "external_credit": "Kreditering stadfesta ved avstemming mot Tripletex"
      },
      "preview": {
        "title": "Kontroller fakturagrunnlaget",
        "credit_title": "Kontroller krediteringsgrunnlaget",
        "notice": "Ingenting er overført til Tripletex.",
        "ready": "Klare til overføring",
        "credit_ready": "Klare til kreditering",
        "total": "Sum til overføring",
        "credit_total": "Sum til kreditering",
        "terms": "%{channel} · Forfall %{date}",
        "details": "Vis utval og vilkår",
        "all": "Alle",
        "ready_filter": "Klare",
        "skipped_filter": "Utelatne",
        "result": "Kontrollresultat",
        "excluded": "%{count} utelatne postar blir ikkje behandla.",
        "nothing": "Ingen postar kan behandlast frå dette grunnlaget",
        "nothing_body": "Sjå årsakene i tabellen. Lag eit nytt grunnlag når opplysningane eller utvalet er endra.",
        "no_matches": "Ingen postar i dette filteret.",
        "back": "Tilbake til fakturering",
        "transfer_one": "Overfør 1 faktura",
        "transfer_many": "Overfør %{count} fakturaer",
        "credit_one": "Opprett 1 kreditnota",
        "credit_many": "Opprett %{count} kreditnotaer"
      },
      "recovery": {
        "title": "Avklar overføring",
        "body": "Vi hentar fakturaen frå Tripletex og kontrollerer kunde, beløp og referanse. Dette registrerer ikkje betaling og opprettar ingen ny faktura.",
        "reference": "Venta referanse",
        "invoice_id": "Faktura-ID i Tripletex",
        "completed": "Eg har kontrollert at overføringa er fullført i Tripletex",
        "save": "Kontroller og lagre avklaring"
      },
      "runs": {
        "credit_preview": "Vis grunnlag",
        "title": "Kontrollerte køyringar",
        "operation": "Type køyring",
        "issue": "Fakturakøyring",
        "credit": "Massekreditering",
        "limit": "Maks tal i køyringa",
        "batch": "Tal per bunt",
        "cohort": "Målgruppe",
        "channel": "Sendemåte for køyringa",
        "due_days": "Dagar til forfall",
        "number_from": "Mesterbrevnummer frå",
        "number_to": "Mesterbrevnummer til",
        "master_number": "Mesterbrevnummer",
        "reason": "Grunngiving",
        "preview": "Berre kontroll – vis grunnlag",
        "preview_notice": "Førehandskontroll – ingenting er overført",
        "preview_body": "Kontroller personar, beløp og avvik. Start overfører berre postane som er klare i dette lagra grunnlaget.",
        "start": "Start kontrollert køyring",
        "resume": "Ta opp att uferdige postar",
        "retry_failed": "Prøv feila postar igjen",
        "next_part": "Lag grunnlag for neste delutval",
        "open_next_part": "Opne neste delutval",
        "previous_part": "Førre delutval",
        "selection_summary": "%{selected} av %{candidates} kandidatar valde. Mesterbrevnummer i grunnlaget: %{from}–%{to}. Stod att ved førehandskontroll: %{remaining}.",
        "continuation_help": "Neste delutval får ein ny førehandskontroll med same utvalsvilkår og dagens grunnlagsdato. Tidlegare valde postar blir ikkje tekne med igjen. Følg opp utelatne og feila postar i køyringa dei høyrer til. Buntar blir behandla automatisk innanfor éi godkjend køyring.",
        "back": "Tilbake til fakturering og avklaring av overføringar",
        "recent": "Siste køyringar",
        "result": "Resultat / avvik",
        "credit_note": "Kreditnota-ID",
        "credit_selection": "Valt %{count} fakturaer. Kontroller år og grunngiving før du viser grunnlaget.",
        "credit_scope": "Opprettar kreditnotaer i Tripletex for valde opne årsavgifter. Betalte fakturaer og refusjonar inngår ikkje. Utvalsregelen «trukket tilbake» ventar på nemnda. Kreditnotaene blir ikkje sende automatisk til mottakaren.",
        "select_invoice": "Vel faktura %{number}",
        "select_page": "Vel opne fakturaer på sida",
        "clear_selection": "Tøm utvalet",
        "invalid_selection": "Vel minst éin faktura frå valt år, innanfor makstalet.",
        "daily": "Opprettingsforsøk i dag: %{used} av %{limit}.",
        "totals": "%{count} postar i grunnlaget. Sum for postar som kan behandlast: %{amount}.",
        "terms": "%{cohort} · %{channel} · Grunnlagsdato %{date} · %{days} dagar til forfall · %{batch} per bunt",
        "progress": "Klare: %{pending} · Under arbeid: %{working} · Fullført: %{succeeded} · Utelatne: %{skipped} · Feila: %{failed}",
        "cohorts": {
          "active": "Aktive meistrar – årsfornying",
          "new_masters": "Nye meistrar",
          "reactivating": "Bortfalne mesterbrev – reaktivering",
          "foreign_address": "Adresse i utlandet",
          "unpaid": "Ikkje betalt – kontroll av eksisterande fakturaer"
        },
        "channels": {
          "email": "E-post",
          "efaktura": "eFaktura",
          "paper": "Papir"
        },
        "states": {
          "preview": "Førehandskontroll",
          "running": "Under arbeid",
          "completed": "Ferdig behandla"
        },
        "items": {
          "pending": "Klar",
          "working": "Under arbeid",
          "succeeded": "Fullført",
          "skipped": "Utelaten",
          "failed": "Feila"
        },
        "results": {
          "selection_exhausted": "Ingen fleire postar i utvalet. Det er ikkje oppretta noko nytt grunnlag.",
          "part_not_finished": "Behandle det gjeldande grunnlaget før du går til neste delutval.",
          "operation_busy": "Ein annan operasjon behandlar denne posten. Oppdater oversikta.",
          "another_run_active": "Ei anna køyring går føre seg. Vent til ho er ferdig.",
          "nothing_to_process": "Ingen postar er klare for behandling.",
          "preview_changed": "Opplysningar eller status er endra sidan kontrollen. Lag eit nytt grunnlag.",
          "amount_changed": "Beløpet er endra sidan kontrollen.",
          "draft_options_changed": "Sendemåten avvik frå den lagra fakturaen.",
          "not_billable": "Personen eller mesterbrevet skal ikkje fakturerast.",
          "already_covered": "Årsavgifta er allereie dekt for perioden.",
          "already_invoiced": "Perioden er allereie fakturert. Ingen ny faktura blir oppretta.",
          "uncertain": "Overføringa må avklarast mot Tripletex.",
          "register_review": "Ventar på kontroll av registeropplysningar.",
          "missing_email": "E-postadresse manglar.",
          "missing_address": "Papirfaktura krev adresse, postnummer, stad og landkode.",
          "not_yet_granted": "Mesterbrevet er ikkje innvilga per fakturadato.",
          "not_creditable": "Fakturaen kan ikkje krediterast i denne køyringa.",
          "blank_reason": "Grunngiving er påkravd.",
          "provider_error": "Tripletex-operasjonen kunne ikkje fullførast. Kontroller fakturaen før omkøyring.",
          "unexpected_error": "Ein feil stoppa posten. Kontroller jobb- og fakturaloggen.",
          "invalid_recovery": "Oppgi gyldig faktura-ID og grunngiving.",
          "not_recoverable": "Denne fakturaen kan ikkje avklarast med denne handlinga.",
          "identity_mismatch": "Kunde, beløp eller referanse i Tripletex samsvarar ikkje med denne fakturaen.",
          "invoice_already_linked": "Tripletex-fakturaen er allereie knytt til ein annan post.",
          "credit_requires_review": "Krediteringsforsøket må kontrollerast i Tripletex.",
          "delivery_requires_confirmation": "Utsending er allereie prøvd. Stadfest resultatet i Tripletex før du fullfører avklaringa.",
          "still_processing": "Køyringa er framleis i kø eller under arbeid. Oppdater status før du prøver å ta henne opp att.",
          "provider_authorization": "Tilgangen til Tripletex vart avvist.",
          "provider_unavailable": "Tripletex er mellombels utilgjengeleg.",
          "provider_rejected": "Tripletex avviste operasjonen."
        }
      },
      "overview": {
        "subtitle": "Fakturaer og førstegongsgebyr samla på éin stad.",
        "search_short": "Søk i oversikta",
        "total": "Oppføringar totalt",
        "all": "Alle fakturaer og nye meistrar",
        "all_statuses": "Alle statusar",
        "search": "Søk etter namn, nummer eller KID"
      },
      "tabs": {
        "waiting": "Nye meistrar",
        "issue": "Ny fakturakøyring",
        "credit": "Kreditering",
        "credit_form": "Kontroller krediteringa",
        "scope": "År og omfang",
        "recipients": "Mottakarar og utsending",
        "waiting_help": "Nye meistrar som ventar på første årsgebyr. Følg opp enkeltfakturaer og avklar overføringar her.",
        "invoices_help": "Alle årsgebyrfakturaer med betalingsstatus og høve til oppfølging.",
        "waiting_header": "Nye meistrar som ventar på første årsgebyr blir fakturerte dagleg. Følg opp fakturaer og avklar overføringar her. Betaling blir kontrollert mot Tripletex kvar kveld.",
        "invoices_header": "Alle årsgebyrfakturaer med betalingsstatus og oppfølging. Nye meistrar blir fakturerte dagleg, og betaling blir kontrollert mot Tripletex kvar kveld.",
        "credit_help": "Vel opne fakturaer som skal krediterast. Utvalet blir halde ved lag når du sorterer eller byter fane. Gå til «Kontroller krediteringa» for å kontrollere grunnlaget.",
        "credit_review_help": "Kontroller år og grunngiving for dei valde fakturaene. Førehandskontrollen opprettar ingen kreditnotaer.",
        "runs_help": "Tidlegare førehandskontrollar og køyringar. Opne ei køyring for å sjå resultat, avvik eller ta opp att arbeidet.",
        "select_loaded": "Vel alle fakturaer",
        "loaded": "Viser %{count} av %{total} oppføringar",
        "loading": "Lastar fleire …",
        "load_more": "Last inn fleire",
        "selected": "%{count} fakturaer valde",
        "no_runs": "Ingen køyringar er oppretta enno.",
        "created": "Oppretta",
        "requested_by": "Oppretta av",
        "started": "Starta",
        "completed": "Ferdig behandla",
        "run_counts": "%{done} fullførte · %{failed} feila",
        "back_runs": "Tilbake til siste køyringar",
        "open_invoices": "Opne fakturaoversikta",
        "run_status": "Status for køyringa",
        "items": "Grunnlag og resultat",
        "details": "Køyringsdetaljar"
      },
      "workflow": {
        "selection": "%{count} av %{total} fakturaer valde for %{year}",
        "invalid_year": "Vel eit gyldig fakturaår.",
        "selection_too_large": "Utvalet overstig grensa på 9999 fakturaer. Vel eit mindre utval manuelt.",
        "limit_exceeded": "%{count} fakturaer er valde, men maksantallet er %{limit}. Reduser utvalet eller auk maksantallet før kontroll.",
        "edit_preview": "Endre grunnlag",
        "empty_title": "Ingen treff i utvalet",
        "empty_body": "Ingen postar samsvarer med utvalsvilkåra. Periodar som allereie er fakturerte eller dekte, kan vere utelatne frå kandidatlista. Endre utvalet og prøv igjen.",
        "completed": "Fullført",
        "completed_errors": "Avslutta med feil",
        "completed_skipped": "Avslutta med utelatne postar",
        "selected_amount": "Beløp i grunnlaget",
        "credited_amount": "Kreditert beløp",
        "transferred_amount": "Overført beløp",
        "failed_amount": "Beløp som feila",
        "last_attempt": "Siste forsøk starta",
        "last_checked": "Status oppdatert",
        "processing": "Køyringa er i kø eller under arbeid. Status blir oppdatert automatisk.",
        "stalled": "Ingen aktivitet er registrert dei siste fem minutta, og ingen jobb behandlar køyringa no. Du kan prøve å ta henne opp att.",
        "credit_delivery": "Oppretta kreditnotaer er ikkje sende automatisk til mottakarane. Følg opp utsending i Tripletex.",
        "guidance": {
          "wait_retry": "Vent litt og oppdater status før du prøver igjen.",
          "contact_admin": "Be systemansvarleg kontrollere tilgangen til Tripletex før omkøyring.",
          "check_provider": "Kontroller fakturaen og referansen i Tripletex. Avklar ei usikker overføring frå fakturaoversikta før omkøyring.",
          "correct_preview": "Kontroller opplysningane på personen og fakturaen. Lag eit nytt grunnlag dersom opplysningane må endrast."
        }
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "God morgon, %{name}",
        "day": "God dag, %{name}",
        "evening": "God kveld, %{name}"
      },
      "title": "Oversikt",
      "openCaseCount": {
        "one": "%{count} open sak",
        "other": "%{count} opne saker"
      },
      "kpi": {
        "openCases": "Mine aktive saker",
        "deadlinesWithin7Days": "Fristar innan 7 dagar",
        "overdueSuffix": "%{count} forfalne",
        "intakeLast30Days": "Nye saker siste 30 dagar",
        "intakeDelta": "%{value} % mot førre periode",
        "avgProcessingTime": "Gjennomsnittleg saksbehandlingstid",
        "placeholder": "—"
      },
      "intakeChart": {
        "title": "Saksinngang",
        "subtitle": "Nye saker per månad siste 12 månader",
        "legend": "Totalt %{count}",
        "months": [
          "jan",
          "feb",
          "mar",
          "apr",
          "mai",
          "jun",
          "jul",
          "aug",
          "sep",
          "okt",
          "nov",
          "des"
        ]
      },
      "distribution": {
        "title": "Fordeling på status",
        "state": {
          "submitted": "Innsendt",
          "under_review": "Under behandling",
          "awaiting_documentation": "Ventar på dokumentasjon",
          "ready_for_decision": "Klar for vedtak",
          "awaiting_board": "Til nemnda",
          "appeal_under_review": "Klage under behandling",
          "open": "Open",
          "in_progress": "Under arbeid"
        }
      },
      "urgentCases": {
        "title": "Saker som hastar",
        "empty": "Ingen saker med nær frist.",
        "emptyHint": "Saker med frist innan sju dagar dukkar opp her.",
        "overdue": "Frist utgått",
        "seeAll": "Sjå alle saker"
      },
      "recentlyAssigned": {
        "title": "Nyleg tildelt meg",
        "empty": "Ingen nyleg tildelte saker.",
        "emptyHint": "Saker som blir tildelte deg, blir viste her."
      },
      "note": {
        "title": "Mine notat",
        "label": "Notat",
        "hint": "Berre du ser dette notatet. Skriv gjerne hugselista di her.",
        "save": "Lagre notat",
        "saved": "Lagra",
        "unsaved": "Ulagra endringar",
        "error": "Klarte ikkje å lagre notatet. Prøv igjen."
      },
      "actions": {
        "newCase": "Ny sak",
        "reports": "Statistikk"
      },
      "breadcrumb": {
        "home": "Heim",
        "overview": "Oversikt"
      }
    },
    "reports": {
      "title": "Nøkkeltal / Statistikk",
      "subtitle": "%{period}",
      "breadcrumb": {
        "home": "Heim",
        "overview": "Nøkkeltal"
      },
      "priorQuarter": "mot førre kvartal",
      "delta": "%{value} %",
      "figure": {
        "new": "Nye meistrar",
        "active": "Aktive meistrar",
        "passive": "Passive meistrar",
        "reactivated": "Reaktiverte meistrar",
        "lapsedRevokedSuffix": "%{count} bortfalne/tilbakekalla"
      },
      "distribution": {
        "title": "Aktive meisterbrev per faggruppe",
        "empty": "Ingen aktive meisterbrev.",
        "share": "%{count} (%{percent} %)"
      },
      "tradeGroup": {
        "byggfag": "Byggfag",
        "mat_og_servicefag": "Mat- og servicefag",
        "designfag": "Designfag",
        "ovrige_handverksfag": "Øvrige handverksfag",
        "unknown": "Ukjend faggruppe"
      }
    },
    "home": {
      "subtitle": "Intern saksbehandlararbeidsflate."
    },
    "nav": {
      "cases": "Saker",
      "register": "Register",
      "internal_users": "Brukarar",
      "profile": "Profil",
      "jobs": "Jobbar",
      "pghero": "Databasehelse",
      "feedback_reports": "Tilbakemeldingar",
      "overview": "Oversikt",
      "case_inbox": "Saksinnboks",
      "my_cases": "Mine saker",
      "due_cases": "Saker med frist",
      "unassigned": "Til tildeling",
      "appeals": "Klagebehandling",
      "sanctions": "Sanksjon og tilbakekall",
      "signing": "Til signering",
      "advance_notices": "Førehandsvarsel",
      "register_people": "Personar",
      "register_companies": "Bedrifter",
      "membership_feed": "Firmatilknytingar",
      "review_tasks": "Til oppfølging",
      "billing": "Fakturering",
      "journal": "Journal og arkiv",
      "journal_overview": "Journal",
      "templates": "Malar",
      "reports": "Rapportar",
      "groups": {
        "cases": "Saksbehandling",
        "register": "Register",
        "economy": "Økonomi",
        "archive": "Arkiv",
        "governance": "Styring",
        "ops": "Drift"
      }
    },
    "changelog": {
      "title": "Kva er nytt",
      "trigger": "Kva er nytt i %{version}",
      "loading": "Hentar endringane …",
      "error": "Klarte ikkje å hente endringane. Prøv igjen.",
      "empty": "Ingen utgjevingar er registrerte enno.",
      "pr_link": "Sjå endring nummer %{number}"
    },
    "feedback_reports": {
      "title": "Tilbakemeldingar",
      "subtitle": "Meldingar frå «Meld feil» på alle tre flatene. Systemet slettar dei automatisk etter %{days} dagar.",
      "filters": {
        "open": "Opne",
        "resolved": "Løyst",
        "dismissed": "Avvist",
        "all": "Alle"
      },
      "empty": "Ingen tilbakemeldingar her.",
      "columns": {
        "created_at": "Motteke",
        "surface": "Flate",
        "category": "Type",
        "reporter": "Meldar",
        "page": "Side",
        "status": "Status"
      },
      "anonymous": "Anonym",
      "screenshot": "Skjermbilete",
      "no_screenshot": "Utan skjermbilete",
      "screenshot_failed": "Kunne ikkje laste skjermbiletet.",
      "user_agent": "Nettlesar",
      "actions": {
        "resolve": "Marker som løyst",
        "dismiss": "Avvis",
        "reopen": "Opne igjen",
        "open": "Opne"
      },
      "update_failed": "Vi fekk ikkje oppdatert statusen. Prøv igjen.",
      "diagnostics": {
        "viewport": "Vindaugsstorleik",
        "errors": "JS-feil",
        "breadcrumbs": "Navigasjon før rapporten"
      }
    },
    "placeholder": {
      "journal_title": "Samla journaloversikt er ikkje tilgjengeleg enno",
      "journal_body": "Du kan sjå journal- og arkivstatus for ei enkelt sak. Opne saka frå Saksinnboks, vel dokumenta og deretter «Journal og arkiv». Den samla oversikta på tvers av saker er under utvikling.",
      "eyebrow": "Kjem",
      "title": "%{destination} er ikkje tilgjengeleg endå",
      "body": "Denne delen av saksbehandlingsløysinga er under utvikling og kjem i ei seinare leveranse.",
      "back": "Tilbake til oversikta"
    },
    "user_menu": {
      "profile": "Min profil",
      "display": "Vising og tema",
      "help": "Hjelp og lovgrunnlag",
      "switch_context": "Byt rolle",
      "switch_context_hint": "Kjem seinare",
      "logout": "Logg ut",
      "aria_label": "Brukarmeny"
    },
    "help": {
      "title": "Hjelp og lovgrunnlag",
      "close": "Lukk",
      "shortcuts_heading": "Snøggtastar",
      "laws_heading": "Lovgrunnlag",
      "support_heading": "Support",
      "shortcut_search": "Opne søk i saker og sider",
      "shortcut_close": "Lukk open dialog eller panel",
      "shortcut_navigate": "Bla i søkjeresultata",
      "shortcut_open": "Opne valt treff",
      "support_body": "Saksbehandlarstøtte: support@mesterbrev.no · 22 00 00 00 (kvardagar 09–15). Lovlenker blir opna på lovdata.no i ny fane.",
      "laws_note": "Blir opna på lovdata.no i ny fane"
    },
    "cases": {
      "v2": {
        "phase4d_discard_draft": "Forkast utkastet og hent siste versjon",
        "phase4d_discard_confirm": "Vil du forkaste utkastet og hente den sist lagra versjonen?",
        "phase4d_conflict_hint": "Utkastet ditt er halde på. Kopier teksten du vil ta vare på, og forkast deretter utkastet for å hente og vurdere siste versjon.",
        "assessment_tools": "Vurderingsval og dokument",
        "requirements_heading": "Dokumentasjonskrav",
        "requirements_hint": "Behandle kvart krav og dokumenta som høyrer til.",
        "request_documentation": "Be om dokumentasjon",
        "add_documentation": "Legg til dokumentasjon",
        "documentation_requirement": "Dokumentasjonskrav",
        "document_category": "Kategori",
        "whole_case": "Heile saka (utan dokumentasjonskrav)",
        "documentation_action_unavailable": "Dokumentasjon kan berre leggjast til medan saka er open.",
        "request_documentation_unavailable": "Nye dokumentasjonskrav kan ikkje opprettast i denne statusen.",
        "show": "Vis",
        "all_requirements": "Alle",
        "active_requirements": "Aktive",
        "sort": "Sorter",
        "newest_first": "Nyaste først",
        "deadline_first": "Frist først",
        "no_requirements": "Ingen krav å vise",
        "requirement": "Dokumentasjonskrav",
        "deadline": "Frist",
        "status": "Status",
        "action": "Handling",
        "no_deadline": "Ingen frist",
        "overdue": "Frist ute",
        "collapse": "Lukk detaljar",
        "open_requirement": "Sjå krav",
        "requested_documentation": "Dette er etterspurt",
        "linked_documents": "Dokument til kravet",
        "no_linked_documents": "Ingen dokument er kopla til dette kravet.",
        "choose_documents": "Kople dokument til kravet",
        "no_documents": "Ingen dokument registrerte.",
        "review_note": "Merknad frå sakshandsamar",
        "requirement_notes": "Interne notat til kravet",
        "new_requirement_note": "Nytt notat til kravet",
        "internal_note_hint": "Internt. Blir ikkje vist til søkjaren.",
        "save_note": "Lagre merknad og koplingar",
        "record_response": "Registrer motteke svar",
        "resolve": "Avklar kravet",
        "supplement": "Be om supplering",
        "cancel_requirement": "Annuller kravet",
        "resolve_hint": "Registrer motteke svar før kravet blir avklart. Avklaringa gjeld berre dette kravet og er ikkje eit vedtak.",
        "requirement_history": "Historikk for kravet",
        "stale_error": "Ein annan har endra opplysningane. Ta vare på teksten din, oppdater sida og samanlikn før du lagrar igjen.",
        "save_error": "Endringa kunne ikkje lagrast. Kontroller opplysningane og prøv igjen. Teksten din er teken vare på.",
        "saved": "Lagra",
        "back": "Tilbake",
        "confirm": "Stadfest",
        "saving": "Lagrar …",
        "confirm_respond": "Registrere motteke svar?",
        "confirm_respond_hint": "Stadfest at svaret er motteke. Kravet vil framleis vente på avklaring frå sakshandsamar.",
        "confirm_resolve": "Avklare dette kravet?",
        "confirm_resolve_hint": "Dette avsluttar berre det valde dokumentasjonskravet. Andre krav og statusen til saka blir ikkje endra.",
        "confirm_supplement": "Be søkjaren om supplering?",
        "confirm_supplement_hint": "Kravet blir opna att. Meldinga og fristen blir viste på Min side, og søkjaren blir varsla gjennom den eksisterande varslingsflyten.",
        "confirm_cancel": "Annullere dette kravet?",
        "confirm_cancel_hint": "Oppgi kvifor dokumentasjonen ikkje lenger er nødvendig. Kravet og historikken blir tekne vare på.",
        "message_to_applicant": "Melding til søkjaren",
        "reason": "Grunngiving",
        "all_documents": "Alle dokument",
        "document": "Dokument",
        "documents": "dokument",
        "preview": "Førehandsvising",
        "select_document": "Vel eit dokument",
        "open_separately": "Opne i ny fane",
        "search_documents": "Søk i dokument",
        "name": "Namn",
        "generated": "Generert",
        "no_documents_found": "Ingen dokument passar søket.",
        "unknown_format": "Ukjent format",
        "sensitive": "Skjerma dokument",
        "download": "Last ned",
        "share": "Del med søkjaren",
        "unshare": "Fjern deling",
        "linked_requirements": "Tilknytte krav",
        "no_linked_requirements": "Dokumentet er ikkje knytt til eit krav.",
        "assessment": "Vurdering",
        "assessment_hint": "Vurderinga er eit utkast. Vedtak vert fatta separat.",
        "new_assessment": "Ny vurdering",
        "continue_assessment": "Hald fram med vurdering",
        "view_assessments": "Sjå vurderingar",
        "finalized": "Ferdigstilt",
        "draft": "Utkast",
        "unsaved": "Ulagra endringar",
        "readonly_assessment": "Ferdigstilt · skriveverna",
        "close_keep_draft": "Lukk",
        "save_draft": "Lagre utkast",
        "finalize": "Ferdigstill vurdering",
        "finalize_confirm": "Er vurderinga klar til å låsast?",
        "finalize_hint": "Grunngiving, konklusjonar og dokumentgrunnlag blir lagra. Vurderinga kan deretter ikkje endrast. Dette fattar ikkje vedtak i saka.",
        "confirm_finalize": "Lagre og ferdigstill",
        "assessment_points": "Vurderingspunkt",
        "overall_assessment": "Samla vurdering",
        "not_assessed": "Ikkje vurdert",
        "points_assessed": "punkt vurderte",
        "no_configured_points": "Denne søknadstypen har ingen konfigurerte vurderingspunkt. Skriv den samla vurderinga nedanfor.",
        "rationale": "Grunngiving",
        "statute": "Vis regelverksgrunnlag",
        "conclusion": "Konklusjon",
        "complete_points": "Alle vurderingspunkt må ha ein konklusjon før ferdigstilling.",
        "select_conclusion_first": "Vel konklusjon før du skriv merknad til punktet.",
        "preview_document": "Dokument som blir vist",
        "leave_draft": "Du har ulagra tekst i saka. Vil du forlate sida og forkaste teksten?",
        "received": "Motteken",
        "nearest_deadline": "Næraste frist",
        "open_requirements": "opne krav",
        "awaiting_applicant": "Ventar på svar frå søkjaren",
        "responses_received": "svar mottekne",
        "needs_review": "Må vurderast av sakshandsamar",
        "assessment_draft": "Vurdering pågår",
        "assessment_completed": "Vurdering ferdigstilt",
        "no_assessment": "Vurdering ikkje starta",
        "continue_hint": "Hald fram der du slapp",
        "assessment_summary_hint": "Sjå vurdering og dokumentgrunnlag",
        "requirements_not_applicable": "Denne sakstypen har ingen dokumentasjonskrav.",
        "application_details": "Søknadsopplysningar",
        "latest_activity": "Siste aktivitet",
        "all_history": "Heile historikken",
        "loading": "Lastar …",
        "load_error": "Kunne ikkje hente opplysningane.",
        "retry": "Prøv igjen",
        "no_activity": "Ingen hendingar registrerte.",
        "work_on_case": "Arbeid med saka",
        "assignee": "Saksansvarleg",
        "reviewer": "Kontrollør",
        "next_step": "Neste steg",
        "next_review_requirements": "Behandle mottekne svar og avklar krava før du går vidare.",
        "next_assessment": "Vurder dokumentasjonen og bruk saksflyten nedanfor for å gå vidare.",
        "internal_notes": "Interne notat",
        "refresh": "Oppdater",
        "load_more": "Vis eldre hendingar",
        "queue_hint": "Opne saka frå innboksen for å bla mellom saker.",
        "previous_case": "Førre sak",
        "next_case": "Neste sak",
        "reopen_case": "Opne saka på nytt",
        "resolve_first": "Avklar eller annuller alle aktive krav før sakshandsaminga vert teken opp att.",
        "statuses": {
          "open": "Open",
          "responded": "Svar motteke",
          "resolved": "Avklart",
          "cancelled": "Annullert"
        },
        "history_fields": {
          "status": "Status",
          "review_note": "Intern merknad",
          "reason": "Melding",
          "due_at": "Frist"
        },
        "document_filters": {
          "all": "Alle",
          "incoming": "Inngåande",
          "generated": "Produsert",
          "unlinked": "Utan kravkopling"
        },
        "archive_status": "Journal og arkivstatus",
        "archive_hint": "Status frå den siste synkroniseringa med arkivet.",
        "archive_error": "Synkronisering feila",
        "archived": "Arkivert",
        "not_archived": "Ikkje arkivert",
        "case_file": "Saksmappe",
        "last_synced": "Sist synkronisert",
        "no_archive_records": "Ingen journalpostar registrerte i arkivet.",
        "journal_number": "Journalnummer",
        "readonly": "Berre lesetilgang",
        "view_response": "Vis svar",
        "response_received_on": "Svar motteke",
        "requirement_created": "Krav sendt til søkjar",
        "response_review_hint": "Svar motteke – må gjennomgåast. Svart betyr ikkje avklart.",
        "file_received_open": "Fil er kopla til kravet. Motteke svar er enno ikkje registrert.",
        "applicant_claims_hint": "Opplysningar frå søkjar",
        "application_basis": "Søknadsgrunnlag",
        "all_application_details": "Vis alle søknadsopplysningar",
        "next_await_response": "Saka ventar på svar frå søkjaren. Du kan førebu vurderinga og følgje opp krava.",
        "next_resume": "Alle krav er handsama. Ta opp att sakshandsaminga for å gå vidare.",
        "next_closed": "Saka er avslutta. Sjå vedtak, dokument og historikk, eller tilgjengelege oppfølgingshandlingar.",
        "next_decided": "Følg opp underretning og klagefrist før saka vert avslutta.",
        "next_decision": "Gå gjennom vedtaksgrunnlaget og signeringa til kontrolløren før vedtaket vert fatta.",
        "next_prepare": "Vurderinga er ferdigstilt. Gå gjennom grunnlaget og klargjer saka for vedtak.",
        "case_progress": "Vidare saksbehandling",
        "other_actions": "Andre handlingar",
        "new_internal_note": "Nytt internt notat",
        "notes_saved": "Ingen ulagra notat",
        "save_internal_note": "Lagre notat",
        "payment_details": "Vis betalingsdetaljar",
        "points_remaining": "vurderingspunkt står att",
        "rationale_required": "Samla grunngjeving manglar",
        "outstanding_requirements": "dokumentasjonskrav er aktive.",
        "can_save_draft": "Du kan lagre vurderinga som utkast.",
        "case_document": "Saksdokument",
        "shared": "Delt med søkjar",
        "requirement_resolved_hint": "Kravet er avklart. Søknaden vert vurdert separat.",
        "requirement_cancelled_hint": "Kravet er annullert. Dokument og historikk er bevarte.",
        "declared_practice": "Sjå oppgitte arbeidsforhold",
        "practice_heading": "Oppgitt praksis",
        "practice_hint": "Periodane er oppgitt av søkjaren. Kontroller datoar og dokumentasjon før praksisen blir vurdert.",
        "practice_period": "Periode",
        "practice_duration": "Varigheit",
        "practice_evidence": "Dokumentasjon",
        "practice_evidence_attached": "Vis vedlegg",
        "practice_evidence_missing": "Ingen kopla attest",
        "practice_leadership": "Leiarpraksis",
        "open_requirement_singular": "ope krav",
        "change_details": "Vis endringsdetaljar",
        "previous_page": "Førre side",
        "next_page": "Neste side",
        "page": "Side",
        "zoom": "Zoom",
        "fit_width": "Tilpass breidd",
        "document_text": "Les teksten på sida",
        "reduce_preview": "Tilbake til arbeidsflata",
        "requirement_events": {
          "open": "Supplering etterspurd",
          "responded": "Svar motteke",
          "resolved": "Krav avklart",
          "cancelled": "Krav annullert",
          "updated": "Merknad eller opplysningar endra"
        },
        "previous_assessments": "Lagra vurderingar",
        "select_saved_assessment": "Vel ei lagra vurdering",
        "create_assessment": "Opprett ny vurdering",
        "continue_new_assessment": "Hald fram med nytt utkast",
        "assessment_kinds": {
          "initial": "Førstegongsvurdering",
          "reconsideration": "Revurdering",
          "appeal_response": "Klagevurdering"
        },
        "review_responses": "Vurder mottekne svar (%{count})",
        "view_open_requirements": "Sjå opne krav (%{count})",
        "blocking_requirements": "Vis krav som blokkerer (%{count})",
        "group_by_document_type": "Grupper etter dokumenttype"
      },
      "title": "Saker",
      "work_modes": {
        "aria_label": "Arbeidsmodus for saksvisinga",
        "classic": "Original",
        "queue": "Kø",
        "split": "Delt skjerm",
        "compact": "Kompakt",
        "viewer": {
          "download": "Last ned",
          "enlarge": "Opne stort",
          "close": "Lukk",
          "prev_doc": "Forrige dokument",
          "next_doc": "Neste dokument",
          "position": "%{index} av %{total}",
          "no_document": "Vel eit dokument i lista",
          "no_preview": "Dokumentet har inga førehandsvising",
          "docx_text_only": "Tekstutdrag frå Word-fila. Formatering, bilete og tabelloppsett blir ikkje viste. Last ned originalen for å kontrollere heile dokumentet."
        },
        "conditions": {
          "title": "Vurdering av vilkår",
          "progress": "%{done} av %{total} vilkår vurderte",
          "source": "Kilde",
          "note_label": "Merknad",
          "note_placeholder": "Skriv ein merknad …",
          "save_failed": "Kunne ikkje lagre vurderinga – prøv igjen.",
          "note_save": "Lagre merknad",
          "empty_title": "Ingen vilkårssjekkliste",
          "empty_body": "Sjekklista for denne sakstypen er ikkje konfigurert enno.",
          "no_round_title": "Inga aktiv vurdering",
          "no_round_body": "Start ei vurderingsrunde med «Ny vurdering» under Handlingar."
        },
        "queue_bar": {
          "position": "Sak %{position} av %{total} i køa",
          "done_next": "Neste sak",
          "keys_hint": "J/K bytt sak · ⌘↵ neste",
          "outside": "Opna utanfor køa",
          "back": "Til saksinnboksen"
        },
        "core_info": {
          "deficiency_fallback": "Etterspurd dokumentasjon",
          "empty": "Inga kjerneinformasjon registrert enno",
          "title": "Kjerneinformasjon",
          "reminder": "purring %{date}",
          "fee_paid": "Behandlingsgebyr: betalt",
          "fee_unpaid": "Behandlingsgebyr: ikkje betalt",
          "fee_credited": "Behandlingsgebyr: kreditert",
          "fee_not_applicable": "Behandlingsgebyr: ikkje aktuelt",
          "trade_certificate": "Fagbrev: %{title}",
          "passed_exam": "Mesterprøve bestått (%{year})",
          "tone_ok": "Oppfylt",
          "tone_warn": "Krev oppfølging",
          "tone_none": "Ikkje aktuelt",
          "basis": "Søknadsgrunnlag",
          "company": "Bedrift",
          "residence": "Bustad",
          "months": "%{months} mnd",
          "decided_at": "Vedtaksdato",
          "precedent": "Prinsipiell sak",
          "precedent_yes": "Ja"
        },
        "practice": {
          "title": "Praksis",
          "months_chip": "%{months} mnd",
          "undated_chip": "Utan datoar",
          "ongoing": "pågår",
          "total_documented": "Dokumentert praksis: %{months} mnd",
          "no_entries": "Ingen praksisoppføringar i søknaden"
        },
        "feed": {
          "journal_tab": "Journal",
          "history_tab": "Historikk",
          "kind_note": "Notat",
          "kind_outgoing": "Utgåande",
          "kind_incoming": "Innkomande",
          "kind_status": "Status",
          "kind_change": "Endring",
          "empty": "Ingen hendingar enno",
          "show_all": "Vis full historikk"
        },
        "next_action": {
          "title": "Neste handling",
          "none": "Inga foreslått handling i denne tilstanden"
        },
        "chrome": {
          "case_position": "Sak %{index} av %{total}",
          "actions_title": "Handlinger",
          "documents_title": "Dokumenter"
        },
        "v2": "V2"
      },
      "new_case": "Ny sak",
      "filter_department": "Vel avdeling",
      "search_placeholder": "Søk på saksnummer, namn …",
      "empty": "Ingen saker i denne lista.",
      "toggle_all_departments": "Alle avdelingar",
      "kinds": {
        "ordinary_grant": "Mesterbrev – utdanning eller innvilga fritak",
        "prior_learning_assessment": "Realkompetansevurdering",
        "equivalent_education_exemption": "Anna utdanning / fritak",
        "foreign_qualification": "Mesterkvalifikasjon frå andre land",
        "special_grounds_dispensation": "Særlege grunnar (dispensasjon)",
        "master_certificate_with_exemption_letter": "Mesterbrev med innvilga fritak",
        "exemption_from_master_education": "Fritak for meisterutdanning"
      },
      "case_types": {
        "application": "Søknad",
        "appeal": "Klage",
        "sanction": "Ulovleg bruk",
        "change": "Endring",
        "access_request": "Innsynskrav"
      },
      "buckets": {
        "new": "Nye",
        "mine": "Mine",
        "all": "Alle",
        "decided": "Avgjorde",
        "written_off": "Henlagde",
        "short_deadline": "Kort frist"
      },
      "states": {
        "draft": "Utkast",
        "submitted": "Innsendt",
        "under_review": "Under behandling",
        "awaiting_documentation": "Ventar på dokumentasjon",
        "ready_for_decision": "Klar for vedtak",
        "awaiting_board": "Til nemnda",
        "decided": "Vedteke",
        "appeal_under_review": "Klage under behandling",
        "appeal_resolved": "Klage avgjort",
        "closed": "Avslutta",
        "withdrawn": "Trekt",
        "awaiting_payment": "Ventar på betaling",
        "written_off": "Avskriven",
        "open": "Open",
        "in_progress": "Under arbeid",
        "awaiting_response": "Ventar på tilbakemelding",
        "response_received": "Tilsvar motteke"
      },
      "next_step": {
        "draft": "Fullfør registrering",
        "submitted": "Start sakshandsaming",
        "under_review": "Vurder og førebu vedtak",
        "awaiting_documentation": "Avventar søkjar",
        "ready_for_decision": "Fatt vedtak",
        "awaiting_board": "Til nemndsbehandling",
        "decided": "Send underretning / avslutt",
        "appeal_under_review": "Behandle klage",
        "appeal_resolved": "Klage behandla",
        "closed": "Ingen vidare handling",
        "withdrawn": "Ingen vidare handling",
        "awaiting_payment": "Avventar betaling",
        "written_off": "Ingen vidare handling",
        "open": "Start sakshandsaming",
        "in_progress": "Under arbeid"
      },
      "markers": {
        "overdue": "Frist utgått",
        "overdue_count": "%{count} forfalne",
        "flagged": "Redigert av annan saksbehandlar",
        "flagged_by": "Redigert av %{name}",
        "flagged_helptext": "Samarbeidssignal, ikkje habilitet (fvl §6). Ingen automatisk verknad på vedtaket.",
        "changed": "Endringar sidan sist",
        "changed_helptext": "Saka er endra etter at du sist opna henne. Nye saker du aldri har opna er ikkje merkte.",
        "reviewer": "Kontrollør",
        "party_person": "Person",
        "party_company": "Bedrift"
      },
      "deadline": {
        "overdue": "Forfalt %{date}",
        "today": "I dag",
        "soon": "Om %{days} d · %{date}"
      },
      "unassigned": "Ikkje tildelt",
      "empty_filtered": "Ingen treff med valde filter.",
      "empty_reset": "Nullstill filter",
      "overview_feedback": {
        "shown": "%{count} saker viste",
        "load_more": "Last fleire saker",
        "loading": "Lastar fleire saker…",
        "load_error": "Kunne ikkje laste fleire saker. Prøv igjen.",
        "retry": "Prøv igjen",
        "bulk_error": "Kunne ikkje stadfeste oppdateringa. Utvalet er halde på; prøv igjen.",
        "copy_error": "Kunne ikkje kopiere saks-ID.",
        "validation_summary": "Kontroller saksopplysningane",
        "missing_slug": "Serveren returnerte ingen saksreferanse. Saka kan ha blitt oppretta. Oppdater innboksen før du prøver igjen."
      },
      "filters": {
        "status": "Status",
        "case_type": "Sakstype",
        "kind": "Søknadstype",
        "trade": "Fag",
        "assignee": "Saksbehandlar",
        "period": "Periode",
        "all": "Alle",
        "unassigned": "Ikkje tildelt",
        "period_7d": "Siste 7 dagar",
        "period_30d": "Siste 30 dagar",
        "period_90d": "Siste 90 dagar",
        "period_all": "Heile perioden",
        "active_count": "%{count} aktive",
        "reset": "Nullstill",
        "label": "Filter"
      },
      "views": {
        "label": "Vising",
        "table": "Tabell",
        "kanban": "Kanban",
        "cards": "Kort",
        "kanban_columns": {
          "intake": "Ny / tildelt",
          "in_progress": "Under behandling",
          "awaiting": "Avventar",
          "ready": "Klar for vedtak",
          "done": "Avslutta"
        }
      },
      "bulk": {
        "selected_count": {
          "one": "%{count} vald",
          "other": "%{count} valde"
        },
        "clear": "Nullstill val",
        "assign": "Tildel",
        "assign_to": "Tildel valde til",
        "unassign": "Fjern tildeling",
        "status": "Endre status",
        "status_to": "Set status",
        "archive": "Arkiver",
        "archive_disabled_hint": "Arkivering er ikkje tilgjengeleg endå",
        "result": {
          "one": "%{succeeded} oppdatert",
          "other": "%{succeeded} oppdaterte"
        },
        "result_with_skipped": "%{succeeded} oppdaterte, %{skipped} hoppa over",
        "skipped_reason": {
          "not_found": "Fann ikkje saka",
          "invalid_transition": "Ugyldig statusovergang",
          "guard_failed": "Vilkår ikkje oppfylt",
          "forbidden": "Ingen tilgang",
          "error": "Kunne ikkje oppdatere"
        }
      },
      "export": {
        "button": "Eksporter",
        "hint": "Last ned synlege saker som CSV"
      },
      "row_menu": {
        "actions": "Handlingar",
        "open": "Opne sak",
        "copy_id": "Kopier saks-ID",
        "copy_id_done": "Kopierte %{slug}",
        "assign_to_me": "Tildel til meg",
        "assign_to_me_done": "Sak %{slug} tildelt deg",
        "assign_to_me_error": "Kunne ikkje tildele sak %{slug}",
        "archive": "Arkiver sak",
        "archive_disabled_hint": "Arkivering er ikkje tilgjengeleg endå"
      },
      "columns": {
        "case_number": "Saksnummer",
        "case": "Sak",
        "title": "Tittel",
        "applicant": "Søkjar",
        "party": "Part",
        "trade": "Fag",
        "kind": "Type",
        "state": "Status",
        "assignee": "Saksbehandlar",
        "reviewer": "Kontrollør",
        "deficiencies": "Manglar",
        "deadline": "Frist / oppfølging",
        "department": "Avdeling",
        "date": "Oppdatert"
      },
      "claims": {
        "title": "Søknadsopplysningar",
        "groups": {
          "personalia": "Personalia",
          "trade": "Fag",
          "education": "Utdanning",
          "practice": "Praksis",
          "other_documentation": "Anna dokumentasjon"
        },
        "address_from_registry": "Adresse frå Folkeregisteret",
        "contact_from_registry": "Kontakt frå ID-porten",
        "contact_email": "E-post oppgitt i søknaden",
        "contact_mobile_number": "Telefon oppgitt i søknaden",
        "third_party_verification_consent": "Samtykke til kontroll hos tredjepart",
        "value_yes": "Ja",
        "value_no": "Nei",
        "trade_name": "Fag",
        "trade_certificate_title": "Tittelen på fag-/sveinebrevet",
        "passed_exam_date": "Dato for bestått prøve",
        "practice": {
          "type": "Type",
          "employer": "Arbeidsstad / bedrift",
          "years": "Periode",
          "type_employed": "Tilsett",
          "type_self_employed": "Sjølvstendig",
          "implausible_years": "Kontroller årstala"
        },
        "empty": "Ingen strukturerte søknadsopplysningar (manuelt registrert sak)"
      },
      "show": {
        "title": "Sak %{slug}",
        "nav": {
          "prev": "Førre sak",
          "next": "Neste sak"
        },
        "action_gate": {
          "needs_finalized_assessment": "Fullfør ei vurdering for å gå vidare",
          "needs_ready": "Saka må vere klar for vedtak",
          "unavailable": "Handlinga er ikkje tilgjengeleg i denne tilstanden",
          "needs_notification": "Registrer underretning før saka kan avsluttast",
          "appeal_window_running": "Klagefristen går ut %{date} — saka kan avsluttast etter det"
        },
        "case_details": "Saksopplysningar",
        "applicant_label": "Søkjar",
        "trade_label": "Fag",
        "kind_label": "Søknadstype",
        "state_label": "Status",
        "submitted_at_label": "Innsendt",
        "intake_channel_label": "Kanal",
        "manual_intake_by": "Manuelt registrert av %{name}",
        "precedent_setting_label": "Presedenssak",
        "precedent_setting_yes": "Ja",
        "precedent_setting_no": "Nei",
        "assessments_heading": "Vurderingar",
        "no_assessments": "Ingen vurderingar registrerte.",
        "decision_heading": "Vedtak",
        "no_decision": "Ikkje vedteke endå.",
        "documents_heading": "Dokument",
        "no_documents": "Ingen dokument lasta opp.",
        "transitions_heading": "Handlingar",
        "outcomes": {
          "granted": "Innvilga",
          "partially_granted": "Delvis innvilga",
          "denied": "Avslått",
          "returned": "Returnert",
          "written_off": "Lagt vekk",
          "upheld": "Stadfesta",
          "overturned": "Omgjort",
          "partially_upheld": "Delvis stadfesta"
        },
        "decided_by_body": {
          "secretariat": "Sekretariatet",
          "board": "Nemnda",
          "appeals_board": "Klagenemnda"
        },
        "transitions": {
          "pick_up": "Start sakshandsaming",
          "request_documentation": "Be om dokumentasjon",
          "documentation_received": "Ta opp att sakshandsaminga",
          "prepare_decision": "Klargjer for vedtak",
          "refer_to_board": "Send til nemnda",
          "decide": "Gjer vedtak",
          "close": "Avslutt sak",
          "notify": "Registrer underretning",
          "withdraw": "Trekk søknad",
          "file_appeal": "Registrer klage",
          "appeal_resolved": "Registrer klageutfall",
          "start": "Start behandling",
          "write_off": "Avskriv saka",
          "reopen": "Gi ny sjanse",
          "send_advance_notice": "Send førehandsvarsel"
        },
        "send_notification": {
          "phase4d_queued": "Varslet er lagt i kø. Du kan følgje statusen i kommunikasjonshistorikken.",
          "title": "Send varsel",
          "template_label": "Mal",
          "template_placeholder": "Vel ein mal",
          "channel_override_label": "Send via",
          "channel_override_default": "Standard (mottakars preferanse)",
          "channel_override_email": "E-post",
          "channel_override_sms": "SMS",
          "send_button": "Send",
          "sent": "Varsel sendt",
          "no_templates": "Ingen standardsvar tilgjengeleg for denne saka.",
          "preview_button": "Førehandsvis",
          "preview_subject_label": "Emne",
          "preview_body_label": "Innhald"
        },
        "write_off_form": {
          "heading": "Avskriv saka",
          "reason_label": "Grunngjeving for avskriving",
          "submit": "Avskriv saka",
          "confirm": "Er du sikker på at du vil avskrive saka?"
        },
        "assessment_form": {
          "heading": "Ny vurdering",
          "kind_label": "Vurderingstype",
          "outcome_label": "Tilrådd utfall",
          "outcome_placeholder": "Vel utfall",
          "rationale_label": "Grunngjeving",
          "rationale_placeholder": "Skriv vurdering …",
          "facts_snapshot_label": "Faktum (JSON)",
          "submit": "Lagre vurdering",
          "kinds": {
            "initial": "Første vurdering",
            "reconsideration": "Ny vurdering",
            "appeal_response": "Klagevurdering"
          }
        },
        "decision_form": {
          "heading": "Gjer vedtak",
          "outcome_label": "Utfall",
          "outcome_placeholder": "Vel utfall",
          "rationale_label": "Grunngjeving",
          "rationale_placeholder": "Grunngjeving for vedtaket (fvl §§24–25) …",
          "legal_basis_label": "Heimel",
          "legal_basis_placeholder": "t.d. meisterbrevlova §2",
          "legal_basis_hint": "Oppgi heimelen vedtaket byggjer på (fvl §25), t.d. meisterbrevlova §2 jf. forskrift om vilkår for å få mesterbrev §2",
          "decided_by_body_label": "Vedtaksorgan",
          "decided_by_body_placeholder": "Vel organ",
          "cited_assessment_ids_label": "Siterte vurderingar",
          "submit": "Gjer vedtak"
        },
        "notify_form": {
          "heading": "Registrer underretning",
          "notified_at_label": "Underretningsdato",
          "submit": "Lagre underretning"
        },
        "assignment_form": {
          "heading": "Tildeling",
          "save_error": "Kunne ikkje lagre tildelinga",
          "assignee_label": "Saksbehandlar",
          "assignee_placeholder": "Vel saksbehandlar",
          "clear_assignee": "Fjern tildeling",
          "save_assignee": "Lagre tildeling",
          "edit_assignee": "Endre",
          "assign_assignee": "Tildel",
          "assign_me": "Tildel meg",
          "reviewer_heading": "Kontrollør",
          "reviewer_label": "Kontrollør",
          "reviewer_placeholder": "Vel kontrollør",
          "clear_reviewer": "Fjern kontrollør",
          "save_reviewer": "Lagre kontrollør",
          "sign_off_heading": "Signering",
          "sign_off_label": "Kontroll registrert",
          "sign_off_button": "Registrer signering",
          "no_reviewer": "Ikkje tildelt",
          "no_assignee": "Ikkje tildelt",
          "no_sign_off_notice": "Ingen kontrollør har signert. Vedtaket kan likevel gjerast."
        },
        "deficiencies": {
          "heading": "Manglar",
          "legal_anchor": "Heimel: forvaltningslova §17 (utgreiings- og informasjonsplikt)",
          "empty": "Ingen manglar registrert.",
          "awaiting_empty": "Saka ventar på dokumentasjon – ingen manglar er registrerte endå.",
          "overdue_marker": "Frist utløpt",
          "due_at_label": "Frist",
          "no_due_at": "Ingen frist",
          "responded_at_label": "Svart",
          "resolved_at_label": "Løyst",
          "requested_by_label": "Registrert av",
          "respond_button": "Registrer svar",
          "cancel_button": "Trekk mangel",
          "statuses": {
            "open": "Open",
            "responded": "Svart",
            "resolved": "Løyst",
            "cancelled": "Trekt"
          },
          "document_kinds_label": "Dokument",
          "columns": {
            "summary": "Mangel",
            "status": "Status",
            "actions": "Handlingar"
          }
        },
        "communication_history": {
          "unknown_template": "Varsel",
          "event_labels": {
            "case": {
              "submitted": "Søknad motteken",
              "documentation_requested": "Dokumentasjon etterspurd",
              "decided": "Underretning om vedtak"
            },
            "document": {
              "shared": "Dokument delt med søkjaren"
            },
            "mastership": {
              "granted": "Meisterbrev tildelt",
              "lapsed": "Meisterbrev falle bort"
            }
          },
          "heading": "Varsel sendt",
          "empty": "Ingen varsel sendt.",
          "created_at_label": "Oppretta:",
          "sent_at_label": "Sendt:",
          "delivered_at_label": "Levert:",
          "columns": {
            "template": "Mal",
            "channel": "Kanal",
            "status": "Status",
            "legal_basis": "Heimel",
            "timestamps": "Tidspunkt"
          },
          "channels": {
            "in_app": "I appen",
            "email": "E-post",
            "sms": "SMS"
          },
          "statuses": {
            "queued": "I kø",
            "sent": "Sendt",
            "delivered": "Levert",
            "failed": "Feila",
            "routed_paper": "Ruta til papir"
          },
          "paper_reasons": {
            "reserved": "Mottakar reservert mot elektronisk kommunikasjon",
            "missing_contact": "Manglar gyldig kontaktinformasjon",
            "inactive": "Mottakarkonto er ikkje aktiv",
            "not_notifiable": "Kontaktkanal ikkje gyldig i KRR"
          }
        },
        "deficiency_form": {
          "heading": "Registrer mangel",
          "delivery_hint": "Registrering sender varsel til søkjaren. For å dele sjølve PDF-brevet må du opne mangelen og velje «Opprett brev og del på Min side».",
          "document_kinds_label": "Dokument som manglar",
          "document_kinds_hint": "Kryss av for dokumenta søkjaren må sende inn.",
          "summary_label": "Kort skildring/Overskrift",
          "summary_help": "Ei kort skildring av mangelen. Teksten blir òg brukt som overskrift for førespurnaden. Døme: «Praksisattest med stillingsprosent».",
          "summary_placeholder": "Skildre det som ikkje står i lista over",
          "nothing_named": "Vel minst eitt dokument, eller skildre kva som manglar.",
          "reason_label": "Melding til søkjar",
          "reason_help": "Den utfyllande meldinga: kva som er utilstrekkeleg, og kva søkjaren må sende inn. Døme: «Attesten du har sendt inn, oppgir ikkje stillingsprosent. Last opp ein ny attest der arbeidsgjevaren stadfestar dette.»",
          "reason_placeholder": "Detaljert melding til søkjaren …",
          "due_at_label": "Frist",
          "submit": "Registrer mangel"
        },
        "state_context": {
          "ready_heading": "Vurderingsgrunnlag",
          "no_finalized": "Ingen ferdigstilte vurderingar enno."
        },
        "tabs": {
          "oversikt": "Oversikt",
          "saksflyt": "Saksflyt",
          "dokumenter": "Dokument",
          "vedtak": "Vedtak",
          "historikk": "Historikk",
          "parter": "Partar & roller",
          "journal": "Journal"
        },
        "open_flow": "Opne saksflyt",
        "resize_left": "Endre breidda på venstre kolonne",
        "resize_right": "Endre breidda på høgre kolonne",
        "summary_heading": "Saksdetaljar",
        "company_heading": "Føretak",
        "case_type_label": "Sakstype",
        "created_at_label": "Oppretta",
        "updated_at_label": "Sist endra",
        "company_name_label": "Namn",
        "company_orgnr_label": "Org.nr",
        "company_status_label": "Status",
        "company_status_active": "Aktiv (Brreg)",
        "no_company": "Ingen føretak knytt til saka",
        "quick_actions_heading": "Snøgghandlingar",
        "vilkaar_heading": "Vilkårsvurdering",
        "document_meta_heading": "Dokumentdetaljar",
        "document_filename_label": "Filnamn",
        "document_kind_label": "Type",
        "document_state_label": "Status",
        "document_classification_label": "Gradering",
        "document_source_label": "Kjelde",
        "document_received_label": "Motteke",
        "select_document": "Vel eit dokument for å sjå detaljar.",
        "classifications": {
          "ordinary": "Ordinær",
          "sensitive": "Sensitiv (jf. fvl §13)"
        },
        "parties_heading": "Partar i saka",
        "applicant_role": "Søkjar",
        "company_role": "Føretak",
        "history_heading": "Saksforløp",
        "history_load_more": "Vis fleire",
        "history_empty": "Ingen hendingar registrerte endå.",
        "history_loading": "Lastar saksforløp …",
        "comments": {
          "title": "Interne notat",
          "add_placeholder": "Skriv eit internt notat …",
          "submit": "Legg til",
          "empty": "Ingen interne notat på denne saka enno.",
          "author_at": "%{author} · %{date}",
          "toast": {
            "added": "Notat lagt til.",
            "error": "Noko gjekk gale. Prøv igjen."
          },
          "errors": {
            "blank": "Notatet kan ikkje vere tomt."
          }
        }
      },
      "payment": {
        "heading": "Behandlingsgebyr",
        "amount_label": "Beløp",
        "status_label": "Status",
        "not_applicable": "Ikkje aktuelt",
        "statuses": {
          "unpaid": "Ubetalt",
          "paid": "Betalt",
          "credited": "Kreditert"
        },
        "references": {
          "transaction_id": "Transaksjons-id",
          "kid": "KID",
          "invoice_id": "Faktura-id"
        },
        "captured_at_label": "Betalt",
        "credited_at_label": "Kreditert"
      },
      "work_surface": {
        "preview": {
          "select": "Vel eit dokument",
          "enlarge": "Forstørr",
          "none": "Inga førehandsvising",
          "download": "Last ned",
          "unavailable": "Førehandsvising ikkje tilgjengeleg"
        },
        "confirm": {
          "title": "Stadfest handling",
          "body": "Vil du utføre denne handlinga?",
          "cancel": "Avbryt",
          "confirm": "Stadfest",
          "bodies": {
            "pick_up": "Sakshandsaminga startar, og saka blir tildelt deg. Dette blir registrert i historikken.",
            "prepare_decision": "Du kan ikkje vurdere saka meir etter dette. Saka går vidare til vedtak — gjer eventuelle endringar no.",
            "documentation_received": "Når du stadfestar, blir dette registrert:",
            "close": "Saka blir avslutta og arkivert. Klagefristen må ha gått ut (fvl §29).",
            "notify": "Du registrerer underretninga no, og klagefristen på tre veker blir rekna frå denne datoen (fvl §27 og §29). Etter §29 går fristen frå underretninga kom fram til parten.",
            "withdraw": "Saka blir avslutta som trekt. Eit innbetalt behandlingsgebyr blir ikkje refundert."
          },
          "details": {
            "documentation_received": {
              "case_state": "Saka blir flytta frå «Ventar på dokumentasjon» til «Under handsaming».",
              "resolve_deficiency": "Dokumentasjonsmangelen «%{name}» blir merkt som løyst.",
              "history": "Handlinga blir registrert i sakshistorikken."
            }
          }
        },
        "reference": {
          "menu_label": "Meir"
        },
        "pickup": {
          "heading": "Start sakshandsaming",
          "body": "Saka er send inn. Du kan starte sakshandsaminga eller be om dokumentasjon først."
        },
        "under_review": {
          "docs_heading": "Dokument",
          "checklist_heading": "Vilkårsvurdering"
        },
        "awaiting_documentation": {
          "heading": "Ventar på dokumentasjon"
        },
        "decision": {
          "heading": "Vedtak",
          "awaiting_board": "Saka er sendt til nemnda og ventar på handsaming."
        },
        "decided": {
          "heading": "Vedteke",
          "klagefrist": "Klagefrist",
          "notify_hint": "Underretning etter forvaltningslova §27 — startar klagefristen på 3 veker",
          "notified_at": "Underretta",
          "not_notified": "Ikkje underretta enno"
        },
        "appeal": {
          "heading": "Klagehandsaming"
        },
        "closed": {
          "heading": "Avslutta sak"
        },
        "baseline": {
          "heading": "Sakshandsaming"
        },
        "document_groups": {
          "practice_documentation": "Praksis",
          "education_documentation": "Utdanning",
          "correspondence_documentation": "Korrespondanse",
          "system_generated": "Generert",
          "other": "Andre dokument"
        },
        "doc_actions": {
          "open": "Opne",
          "enlarge": "Forstørr",
          "download": "Last ned",
          "share": "Del med søkjar",
          "unshare": "Fjern deling",
          "shared_badge": "Delt med søkjar"
        },
        "unknown_state": "Ukjend status — viser berre oppsummering."
      },
      "placeholders": {
        "not_applicable": "Ikkje aktuelt for denne sakstypen.",
        "saksflyt_viz": {
          "title": "Interaktiv saksflyt kjem seinare",
          "body": "Den fulle tilstandsmaskina med gyldige overgangar og guards blir bygd i ei seinare leveranse. Tilgjengelege handlingar blir viste til venstre."
        },
        "ai_assist": {
          "title": "KI-assistanse kjem seinare",
          "body": "Automatisk forslag til vurdering og vedtaksutkast er planlagt, men ikkje aktivt endå."
        },
        "journal_tab": {
          "title": "Journal kjem seinare",
          "body": "Journalføring mot arkivet (Documaster/Noark) er ikkje kopla på endå."
        },
        "internal_notes": {
          "title": "Interne notat",
          "body": "Ingen interne notat på denne saka endå."
        },
        "access_history": {
          "title": "Tilgangshistorikk kjem seinare",
          "body": "Oversikt over kven som har sett saka blir bygd i ei seinare leveranse."
        }
      },
      "intake": {
        "title": "Ny sak",
        "subtitle": "Registrer ein papir- eller realkompetansesøknad på vegner av søkjaren.",
        "breadcrumb_cases": "Saker",
        "breadcrumb_new": "Ny sak",
        "applicant_heading": "Søkjar",
        "full_name_label": "Namn",
        "full_name_hint": "Påkravd. Oppgi det fulle namnet til søkjaren.",
        "email_label": "E-post",
        "email_hint": "Valfritt. Vert brukt for å finne ein eksisterande søkjar.",
        "national_id_label": "Fødselsnummer",
        "national_id_hint": "Valfritt. Vi bruker nummeret til oppslag i Folkeregisteret. Vi lagrar det kryptert, viser det skjult og loggar kvar visning.",
        "national_id_invalid": "Oppgi eit gyldig fødselsnummer med 11 siffer, eller la feltet stå tomt.",
        "freg_lookup_button": "Hent frå folkeregister",
        "freg_no_match": "Ingen treff i folkeregisteret. Hald fram med oppgjevne opplysningar.",
        "freg_error": "Kunne ikkje hente opplysningar frå Folkeregisteret. Prøv igjen eller hald fram med oppgjevne opplysningar.",
        "error_summary": "Kontroller opplysningane",
        "general_error_label": "Saka kunne ikkje opprettast",
        "case_heading": "Sak",
        "trade_label": "Fag",
        "trade_placeholder": "Vel fag",
        "kind_label": "Søknadstype",
        "notes_label": "Notat",
        "notes_placeholder": "Interne notat, t.d. «Papirsøknad motteke 2026-06-10».",
        "submit": "Opprett sak",
        "cancel": "Avbryt",
        "case_type_label": "Sakstype",
        "basis_label": "Søknadsgrunnlag",
        "party_type_label": "Part",
        "party_person": "Person",
        "party_company": "Bedrift",
        "name_label_person": "Namn på søkjar",
        "name_label_company": "Føretaksnamn",
        "name_too_short": "Oppgi namn på parten.",
        "org_number_label": "Org.nr",
        "org_number_hint": "9 siffer. Vert verifisert mot Einingsregisteret ved innsending.",
        "org_number_invalid": "Org.nr må vere 9 siffer.",
        "assignee_label": "Tildel saksbehandlar",
        "assignee_placeholder": "Til tildeling",
        "note_label": "Intern merknad",
        "note_optional": "valfritt",
        "note_placeholder": "Kort notat om saka …",
        "deadline_label": "Behandlingsfrist",
        "deadline_preset_3w": "3 veker",
        "deadline_preset_6w": "6 veker",
        "deadline_preset_3m": "3 mnd",
        "deadline_due": "Forfell %{date}",
        "errors": {
          "forbidden": "Du har ikkje tilgang til å opprette saker.",
          "invalid_case_type": "Ugyldig sakstype.",
          "missing_party_identity": "Oppgi namn på parten.",
          "missing_organization_number": "Org.nr er påkravd for bedrift.",
          "invalid_organization_number": "Skriv eit gyldig organisasjonsnummer. Kontroller sifra og prøv igjen.",
          "company_not_found": "Fann ikkje føretaket i Einingsregisteret.",
          "validation_failed": "Kunne ikkje opprette saka. Kontroller felta.",
          "generic": "Noko gjekk gale. Prøv igjen."
        }
      }
    },
    "internal_users": {
      "validation": {
        "summary": "Kontroller opplysningane",
        "name_required": "Oppgi namn.",
        "email_required": "Oppgi e-postadresse.",
        "email_taken": "E-postadressa er allereie i bruk.",
        "role_invalid": "Vel ei gyldig rolle.",
        "department_invalid": "Vel ei gyldig avdeling."
      },
      "title": "Brukarar",
      "new_user": "Ny brukar",
      "empty": "Ingen interne brukarar endå.",
      "columns": {
        "name": "Namn",
        "email": "E-post",
        "role": "Rolle",
        "department": "Avdeling",
        "active": "Status",
        "actions": "Handlingar"
      },
      "active_yes": "Aktiv",
      "active_no": "Inaktiv",
      "activate": "Aktiver",
      "deactivate": "Deaktiver",
      "deactivate_self_disabled": "Du kan ikkje deaktivere din eigen konto.",
      "deactivate_last_admin_disabled": "Kan ikkje deaktivere den siste aktive administratoren.",
      "modal": {
        "create_title": "Ny brukar",
        "edit_title": "Rediger brukar",
        "name": "Namn",
        "email": "E-post",
        "role": "Rolle",
        "department": "Avdeling",
        "department_none": "Inga avdeling",
        "save": "Lagre",
        "cancel": "Avbryt"
      },
      "toast": {
        "created": "Brukar oppretta.",
        "updated": "Brukar oppdatert.",
        "activated": "Brukar aktivert.",
        "deactivated": "Brukar deaktivert.",
        "error": "Noko gjekk gale. Prøv igjen."
      }
    },
    "register": {
      "people": {
        "title": "Personregister",
        "search_placeholder": "Søk på namn eller e-post …",
        "filter_municipality": "Kommune",
        "filter_status": "Status",
        "filter_all": "Alle",
        "filter_has_mastership": "Meisterbrev",
        "filter_trade": "Fag",
        "filter_caseworker": "Saksbehandlar",
        "filter_passive_reason": "Passiv-årsak",
        "has_mastership": {
          "all": "Alle",
          "yes": "Har meisterbrev",
          "no": "Utan meisterbrev"
        },
        "status": {
          "all": "Alle",
          "active": "Aktive",
          "passive": "Passive",
          "opted_out": "Reservert mot oppføring"
        },
        "empty": "Ingen personar funne.",
        "result_count": "Viser %{shown} av %{total}",
        "load_more": "Vis fleire",
        "paging_error": "Vi kunne ikkje laste fleire personar. Prøv igjen.",
        "paging_retry": "Prøv igjen",
        "columns": {
          "name": "Namn",
          "email": "E-post",
          "municipality": "Kommune",
          "masterships": "Meisterbrev",
          "status": "Status"
        },
        "badge": {
          "passive": "Passiv",
          "opted_out": "Reservert"
        },
        "visibility": {
          "listed": "Synleg i register",
          "hidden": "Skjult"
        },
        "view": {
          "table": "Tabell",
          "cards": "Kort"
        },
        "tabs": {
          "overview": "Oversikt",
          "masterships": "Meisterbrev",
          "cases": "Saker",
          "history": "Historikk",
          "comments": "Kommentarar",
          "communication": "Kommunikasjon",
          "company_memberships": "Bedriftstilknyting",
          "invoices": "Fakturaer"
        },
        "cases": {
          "empty": "Ingen saker registrert på denne personen.",
          "columns": {
            "case_number": "Saksnr.",
            "type": "Type",
            "trade": "Fag",
            "state": "Status",
            "date": "Registrert",
            "assigned_to": "Saksbehandlar"
          },
          "unassigned": "Ikkje tildelt"
        },
        "company_memberships": {
          "empty": "Ingen bedriftstilknytingar registrerte på denne personen.",
          "ongoing": "Laupande",
          "status_active": "Aktiv",
          "status_ended": "Avslutta",
          "status_revoked": "Trekt tilbake",
          "columns": {
            "company": "Bedrift",
            "trade": "Fag",
            "role": "Rolle",
            "position_percent": "Stillingsdel",
            "period": "Periode",
            "status": "Status"
          }
        },
        "comments_stub": "Kommentarar kjem i ei seinare leveranse.",
        "register_sourced": {
          "notice": "Henta frå Folkeregisteret — kan ikkje endrast her.",
          "legal_name": "Juridisk namn",
          "address": "Adresse",
          "birth_date": "Fødselsdato",
          "deceased": "Død",
          "unavailable": "Ikkje tilgjengeleg"
        },
        "fields": {
          "email": "E-post",
          "gender": "Kjønn",
          "reference_number": "Referansenummer",
          "municipality": "Kommune",
          "passive_reason": "Passiv-årsak",
          "passivated_at": "Passivert",
          "comments_count": "Tal på kommentarar"
        },
        "national_id": {
          "label": "Fødselsnummer",
          "unknown": "Ikkje registrert",
          "reveal": "Vis",
          "copy": "Kopier",
          "hide": "Skjul",
          "copied": "Kopiert til utklippstavla",
          "error": "Klarte ikkje å hente fødselsnummeret"
        },
        "masterships": {
          "empty": "Ingen meisterbrev registrert.",
          "trade": "Fag",
          "trade_group": "Fagområde",
          "state": "Status",
          "svennebrev": "Svennebrev",
          "granted_at": "Innvilga",
          "mesterbrev_sent_at": "Meisterbrev sendt",
          "lapsed_at": "Bortfalle",
          "revoked_at": "Tilbakekalla",
          "fee_paid_through": "Avgift betalt til",
          "arsgebyr": {
            "label": "Årsgebyr",
            "issue": "Send årsgebyr-faktura",
            "credit": "Krediter faktura",
            "credit_prompt": "Oppgi årsak til kreditering:",
            "latest_invoice": "Siste faktura",
            "demand": "Påkrav sendt",
            "demand_channel": {
              "registered_mail": "rekommandert brev",
              "secure_electronic": "sikker elektronisk kanal"
            },
            "status": {
              "paid": "Betalt",
              "invoiced": "Fakturert",
              "overdue": "Forfalen",
              "lapsed": "Bortfalen",
              "none": "Ikkje fakturert"
            },
            "toast": {
              "issued": "Årsgebyr fakturert",
              "credited": "Faktura kreditert",
              "error": "Klarte ikkje å fakturere årsgebyr"
            }
          }
        },
        "history": {
          "empty": "Ingen hendingar registrert.",
          "loading": "Lastar historikk …",
          "load_more": "Last fleire",
          "from_case": "Sak %{reference}"
        },
        "scheduled_notice": "Planlagt passivering %{date}",
        "invoices": {
          "original_invoice": "Gjeld faktura",
          "credited_at": "Kreditert dato",
          "help": "Årsgebyr, behandlingsgebyr og kreditnotaer registrerte på personen, på tvers av fag og år. Kreditnotaer blir viste med negativt beløp og kan søkjast opp med kreditnota-ID. Leverandørlenkjene opnar portalen der du kan slå opp den viste referansen.",
          "kind": "Type",
          "all": "Alle oppføringar",
          "reference": "Fakturanummer / betalingsreferanse",
          "search_label": "Søk på fakturanummer, KID eller betalingsreferanse",
          "search": "Søk",
          "reset": "Nullstill",
          "paid_at": "Betalt dato",
          "manual": "Manuelt registrert",
          "tripletex": "Tripletex",
          "nexi": "Nexi",
          "attention": "Treng oppfølging",
          "empty": "Ingen fakturaer eller betalingar i dette utvalet",
          "loading": "Lastar fakturahistorikk …",
          "load_more": "Last inn fleire",
          "retry": "Prøv igjen",
          "error": "Kunne ikkje hente fakturahistorikken. Prøv igjen.",
          "count": "Viser %{count} av %{total} oppføringar",
          "kinds": {
            "credit_note": "Kreditnota",
            "annual_fee": "Årsgebyr",
            "processing_fee": "Behandlingsgebyr"
          },
          "statuses": {
            "draft": "Utkast",
            "sent": "Sendt – ikkje betalt",
            "paid": "Betalt",
            "credited": "Kreditert",
            "awaiting_payment": "Ventar på betaling",
            "refunded": "Tilbakebetalt"
          }
        }
      },
      "passivation": {
        "title": "Passivering",
        "set_passive": "Set passiv",
        "reactivate": "Reaktiver",
        "reason_label": "Årsak",
        "reason_placeholder": "Vel årsak …",
        "current_passive": "Passiv",
        "current_active": "Aktiv",
        "scheduled_overdue": "Planlagt passivering %{date} — fristen har gått ut",
        "schedule": "Planlegg passivering",
        "reschedule": "Endre",
        "cancel_schedule": "Avbryt",
        "schedule_title": "Planlegg passivering",
        "schedule_date_label": "Dato",
        "schedule_submit": "Lagre",
        "cancel": "Avbryt",
        "confirm_passive": "Stadfest",
        "error_title": "Handlinga vart ikkje utført",
        "errors": {
          "invalid_date": "Ugyldig dato. Bruk formatet dd.mm.åååå.",
          "invalid_reason": "Ugyldig årsak. Vel eit av alternativa i lista.",
          "blank": "Feltet må fyllast ut.",
          "invalid": "Ugyldig verdi."
        },
        "toast": {
          "passivated": "Person passivert.",
          "reactivated": "Person reaktivert.",
          "scheduled": "Passivering planlagt.",
          "rescheduled": "Planlagt passivering endra.",
          "cancelled": "Planlagt passivering avbroten.",
          "error": "Noko gjekk gale. Prøv igjen."
        }
      },
      "opt_out": {
        "label": "Reservert mot oppføring",
        "on": "Reservert",
        "off": "Ikkje reservert",
        "set": "Reserver",
        "clear": "Fjern reservasjon",
        "error_title": "Handlinga vart ikkje utført",
        "toast": {
          "set": "Reservasjon registrert.",
          "cleared": "Reservasjon fjerna.",
          "error": "Noko gjekk gale. Prøv igjen."
        }
      },
      "comments": {
        "title": "Kommentarar",
        "add_placeholder": "Skriv ein kommentar …",
        "submit": "Legg til",
        "empty": "Ingen kommentarar endå.",
        "author_at": "%{author} · %{date}",
        "toast": {
          "added": "Kommentar lagt til.",
          "error": "Noko gjekk gale. Prøv igjen."
        }
      },
      "export": {
        "button": "Eksporter persondata",
        "hint": "Last ned alle registrerte opplysningar om personen (GDPR)."
      },
      "review_tasks": {
        "title": "Kontrolloppgåver",
        "subtitle": "Endringar frå registeret som krev stadfesting frå saksbehandlar.",
        "empty": "Ingen opne kontrolloppgåver.",
        "columns": {
          "subject": "Gjeld",
          "kind": "Type",
          "created_at": "Oppretta",
          "action": "Handling"
        },
        "subject": {
          "organization_number": "Org.nr. %{number}",
          "unknown": "Ukjend"
        },
        "resolve": "Stadfest",
        "modal": {
          "title": "Stadfest kontrolloppgåve",
          "person_body": "Stadfest at kontrolloppgåva er behandla. Oppgi rettsleg grunnlag. Stadfestinga kallar ikkje tilbake firmatilknytingar.",
          "validation_summary": "Oppgi rettsleg grunnlag",
          "body": "Stadfesting tilbakekallar aktive firmatilknytingar for emnet. Oppgi rettsleg grunnlag.",
          "legal_basis_label": "Rettsleg grunnlag",
          "legal_basis_hint": "Påkravd. Vis til vedtak, lovheimel eller registerendring.",
          "legal_basis_required": "Rettsleg grunnlag er påkravd.",
          "confirm": "Stadfest og tilbakekall",
          "cancel": "Avbryt"
        },
        "toast": {
          "resolved": "Kontrolloppgåve stadfesta.",
          "error": "Noko gjekk gale. Prøv igjen."
        },
        "payload": {
          "fields": {
            "name": "Namn",
            "address": "Adresse",
            "registry_presence": "Oppføring i Folkeregisteret"
          },
          "stored": "Lagra",
          "register": "I registeret",
          "confidence": "Nivå %{level}",
          "confidence_levels": {
            "high": "høg",
            "medium": "middels",
            "low": "låg"
          },
          "values": {
            "present": "Registrert",
            "not_found": "Ikkje funnen"
          }
        }
      }
    },
    "login": {
      "title": "Logg inn",
      "cta": "Logg inn med arbeidsbrukar"
    },
    "job_overview": {
      "refresh": "Oppdater",
      "refreshing": "Oppdaterer …",
      "refresh_failed": "Kunne ikkje oppdatere jobboversikta. Prøv igjen.",
      "hostname": "Vertsmaskin",
      "no_workers_reported": "Ingen arbeidarar er registrerte i denne oversikta. Kontroller jobbsystemet.",
      "stale_workers_reported": "Éin eller fleire arbeidarar har ikkje meldt livsteikn nyleg. Andre arbeidarar kan framleis behandle køane.",
      "title": "Jobbar",
      "subtitle": "Status for bakgrunnsjobbar, køar og planlagde køyringar.",
      "unavailable_title": "Jobbsystemet er ikkje tilgjengeleg her",
      "unavailable_body": "Køen køyrer berre i produksjon. I dette miljøet finst ingen jobbtabellar å lesa frå.",
      "workers_heading": "Arbeidarar",
      "workers_empty": "Ingen arbeidarar har meldt seg. Køen blir ikkje tømd.",
      "worker_stale": "Svarar ikkje",
      "worker_healthy": "Køyrer",
      "last_heartbeat": "Siste livsteikn",
      "queues_heading": "Køar",
      "queues_empty": "Ingen jobbar i kø.",
      "queue_name": "Kø",
      "queue_ready": "Klare",
      "queue_scheduled": "Planlagde",
      "recurring_heading": "Planlagde køyringar",
      "recurring_empty": "Ingen planlagde køyringar er registrerte.",
      "recurring_key": "Jobb",
      "recurring_schedule": "Plan",
      "recurring_last_run": "Sist køyrd",
      "never_run": "Aldri køyrd",
      "failed_heading": "Feila jobbar",
      "failed_empty": "Ingen feila jobbar.",
      "failed_job": "Jobb",
      "failed_queue": "Kø",
      "failed_error": "Feil",
      "failed_at": "Tidspunkt",
      "advanced": "Opne Mission Control"
    },
    "templates": {
      "open_pdf": "Opne PDF i ny fane"
    },
    "shell": {
      "identity": "%{name} · %{role}"
    },
    "profile": {
      "title": "Min profil",
      "account_heading": "Kontoen din",
      "name": "Namn",
      "email": "E-post",
      "no_email": "Ingen e-post registrert",
      "role": "Rolle",
      "no_role": "Inga rolle registrert",
      "department": "Avdeling",
      "no_department": "Inga avdeling",
      "account_note": "Du kan ikkje endre kontoopplysningane dine her. Rolle og avdeling blir administrerte av verksemda di.",
      "settings_heading": "Personlege innstillingar",
      "language_heading": "Språk",
      "language_description": "Vel språket du vil bruke i løysinga.",
      "display_heading": "Vising og tilgjengelegheit",
      "display_description": "Tilpass tema, tekststorleik, avstand, kontrast og rørsle.",
      "display_action": "Tilpass visinga",
      "settings_note": "Endringar i visinga blir brukte med ein gong.",
      "help_heading": "Er nokre opplysningar feil?",
      "help_body": "Kontakt den som administrerer brukartilgangen i verksemda di. Namn og e-post kan òg måtte rettast i innloggingsløysinga."
    },
    "regulation_checklist": {
      "heading": "Vurdering mot forskrift",
      "overlay_heading": "Vurdering av praksis",
      "empty_text": "Inga forskriftssjekkliste gjeld for denne sakstypen.",
      "note_label": "Merknad",
      "state_labels": {
        "met": "Oppfylt",
        "not_met": "Ikkje oppfylt",
        "not_applicable": "Ikkje aktuelt",
        "needs_documentation": "Treng dokumentasjon"
      },
      "finalize": {
        "button_label": "Ferdigstill vurdering",
        "blocked_warning": "Alle punkt må konkluderast før vurderinga kan ferdigstillast."
      }
    },
    "companies": {
      "title": "Firma",
      "search_label": "Søk etter firmanamn eller organisasjonsnummer",
      "empty": "Ingen firma funne",
      "columns": {
        "name": "Firmanamn",
        "organization_number": "Org.nr.",
        "status": "Status",
        "municipality": "Kommune",
        "mesterbedrift": "Mesterbedrift",
        "active_masters": "Aktive meistrar"
      },
      "mesterbedrift": {
        "qualified": "Mesterbedrift",
        "not_qualified": "Ikkje mesterbedrift"
      },
      "register": {
        "title": "Registerdata",
        "owned_hint": "Registereigde felt — kan ikkje endrast her. Henta frå Einingsregisteret (BRREG).",
        "synced_at": "Sist synkronisert",
        "never_synced": "Aldri synkronisert",
        "legal_name": "Firmanamn",
        "organization_number": "Organisasjonsnummer",
        "org_form": "Organisasjonsform",
        "status": "Status",
        "business_address": "Forretningsadresse",
        "municipality": "Kommune",
        "details": "Utfyllande BRREG-opplysningar",
        "industry_codes": "Næringskodar",
        "activity": "Aktiviteten til verksemda",
        "registered_on": "Registrert i Einingsregisteret",
        "vat_registered": "Meirverdiavgiftsregisteret",
        "enterprise_registered": "Føretaksregisteret",
        "registered": "Registrert",
        "not_registered": "Ikkje registrert",
        "unknown": "Ikkje oppgitt"
      },
      "refresh": {
        "button": "Oppdater frå BRREG",
        "changed_title": "Registerdata oppdaterte",
        "changed_body": "Endra felt: %{fields}",
        "unchanged_title": "Ingen endringar",
        "unchanged_body": "Firmaet er uendra i Einingsregisteret.",
        "not_found_title": "Ikkje funne i Einingsregisteret",
        "not_found_body": "Det er oppretta ei kontrolloppgåve for oppfølging.",
        "unreachable_title": "Einingsregisteret er utilgjengeleg",
        "unreachable_body": "Kunne ikkje nå registeret. Prøv igjen om litt.",
        "error_title": "Oppdateringa feila",
        "error_body": "Noko gjekk gale. Prøv igjen."
      },
      "local": {
        "title": "Lokal kontaktinformasjon",
        "hint": "Desse felta er eigde lokalt og kan endrast her.",
        "contact_url": "Nettside",
        "contact_phone": "Telefon",
        "contact_email": "E-post",
        "display_address": "Visingsadresse",
        "save": "Lagre",
        "saved": "Endringane er lagra.",
        "error": "Kunne ikkje lagre. Endringane er tilbakestilte."
      },
      "memberships": {
        "title": "Meistertilknytingar",
        "empty": "Ingen meistertilknytingar",
        "columns": {
          "mester": "Meister",
          "role": "Rolle",
          "position_percent": "Stillingsprosent",
          "period": "Periode",
          "status": "Status"
        },
        "ongoing": "laupande",
        "status_active": "Aktiv",
        "status_ended": "Avslutta",
        "status_revoked": "Tilbakekalla"
      },
      "cases": {
        "title": "Saker",
        "empty": "Ingen tilknytte saker",
        "columns": {
          "case_number": "Saksnummer",
          "kind": "Sakstype",
          "state": "Status"
        }
      },
      "review_tasks": {
        "title": "Opne kontrolloppgåver",
        "empty": "Ingen opne kontrolloppgåver",
        "view_all": "Gå til kontrolloppgåver"
      }
    },
    "membership_feed": {
      "title": "Firmatilknytingar",
      "subtitle": "Endringar i tilknytingar mellom meister og firma, på tvers av portal, sakshandsaming og register.",
      "empty": "Ingen endringar i valt tidsrom.",
      "columns": {
        "occurred_at": "Tidspunkt",
        "mester": "Meister",
        "company": "Firma",
        "change_type": "Endring",
        "source": "Kjelde"
      },
      "window_label": "Tidsrom",
      "window_7": "Siste 7 dagar",
      "window_14": "Siste 14 dagar",
      "window_30": "Siste 30 dagar",
      "sources": {
        "portal": "Portal",
        "caseworker": "Sakshandsamar",
        "register": "Register",
        "system": "System"
      },
      "change_types": {
        "created": "Oppretta",
        "revoked": "Tilbakekalla"
      }
    },
    "people": {
      "refresh_register": {
        "button": "Oppdater frå DSF",
        "in_sync_title": "Samsvarar med Folkeregisteret",
        "in_sync_body": "Ingen avvik mellom lagra opplysningar og registeret.",
        "discrepancy_title": "Avvik funne",
        "discrepancy_body": "Det er oppretta kontrolloppgåve(r) for avvika.",
        "view_tasks": "Gå til kontrolloppgåver",
        "deceased_title": "Registrert død i Folkeregisteret",
        "deceased_body": "Det er oppretta ei kontrolloppgåve for oppfølging.",
        "not_found_title": "Ikkje funnen i Folkeregisteret",
        "not_found_body": "Personen finst ikkje i registeret. Det er oppretta ei kontrolloppgåve for oppfølging.",
        "no_identifier_title": "Fødselsnummer er ikkje tilgjengeleg enno",
        "no_identifier_body": "Plattforma lagrar ikkje fødselsnummer, og oppslag mot Folkeregisteret er difor ikkje mogleg for denne personen enno.",
        "unreachable_title": "Folkeregisteret svarar ikkje",
        "unreachable_body": "Kunne ikkje nå registeret. Prøv igjen seinare.",
        "error_title": "Oppdateringa feila",
        "error_body": "Noko gjekk gale. Prøv igjen."
      }
    },
    "sanctions": {
      "title": "Ulovleg bruk",
      "next_action": "Neste handling",
      "assess_response": "Vurder tilsvar",
      "open_documents": "Opne dokument",
      "states": {
        "open": "Ikkje behandla",
        "in_progress": "Under vurdering",
        "awaiting_response": "Ventar på tilbakemelding",
        "response_received": "Tilsvar motteke",
        "closed": "Avslutta"
      },
      "basis": "Saksgrunnlag",
      "company": "Innmeld bedrift",
      "missing_company": "Denne eldre saka manglar bedrift. Registrer organisasjonsnummeret for å knyte rett bedrift til saka.",
      "link_company": "Knyt bedrift til saka",
      "tip_text": "Originalt tips",
      "tip_received_on": "Mottaksdato for tipset",
      "original_tip_hint": "Tidlegare versjonar blir bevarte. Tipsopplysningane blir låste når varselet er sendt.",
      "tipster": "Tipsar",
      "tipster_contact": "Kontaktopplysningane til tipsaren",
      "tipster_hint": "Valfritt. Blir halde skilt frå mottakaropplysningane til bedrifta og ikkje teke med i varselet.",
      "category": "Kva gjeld forholdet?",
      "choose_category": "Vel kategori",
      "categories": {
        "mark": "Bruk av meistermerket",
        "title": "Bruk av meistertittel",
        "mark_and_title": "Bruk av meistermerket og -tittel",
        "other": "Anna"
      },
      "description": "Beskriving av forholdet",
      "assessment": "Vurderinga til saksbehandlaren",
      "source_url": "Nettadresse til observasjonen",
      "observed_on": "Observasjonsdato",
      "evidence": "Dokumentasjon og tilsvar",
      "file": "Vel dokument eller bilete",
      "selected_file": "Vald fil: %{filename}",
      "upload": "Last opp",
      "upload_error": "Kunne ikkje laste opp. Kontroller filtype og storleik. Tillatne filer er PDF, PNG, JPEG, TIFF og DOCX.",
      "notice_title": "Varsel om mogleg gebyr",
      "notice_body": "Brevtekst",
      "notice_recipient": "Mottakar og adresse",
      "notice_hint": "Skriv og kontroller brevteksten. Kategori, beskriving, vurdering og mottakar må vere lagra før varselet kan lagast.",
      "preview": "Førehandsvis varsel",
      "issue": "Lag PDF-varsel",
      "view_notice": "Opne varselet",
      "register_dispatch": "Registrer utsending",
      "external_dispatch_hint": "Send brevet utanfor systemet først. Registrer deretter utsendinga av dette dokumentet. Denne handlinga sender ikkje brevet.",
      "sent_on": "Utsendingsdato",
      "channel": "Utsendingskanal",
      "channels": {
        "post": "Post",
        "email": "E-post"
      },
      "sent_notice": "Utsendt varsel",
      "follow_up_on": "Oppfølgingsdato",
      "default_follow_up": "Tomt felt gir tre veker frå utsendingsdatoen.",
      "saving": "Lagrar …",
      "unsaved": "Endringar ventar på lagring",
      "saved": "Alle endringar er lagra",
      "save_error": "Kunne ikkje lagre siste endring. Kontroller opplysningane og prøv igjen. Teksten din er bevart.",
      "conflict": "Saka er endra av ei anna handling. Ta vare på teksten din og last inn saka på nytt.",
      "close_case": "Avslutt utan gebyr",
      "closure_reason": "Intern grunngiving for avslutning",
      "closure_body": "Brevtekst til bedrifta",
      "closure_recipient": "Mottakar og adresse for avslutningsbrevet",
      "form_changed": "Brevet eller saka er endra. Lukk dialogen og opne handlinga på nytt før du held fram. Innhaldet du har skrive, er bevart.",
      "closure": {
        "open_draft": "Opne lokalt avslutningsutkast",
        "discard_draft": "Forkast lokalt avslutningsutkast",
        "title": "Avslutningsbrev",
        "hint": "Grunngivinga er intern. Skriv sjølv brevteksten til bedrifta. Klargjering avsluttar ikkje saka; saka blir avslutta når utsending av det godkjende brevet blir registrert.",
        "prepare": "Klargjer avslutningsbrev",
        "edit": "Rediger avslutningsbrev",
        "preview": "Førehandsvis avslutningsbrev",
        "view_notice": "Opne avslutningsbrevet",
        "register_dispatch": "Registrer utsending og avslutt",
        "without_letter": "Avslutt utan brev",
        "cancel": "Avbryt klargjering",
        "sent": "Utsendt avslutningsbrev",
        "review": {
          "reviewer": "Godkjennar av avslutningsbrevet",
          "approve": "Godkjenn avslutningsbrevet"
        }
      },
      "responses": {
        "discard_draft": "Forkast tilsvarsutkast",
        "open_draft": "Opne tilsvarsutkast",
        "resolve_before_close": "Registrer eller forkast tilsvarsutkastet før saka blir avslutta.",
        "register": "Registrer tilsvar",
        "received_on": "Mottaksdato for tilsvaret",
        "summary": "Samandrag av tilsvaret",
        "recorded_by": "Registrert av",
        "attachments_hint": "Vedlegg er valfritt. Vel nye filer eller dokument som allereie er lasta opp på saka.",
        "files": "Vel filer",
        "remove_file": "Fjern %{filename}",
        "existing_documents": "Opplasta dokument",
        "open_summary": "Opne samandrag (PDF)",
        "refresh": "Oppdater saka",
        "conflict_hint": "Saka er endra. Oppdater saka før du prøver igjen. Tilsvaret og dei valde filene blir bevarte.",
        "refresh_error": "Kunne ikkje oppdatere saka. Tilsvaret og dei valde filene er bevarte. Prøv å oppdatere igjen.",
        "unavailable_documents": "Nokre valde dokument er ikkje lenger tilgjengelege som vedlegg. Fjern dei frå tilsvaret og vel eventuelt andre dokument før du registrerer.",
        "remove_document": "Fjern dokumentet %{filename}"
      },
      "review": {
        "title": "Godkjenning av varsel",
        "reviewer": "Godkjennar av varselet",
        "choose_reviewer": "Vel godkjennar",
        "request": "Send til godkjenning",
        "reassign": "Byt godkjennar",
        "view_document": "Opne PDF-en til godkjenning",
        "approve": "Godkjenn varselet",
        "comment": "Grunngiving for retur",
        "return": "Returner for endringar",
        "status": {
          "pending": "Ventar på godkjenning",
          "approved": "Godkjent",
          "returned": "Returnert for endringar",
          "outdated": "Innhaldet er endra — send til godkjenning på nytt"
        }
      },
      "errors": {
        "closure_not_ready": "Lagre intern grunngiving, brevtekst og mottakar først.",
        "closure_not_started": "Klargjer avslutningsbrevet først.",
        "closure_already_started": "Avslutningsbrevet er allereie under klargjering. Last inn saka på nytt.",
        "closure_letter_required": "Saka krev eit godkjent avslutningsbrev med registrert utsending.",
        "closure_not_approved": "Avslutningsbrevet må godkjennast før utsendinga kan registrerast.",
        "invalid_closure_document": "PDF-en samsvarer ikkje med det gjeldande avslutningsbrevet. Send til godkjenning på nytt.",
        "closure_generation_failed": "Kunne ikkje lage avslutningsbrevet som PDF. Prøv igjen. Opplysningane dine er bevarte.",
        "closure_in_progress": "Avbryt klargjeringa av avslutningsbrevet før du held fram med varselet.",
        "notice_generation_failed": "Kunne ikkje lage PDF-varselet. Prøv å sende til godkjenning igjen. Opplysningane dine er bevarte.",
        "response_not_allowed": "Tilsvar kan berre registrerast på ei open sak etter at varselet er sendt.",
        "invalid_response_date": "Mottaksdatoen må vere frå og med utsendingsdatoen til og med dagens dato.",
        "invalid_response_summary": "Skriv eit samandrag på maksimalt 30 000 teikn.",
        "invalid_response_documents": "Vel innkomande dokument på denne saka som ikkje er trekte tilbake.",
        "forbidden": "Du har ikkje tilgang til å utføre denne handlinga.",
        "invalid_source_url": "Skriv ei gyldig nettadresse, til dømes https://www.example.com.",
        "invalid_tip_received_on": "Skriv ein gyldig mottaksdato for tipset.",
        "invalid_observed_on": "Skriv ein gyldig observasjonsdato.",
        "invalid_follow_up_on": "Skriv ein gyldig oppfølgingsdato.",
        "invalid_sent_date": "Skriv ein gyldig utsendingsdato.",
        "invalid_follow_up": "Oppfølgingsdatoen kan ikkje vere før utsendingsdatoen.",
        "invalid_notice_document": "PDF-en samsvarer ikkje med det gjeldande varselet. Send til godkjenning på nytt.",
        "notice_not_approved": "Varselet må godkjennast før utsendinga kan registrerast.",
        "notice_not_ready": "Lagre kategori, beskriving, vurdering, brevtekst og mottakar først.",
        "invalid_reviewer": "Vel ein annan aktiv seniorsaksbehandlar eller administrator enn den som ber om godkjenning eller er tildelt saka.",
        "review_not_pending": "Brevet ventar ikkje lenger på godkjenning. Last inn saka på nytt.",
        "review_already_requested": "Det er allereie bede om godkjenning av dette brevet.",
        "reason_required": "Skriv ei grunngiving før du held fram."
      }
    }
  },
  "portal": {
    "applications": {
      "feedback": {
        "help_button": "Vis hjelp: %{topic}",
        "save_failed": "Endringane kunne ikkje lagrast. Prøv igjen før du går vidare.",
        "help_title": "Hjelp og dokumentasjonskrav",
        "foreign_certificate_title": "Utanlandsk fag-/sveinebrev?",
        "foreign_certificate": "Utanlandsk fag- eller sveinebrev må vere godkjent av HK-dir. Last opp ditt originale fag-/sveinebrev og godkjenninga frå HK-dir.",
        "optional_certificate": "Opplasting av fag-/sveinebrev er valfritt i denne søknaden.",
        "practice_title": "Praksiskrav:",
        "practice_rules": "minst 6 års praksis i faget eller minst 2 års praksis i faget etter sveineprøve/fagprøve",
        "practice_recency": "Som hovudregel må praksisen liggje innanfor siste 10-årsperiode.",
        "executive_practice_rules": "minst 6 års utøvande praksis i faget eller minst 2 års utøvande praksis i faget etter sveineprøve/fagprøve",
        "practice_documents": "Slik dokumenterer du praksis",
        "employed_title": "Tilsett",
        "employed_documents": "Tilsett? Legg ved attest frå arbeidsgivar(ar) med arbeidsoppgåver, periode, stillingsprosent og signatur.",
        "company_title": "Er du dagleg leiar i eit AS, legg ved:",
        "company_statement": "Fråsegn frå rekneskapsførar, styreleiar eller revisor. Fråsegna må beskrive rolla di, stillingsprosent og varigheit",
        "company_documents": "Firmaattest og årsrekneskap",
        "sole_trader_title": "Driv du eit enkeltpersonføretak (ENK), legg ved:",
        "sole_trader_statement": "Fråsegn frå rekneskapsførar eller revisor, eller",
        "sole_trader_documents": "Firmaattest og næringsspesifikasjon frå skattemelding for åra du ønskjer å dokumentere praksis frå",
        "leadership_title": "Leiarpraksis",
        "leadership_rules": "Du må dokumentere minst 6 års praksis innanfor dei siste 10 åra som næringsdrivande eller leiar i faget, med fagleg og forretningsmessig ansvar.",
        "leadership_responsibility": "Å ha fagleg og forretningsmessig ansvar inneber som hovudregel at du driv eiga handverksbedrift i det aktuelle meisterfaget, eventuelt er øvste leiar med ansvar for heile bedrifta. Det er i utgangspunktet formelle og registrerte roller som blir tillagde vekt i vurderinga av om du har fagleg og forretningsmessig ansvar.",
        "leadership_exclusions": "Dei som ikkje vil oppfylle dette kravet er til dømes: handverkarar utan tilleggsansvar, prosjektleiarar med berre prosjektansvar, formenn, byggjeleiarar, basar eller avdelingsleiarar. Personar med desse funksjonane kan derfor ikkje søkje om meisterbrev på bakgrunn av realkompetanse.",
        "leadership_full_time": "Talet på år med praksis skal svare til praksis på full tid.",
        "leadership_certificate": "Attest/stadfesting på praksis som leiar",
        "financial_documents": "Næringsoppgåve/næringsspesifikasjon/årsrekneskap",
        "company_certificate": "Firmaattest",
        "employment_percentage": "Stillingsprosent",
        "percentage_invalid": "Oppgi ein stillingsprosent større enn 0 og høgst 100.",
        "calendar_duration": "Kalenderlengd",
        "practice_upload": "Last opp praksisdokumentasjon for denne perioden. Ein samla PDF er tillaten.",
        "practice_add_hint": "Registrer praksisperioden og vel «Legg til» for å laste opp dokumentasjon.",
        "provider": "Utdanningsaktør",
        "provider_placeholder": "Vel utdanningsaktør",
        "provider_required": "Vel utdanningsaktøren for meisterutdanninga.",
        "country": "Land utdanninga er frå",
        "foreign_education_title": "Utanlandsk meisterutdanning",
        "translations": "All dokumentasjon skal liggje føre på norsk. Utanlandsk dokumentasjon må vere omsett av autorisert omsetjar.",
        "norwegian_requirements_title": "Norske styresmaktkrav og bransjestandardar",
        "norwegian_requirements": "Last opp dokumentasjon på at du har kompetanse i gjeldande norske styresmaktkrav og bransjestandardar innan meisterfaget. Dette inkluderer lover, forskrifter og standardar. Dette kan stadfestast med fråsegn frå tidlegare arbeidsgivarar, kursbevis, vitnemål med meir.",
        "legacy_documents": "Tidlegare opplasta dokument",
        "supplementary_documents": "Vedlegg til eigenvurderinga",
        "self_assessment_upload": "Last opp samla eigenvurdering for fagområdet.",
        "self_assessment_templates": "Last ned malar for eigenvurdering",
        "self_assessment_template_instruction": "Bruk malane frå Mesterbrevnemnda for eigenvurdering, og legg ved dokumentasjon som støttar eigenvurderinga under same fagområde.",
        "exemption_title": "Fritak",
        "exemption_help_title": "Krav til fritak og dokumentasjon",
        "exemption_intro": "Du kan søkje om fritak for heile eller delar av meisterutdanninga på grunnlag av anna utdanning.",
        "exemption_requirements": "Då blir det stilt følgjande krav:",
        "exemption_level": "Utdanninga må i grove trekk samsvare med meisterutdanninga når det gjeld nivå og fagleg innhald.",
        "exemption_leadership": "Utdanninga må som hovudregel gi leiarkompetanse og omfatte etablerarkunnskap.",
        "exemption_grade": "Eksamen må beståast med karakter D eller betre i fag som inngår i vurderingsgrunnlaget. I fag der det ikkje blir avlagt eksamen, må standpunktkarakteren tilfredsstille karakterkravet.",
        "exemption_recency": "Utdanninga må som hovudregel ikkje vere eldre enn 10 år på det tidspunktet det blir søkt om meisterbrev.",
        "exemption_documentation": "Dokumentasjonskrav:",
        "exemption_diploma": "Fullstendig vitnemål som viser emne, studiepoeng og oppnådd karakter.",
        "exemption_curriculum": "Emneomtalar / fagplanar som viser læringsutbytte, innhald og nivå på utdanninga",
        "exemption_select": "Vel fagområda eller modulane du søkjer fritak for.",
        "exemption_modules_hint": "Du kan søkje fritak for kvar enkelt modul innan bedriftsleiing. For fagleg leiing og fagleg fordjuping må heile det aktuelle fagområdet godkjennast.",
        "exemption_upload": "Last opp vitnemål og emneomtalar/fagplanar som dokumenterer dette valet. Ein samla PDF er tillaten.",
        "exemption_required": "Vel minst eitt fagområde eller éin modul, og legg ved dokumentasjon.",
        "exemption_fee": "Behandlingsgebyr for valde fagområde",
        "business_management": "Heile fagområdet bedriftsleiing",
        "business_modules": "Modular i bedriftsleiing",
        "business_modules_included": "Alle tre modulane inngår når du vel heile fagområdet bedriftsleiing.",
        "assessment_registered": "Eigenvurdering registrert"
      },
      "education": {
        "types": {
          "master_education": "Vitnemål meisterutdanning",
          "foreign_master_certificate": "Kopi av det utanlandske meisterbrevet",
          "foreign_curriculum": "Kopi av studieplanen for den utanlandske meisterkvalifikasjonen",
          "master_exam_business_management": "Vitnemål meistereksamen i bedriftsleiing",
          "master_exam_technical_leadership_or_specialization": "Vitnemål meistereksamen i fagleg leiing og/eller fagleg fordjuping",
          "pre_approved_education": "Vitnemål frå utdanning godkjend av Mesterbrevnemnda (fagskule, NEAK)",
          "exemption_letter": "Brev frå Mesterbrevnemnda om fritak for meisterutdanning"
        },
        "heading": "Vel utdanninga di",
        "upload_all_pages": "Last opp alle sidene i dokumenta du bruker som grunnlag.",
        "records": {
          "heading": "Utdanning %{number}",
          "summary": "Oppgitt utdanning",
          "institution": "Namn på utdanningsstad",
          "program": "Utdanning / linje",
          "completed_on": "Fullført dato",
          "add": "Legg til utdanning",
          "remove": "Fjern utdanning",
          "diploma_required": "Last opp minst eitt vitnemål for denne utdanninga. Ta med alle sidene.",
          "remove_documents_first": "Fjern vedlegga før du fjernar utdanninga eller vel bort typen. Oppføringar med tilbaketrekt dokumentasjon må behaldast.",
          "invalid_date": "Oppgi ein gyldig fullføringsdato frå 1900 og fram til i dag.",
          "too_long": "Bruk høgst 200 teikn.",
          "complete_fields": "Fyll ut namn på utdanningsstad, linje og fullføringsdato for kvar utdanning."
        }
      },
      "missing": {
        "institution": "Utdanningsaktør for meisterutdanninga",
        "origin_country": "Land utdanninga er frå",
        "practice_entry_documents": "Dokumentasjon for kvar praksisperiode",
        "norwegian_requirements": "Dokumentasjon på kompetanse i norske styresmaktkrav og bransjestandardar",
        "exemption_subjects": "Fagområde eller modular du søkjer fritak for",
        "exemption_documents": "Vitnemål og emneomtalar/fagplanar for vala du søkjer fritak for",
        "exemption_scope": "Omfang av fritak",
        "given_name": "Fornamn",
        "family_name": "Etternamn",
        "email": "E-post",
        "street_address": "Adresse",
        "postcode": "Postnr",
        "city": "Poststad",
        "country": "Land",
        "mobile_number": "Mobilnr",
        "country_code": "Landkode",
        "trade": "Fag",
        "passed_exam_date": "Dato for bestått prøve",
        "trade_certificate": "Fag-/sveinebrev",
        "education_types": "Utdanning",
        "practice_entries": "Praksisperiode",
        "practice_entry_fields": "Opplysningar om praksisperiodane",
        "other_documentation_note": "Skildring",
        "declaration_confirmed": "Eigenerklæring",
        "third_party_verification_consent": "Samtykke til kontroll hos tredjepart",
        "practice_employed_entries": "Praksis i faget",
        "practice_employed_entry_fields": "Opplysningar om praksis i faget",
        "practice_employed_entry_documents": "Attestar for praksis i faget",
        "leadership_practice_entries": "Praksis som næringsdrivande eller leiar",
        "leadership_practice_entry_fields": "Opplysningar om leiarpraksis",
        "leadership_practice_entry_documents": "Dokumentasjon på leiarpraksis",
        "self_assessment_business_entries": "Eigenvurdering i bedriftsleiing",
        "self_assessment_business_entry_fields": "Fagområde i bedriftsleiing",
        "self_assessment_business_entry_documents": "Dokumentasjon til eigenvurdering i bedriftsleiing",
        "self_assessment_leadership_entries": "Eigenvurdering i fagleg leiing",
        "self_assessment_leadership_entry_fields": "Fagområde i fagleg leiing",
        "self_assessment_leadership_entry_documents": "Dokumentasjon til eigenvurdering i fagleg leiing",
        "self_assessment_specialization_entries": "Eigenvurdering i fagleg fordjuping",
        "self_assessment_specialization_entry_fields": "Fagområde i fagleg fordjuping",
        "self_assessment_specialization_entry_documents": "Dokumentasjon til eigenvurdering i fagleg fordjuping",
        "duplicate_entry_ids": "Unike referansar for dokumentasjonsoppføringane",
        "entries": "Oppføring",
        "entry_documents": "Vedlegg til oppføringane",
        "incomplete": "Ufullstendige opplysningar",
        "education_documents": "Vitnemål for kvar utdanning og eventuelt fritaksbrev",
        "education_entry_fields": "Namn på utdanningsstad, linje og fullføringsdato for kvar utdanning"
      },
      "nav": {
        "my_applications": "Søknadene mine"
      },
      "index": {
        "title": "Søknadene mine",
        "empty": "Du har ingen søknader.",
        "empty_subtitle": "Du har ingen søknader enno. Start ein ny søknad for å søkje om meisterbrev.",
        "new": "Ny søknad",
        "col_slug": "Saksnr.",
        "col_kind": "Type",
        "col_trade": "Fag",
        "col_state": "Status",
        "continue_draft": "Hald fram med utkast"
      },
      "new": {
        "title": "Ny søknad",
        "start_action": "Start søknad",
        "error_summary": "Rett feila før du startar søknaden",
        "errors": {
          "kind_required": "Vel kva søknad du vil starte.",
          "trade_required": "Vel faget du søkjer meisterbrev i.",
          "kind_unavailable": "Denne søknadstypen er ikkje tilgjengeleg. Vel ein annan.",
          "trade_invalid": "Faget er ikkje tilgjengeleg. Vel eit fag frå lista.",
          "general": "Søknaden kunne ikkje opprettast"
        }
      },
      "edit": {
        "title": "Rediger søknad"
      },
      "wizard": {
        "error_summary": "Kontroller opplysningane",
        "title": "Søknaden din",
        "back_to_menu": "Tilbake til menyen",
        "next": "Neste",
        "navigation_failed": "Du kunne ikkje gå vidare frå steget. Stadfest nye personopplysningar med lagringsknappen, eller vent til lagring og dokumenthandsaming er ferdig og prøv igjen.",
        "save_section": "Lagre seksjonen",
        "incomplete_notice": "Fyll ut alle påkravde steg før du sender inn søknaden.",
        "submitted_notice": "Søknaden er sendt inn.",
        "coming_soon": "Dette steget kjem snart.",
        "status": {
          "complete": "Registrert",
          "incomplete": "Må fullførast",
          "optional": "Valfritt"
        },
        "steps": {
          "personal_and_declaration": "Personopplysningar og eigenerklæring",
          "trade_and_practice": "Fag og praksis i faget",
          "leadership_practice": "Praksis som næringsdrivande eller leiar",
          "self_assessment": "Eigenvurdering",
          "exemption_scope": "Fritak",
          "self_assessment_business": "Bedriftsleiing – Eigenvurdering",
          "self_assessment_leadership": "Fagleg leiing – Eigenvurdering",
          "self_assessment_specialization": "Fagleg fordjuping – Eigenvurdering",
          "self_declaration": "Eigenerklæring",
          "business_registration": "Næringsoppgåve/næringsspesifikasjon/årsrekneskap",
          "company_certificate": "Firmaattest",
          "course_certificate": "Kurs og utdanning",
          "personal_details": "Personopplysningar",
          "trade": "Fag og fag-/sveinebrev",
          "education": "Utdanning og innvilga fritak",
          "practice": "Praksis i faget",
          "other_documentation": "Tilleggsopplysningar (valfritt)",
          "review": "Kontroller, betal og send inn",
          "practice_employed": "Praksis som tilsett",
          "other_relevant_information": "Anna relevant informasjon"
        },
        "short": {
          "personal_and_declaration": "Personopplysningar og eigenerklæring",
          "trade_and_practice": "Fag og praksis",
          "leadership_practice": "Leiarpraksis",
          "self_assessment": "Eigenvurdering",
          "exemption_scope": "Fritak",
          "self_assessment_business": "Bedriftsleiing",
          "self_assessment_leadership": "Fagleg leiing",
          "self_assessment_specialization": "Fagleg fordjuping",
          "self_declaration": "Eigenerklæring",
          "business_registration": "Næringsoppgåver",
          "company_certificate": "Firmaattest",
          "course_certificate": "Kurs",
          "personal_details": "Personopplysningar",
          "trade": "Fag",
          "education": "Utdanning",
          "practice": "Praksis",
          "other_documentation": "Tilleggsopplysningar",
          "review": "Innsending",
          "practice_employed": "Praksis (tilsett)",
          "other_relevant_information": "Anna info"
        },
        "steps_label": "Steg i søknaden",
        "steps_summary": "%{done} av %{total} steg fullført",
        "step_status": {
          "complete": "Fullført",
          "remaining": "Står att",
          "optional": "Valfritt"
        },
        "descriptions": {
          "exemption_scope": "Vel fagområda eller modulane du søkjer fritak for, og last opp dokumentasjonen som høyrer til.",
          "self_assessment_business": "Last opp samla eigenvurdering i bedriftsleiing og vedlegga som høyrer til.",
          "self_assessment_leadership": "Vel modulen i fagleg leiing eigenvurderinga di dekkjer.",
          "self_assessment_specialization": "Vel modulen i fagleg fordjuping eigenvurderinga di dekkjer.",
          "self_declaration": "Stadfest eigenerklæringa for å kunne sende inn søknaden.",
          "business_registration": "Last opp næringsoppgåver om du har praksis som personleg næringsdrivande.",
          "company_certificate": "Last opp firmaattest om du har praksis som personleg næringsdrivande.",
          "course_certificate": "Last opp dokumentasjon på relevante kurs og utdanning.",
          "personal_details": "Kontroller at opplysningane dine stemmer. Namn og adresse hentar vi frå Folkeregisteret og må endrast der. E-post og mobilnummer kan du endre sjølv.",
          "trade": "Vel faget du søkjer meisterbrev i, og oppgi dato for bestått fag-/sveineprøve.",
          "education": "Vel eitt eller fleire grunnlag. Du kan registrere meisterutdanning, anna godkjend utdanning og innvilga fritak i same søknad. Kvar utdanning må ha eigne opplysningar og vitnemål.",
          "practice": "Registrer praksis opparbeidd som tilsett og/eller som sjølvstendig næringsdrivande.",
          "other_documentation": "Her kan du gi tilleggsopplysningar og leggje ved dokument som ikkje høyrer til dei andre stega. Dette er valfritt.",
          "review": "Kontroller opplysningane, betal behandlingsgebyret og send inn søknaden.",
          "practice_employed": "Registrer praksis som tilsett i faget, med attest per arbeidsstad.",
          "other_relevant_information": "Last opp anna dokumentasjon du meiner er relevant for søknaden."
        }
      },
      "person": {
        "heading": "Personopplysningar",
        "given_name": "Fornamn",
        "middle_name": "Mellomnamn",
        "family_name": "Etternamn",
        "email": "E-post",
        "street_address": "Adresse",
        "co_address": "C/O-adresse",
        "postcode": "Postnr",
        "city": "Poststad",
        "country": "Land",
        "mobile_number": "Mobilnr",
        "country_code": "Landkode",
        "register_explain": "Namn og adresse hentar vi frå Folkeregisteret, og dei kan ikkje endrast her. Stemmer noko ikkje, må du melde det til Folkeregisteret.",
        "register_missing": "Denne opplysninga har vi ikkje frå Folkeregisteret enno. Fyll henne inn her, så bruker vi henne i søknaden.",
        "contact_explain": "E-post og mobilnummer bruker vi til å kontakte deg om denne søknaden. Du kan endre dei her. Endringa gjeld berre denne søknaden."
      },
      "fag": {
        "passed_exam_date": "Dato for bestått prøve",
        "passed_exam_hint": "Oppgi dato for bestått praktisk prøve, ikkje dato for utsteding av fag-/sveinebrev.",
        "certificate_upload_hint": "Last opp fag-/sveinebrevet ditt."
      },
      "praksis": {
        "role": "Rolle / stilling",
        "employment_percentage": "Stillingsprosent",
        "documentation": "Dokumentasjon for perioden",
        "documentation_hint": "Last opp dokumentasjon som underbyggjer opplysningane om denne praksisperioden.",
        "remove_documents_first": "Fjern dokumenta enkeltvis før du fjernar perioden. Periodar med tilbaketrekt dokumentasjon må behaldast.",
        "type_label": "Type praksis",
        "type_employed": "Tilsett",
        "type_self_employed": "Sjølvstendig næringsdrivande",
        "label_employed": "Arbeidsstad",
        "label_self_employed": "Namn på eiga bedrift",
        "from_month": "Frå månad",
        "from_year": "Frå år",
        "to_month": "Til månad",
        "to_year": "Til år",
        "from_date": "Frå dato",
        "to_date": "Til dato",
        "month_placeholder": "Vel månad",
        "months": {
          "m1": "Januar",
          "m2": "Februar",
          "m3": "Mars",
          "m4": "April",
          "m5": "Mai",
          "m6": "Juni",
          "m7": "Juli",
          "m8": "August",
          "m9": "September",
          "m10": "Oktober",
          "m11": "November",
          "m12": "Desember"
        },
        "duration": "Varigheit: %{duration}",
        "total_duration": "Samla praksistid: %{duration}.",
        "overlap_note": "Overlappande periodar blir berre talde éin gong.",
        "ongoing_label": "Praksisen held fram",
        "ongoing": "Pågåande",
        "ongoing_hint": "Du treng ikkje oppgi sluttdato. Praksistida blir rekna til datoen du sender inn søknaden.",
        "as_of_note": "Praksistid rekna til %{date}.",
        "duration_years": {
          "one": "%{count} år",
          "other": "%{count} år"
        },
        "duration_months": {
          "one": "%{count} månad",
          "other": "%{count} månader"
        },
        "duration_days": {
          "one": "%{count} dag",
          "other": "%{count} dagar"
        },
        "add_entry": "Legg til praksis",
        "remove": "Fjern",
        "empty": "Ingen praksis registrert enno."
      },
      "annet": {
        "note_label": "Merknad (valfritt)"
      },
      "show": {
        "title": "Søknad",
        "submit_action": "Send inn søknad",
        "slug": "Saksnummer",
        "trade": "Fag",
        "kind": "Type",
        "state": "Status",
        "documents_heading": "Dokument",
        "no_documents": "Ingen dokument.",
        "withdraw": "Trekk søknad",
        "withdraw_confirm": {
          "title": "Vil du trekkje søknaden?",
          "body": "Vi avsluttar saka og stoppar behandlinga. Har du betalt behandlingsgebyr, får du ikkje pengane tilbake. Vil du søkje seinare, må du sende ein ny søknad.",
          "cancel": "Avbryt",
          "confirm": "Trekk søknad"
        },
        "withdraw_result": {
          "success": "Søknaden er trekt.",
          "invalid_state": "Du kan ikkje lenger trekkje denne søknaden. Oppdater sida for å sjå kvar saka står no.",
          "failed": "Vi klarte ikkje å trekkje søknaden. Prøv igjen. Hjelper det ikkje, kontakt oss på post@mesterbrev.no."
        },
        "summary": {
          "title": "Søknaden min",
          "back": "Tilbake til søknaden",
          "case_details": "Saksopplysningar",
          "submitted_details": "Opplysningar i søknaden",
          "no_details": "Ingen skjemafelt er registrerte for denne søknaden. Sjå dokumenta nedanfor.",
          "documents_intro": "Her finn du dokumenta du har sendt inn, også det du har ettersendt.",
          "documentation_title": "Vi treng meir dokumentasjon",
          "documentation_body": "Saksbehandlaren har bede om opplysningane nedanfor. Opne førespurnaden for å lese heile meldinga og laste opp dokument.",
          "next_steps": "Kva skjer vidare?",
          "draft_body": "Søknaden er eit utkast og er ikkje send til handsaming. Hald fram med å fylle ut søknaden når du er klar.",
          "withdrawn_body": "Søknaden er trekt og blir ikkje handsama vidare. Opplysningane og dokumenta er framleis tilgjengelege her.",
          "closed_body": "Saka er avslutta. Opplysningane og dokumenta er framleis tilgjengelege her.",
          "created_at": "Oppretta",
          "submitted_at": "Send inn",
          "closed_at": "Avslutta",
          "not_submitted": "Ikkje send inn",
          "document_count": "Innsende dokument",
          "contact": "Kontaktopplysningar",
          "contact_intro": "Kontaktinformasjonen vi bruker for denne søknaden.",
          "certificate_title": "Fag-/sveinebrev",
          "third_party_consent": "Samtykke til å hente inn opplysningar frå tredjepart",
          "yes_label": "Ja",
          "no_label": "Nei"
        },
        "checklist": {
          "title": "Ettersend dokumentasjon",
          "intro": "Vi treng fleire dokument for å handsame søknaden din.",
          "deadline": "Frist for ettersending",
          "requested_count": {
            "one": "Éin dokumenttype etterspurd",
            "other": "%{count} dokumenttypar etterspurde"
          },
          "document_number": "Dokumenttype %{number} av %{total}",
          "requested": "Etterspurd",
          "upload_hint": "Last opp dokumentasjonen saksbehandlaren ber om ovanfor.",
          "upload_document": "Last opp %{document}",
          "immediate_upload": "Filene blir sende til Mesterbrevnemnda med ein gong du lastar dei opp. Saksbehandlar vurderer om dokumentasjonen er tilstrekkeleg.",
          "upload_unavailable": "Søknaden tek ikkje imot fleire dokument no. Kontakt oss på post@mesterbrev.no om du treng hjelp.",
          "file_help": "PDF, JPG, PNG, TIFF eller Word (DOCX) · Maks 25 MB per fil",
          "existing_files": "Dokument i denne kategorien som er sende inn",
          "received_at": "Motteke %{date}",
          "history": "Tidlegare innsendt og opplysningar om søknaden"
        },
        "deficiencies": {
          "title": "Dette manglar i søknaden din",
          "intro": "Saksbehandlaren treng meir frå deg før søknaden kan handsamast ferdig. Send inn det som står her.",
          "documents_label": "Dokument vi ber om",
          "note_label": "Frå saksbehandlaren",
          "due_at": "Frist: %{date}",
          "no_due_at": "Ingen frist er sett.",
          "overdue": "Fristen er gått ut. Send inn så snart du kan – vi tek framleis imot dokumenta.",
          "how_to": "Last opp dokumenta her. Saksbehandlaren får dei med ein gong. Er noko uklart, ta kontakt på post@mesterbrev.no."
        },
        "issued_documents_heading": "Dine offisielle dokument",
        "no_issued_documents": "Ingen offisielle dokument er utferda enno.",
        "shared_documents_heading": "Delt med deg",
        "download": "Last ned",
        "preview": "Førehandsvis",
        "download_document": "Last ned %{document}",
        "preview_document": "Førehandsvis %{document}",
        "requirement_response": {
          "title": "Dokumentasjon til søknaden",
          "intro": "Her ser du kva sakshandsamaren har bede om. Last opp dokumenta til rett krav.",
          "received": "Dokumentasjon motteken",
          "received_hint": "Sakshandsamaren vurderer svaret. Du kan framleis leggje til fleire dokument her."
        }
      },
      "form": {
        "kind_label": "Søknadstype",
        "trade_label": "Fag",
        "trade_placeholder": "Vel fag",
        "kind_placeholder": "Vel søknadstype",
        "grounds_label": "Grunngjeving for særlege grunnar",
        "grounds_placeholder": "Beskriv grunnlaget for dispensasjon",
        "save_draft": "Lagre utkast",
        "saving": "Lagrar…",
        "saved": "Lagra"
      },
      "kinds": {
        "ordinary_grant": "Mesterbrev – utdanning eller innvilga fritak",
        "prior_learning_assessment": "Realkompetansevurdering",
        "equivalent_education_exemption": "Anna utdanning / fritak",
        "foreign_qualification": "Mesterkvalifikasjon frå andre land",
        "special_grounds_dispensation": "Særlege grunnar (dispensasjon)",
        "master_certificate_with_exemption_letter": "Mesterbrev med innvilga fritak",
        "exemption_from_master_education": "Fritak for meisterutdanning"
      },
      "chooser": {
        "heading": "Vel søknadsskjema",
        "instruction": "Kryss av for å kome til riktig søknadsskjema.",
        "unavailable": "Denne søknadstypen er ikkje tilgjengeleg for augeblinken",
        "fee_from": "frå %{amount}",
        "options": {
          "ordinary_grant": {
            "label": "Mesterbrev – utdanning eller innvilga fritak",
            "examples": "For deg som har meisterutdanning, anna godkjend utdanning eller eit brev om innvilga fritak. Du kan kombinere fleire grunnlag i same søknad."
          },
          "equivalent_education_exemption": {
            "label": "Andre godkjende utdanningar",
            "examples": "Fagskole, Norges eiendomsakademi, bachelorstudium"
          },
          "master_certificate_with_exemption_letter": {
            "label": "Søknad om mesterbrev med brev om innvilga fritak for meisterutdanninga",
            "examples": ""
          },
          "exemption_from_master_education": {
            "label": "Søknad om fritak for meisterutdanning",
            "examples": "For deg som søkjer om nytt fritak frå heile eller delar av meisterutdanninga. Har du allereie fått fritak og skal søkje mesterbrev, vel du felles søknad om mesterbrev."
          },
          "foreign_qualification": {
            "label": "Søknad om mesterbrev med bakgrunn i meisterkvalifikasjon frå andre land",
            "examples": "Du dokumenterer meisterkvalifikasjonen frå eit anna land, studieplanen og praksisen din."
          },
          "prior_learning_assessment": {
            "label": "Realkompetanse",
            "examples": "For deg som søkjer på grunnlag av praksis og realkompetanse. Søknaden omfattar praksis i faget, leiarpraksis og eigenvurdering."
          }
        }
      },
      "states": {
        "draft": "Utkast",
        "submitted": "Innsendt",
        "under_review": "Under behandling",
        "awaiting_documentation": "Ventar på dokumentasjon",
        "ready_for_decision": "Klar for vedtak",
        "awaiting_board": "Ventar på nemnda",
        "decided": "Avgjort",
        "closed": "Avslutta",
        "withdrawn": "Trekt",
        "appeal_under_review": "Klage under behandling",
        "awaiting_payment": "Ventar på betaling"
      },
      "payment": {
        "heading": "Betal behandlingsgebyr",
        "explanation": "Søknaden er klar til innsending. Betal behandlingsgebyret for å sende han til behandling.",
        "fee_label": "Behandlingsgebyr: %{amount}",
        "pay_action": "Betal behandlingsgebyr",
        "retry_message": "Betalinga vart ikkje fullført. Prøv på nytt for å sende inn søknaden.",
        "paid_confirmation": "Behandlingsgebyret er betalt. Søknaden er sendt til behandling."
      },
      "errors": {
        "kind_blank": "Søknadstype må veljast",
        "required": "Dette feltet er påkravd",
        "email_invalid": "Oppgi ei gyldig e-postadresse",
        "phone_invalid": "Oppgi eit gyldig telefonnummer",
        "date_future": "Dato kan ikkje vere i framtida",
        "at_least_one": "Vel minst eitt alternativ",
        "year_range": "Frå-år kan ikkje vere etter til-år",
        "trade_blank": "Fag må veljast",
        "kind_invalid": "Ugyldig søknadstype",
        "trade_not_found": "Faget vart ikkje funne",
        "not_in_draft": "Søknaden kan ikkje redigerast i noverande tilstand",
        "submission_failed": "Innsending mislykkast — sjekk at alle påkravde felt er fylte ut",
        "withdraw_failed": "Tilbaketrekking mislykkast",
        "missing_required_fields": "Manglar påkravde felt for denne søknadstypen",
        "entry_needs_document": "Kvar oppføring må ha minst eitt vedlegg.",
        "practice_label_required": "Oppgi arbeidsstad eller namn på eiga bedrift.",
        "practice_year_required": "Oppgi både startår og sluttår.",
        "practice_year_future": "Årstal kan ikkje vere i framtida.",
        "practice_year_min": "Oppgi eit årstal med fire siffer, til dømes 2014.",
        "practice_month_required": "Vel månad.",
        "practice_date_required": "Oppgi dato. Sluttdato kan berre utelatast når praksisen held fram.",
        "practice_date_invalid": "Oppgi ein gyldig dato. Pågåande praksis skal ikkje ha sluttdato.",
        "practice_role_invalid": "Oppgi rolle som tekst med høgst 200 teikn.",
        "practice_percentage_invalid": "Oppgi ein stillingsprosent over 0 og høgst 100.",
        "practice_metadata_invalid": "Kontroller rolle og stillingsprosent. Rolla kan ha høgst 200 teikn, og stillingsprosenten må vere over 0 og høgst 100.",
        "practice_save_failed": "Praksisen vart ikkje lagra. Prøv igjen før du går vidare.",
        "practice_date_future": "Datoen kan ikkje vere i framtida.",
        "practice_period_order": "Frå-dato kan ikkje vere etter til-dato.",
        "practice_period_future": "Perioden kan ikkje slutte i framtida."
      },
      "exemption_scope": {
        "options": {
          "one_of_three": "Eitt av tre fagområde",
          "two_of_three": "To av tre fagområde",
          "three_of_three": "Alle tre fagområda"
        },
        "required": "Vel kor mange fagområde du søkjer fritak for."
      },
      "review": {
        "status_heading": "Status",
        "summary": {
          "heading": "Dette sender du inn",
          "person": "Person",
          "trade": "Fag",
          "exam_date": "Dato for bestått prøve",
          "education": "Utdanning",
          "practice": "Praksis",
          "leadership_practice": "Praksis som næringsdrivande eller leiar",
          "third_party_consent": "Samtykke til kontroll hos tredjepart",
          "answer_yes": "Ja",
          "answer_no": "Nei",
          "documents": "Dokument",
          "fee": "Behandlingsgebyr",
          "missing_label": "Manglar:",
          "none": "Ikkje oppgitt"
        }
      },
      "receipt": {
        "title": "Kvittering",
        "banner": "Søknaden er sendt inn.",
        "submitted_at": "Sendt inn",
        "fee_paid": "Behandlingsgebyr betalt",
        "paid_at": "Betalingsdato",
        "next_steps": "Vi har motteke søknaden din. Du får beskjed under Meldingar når saka er behandla.",
        "messages_link": "Gå til Meldingar"
      },
      "decision": {
        "title": "Vedtak",
        "outcome": "Utfall",
        "decided_by_body": "Vedtaksorgan",
        "issued_at": "Vedtaksdato",
        "notified_at": "Du fekk beskjed",
        "appeal_deadline_at": "Klagefrist",
        "appeal_guidance": "Du kan klage på vedtaket. Fristen er tre veker frå du fekk beskjed om vedtaket. Klagen sender du til Mesterbrevnemnda, som førebur saka for Klagenemnda for mesterbrev. Vedtaksbrevet forklarer korleis du klagar og kva rett du har til innsyn i saka.",
        "documents_hint": "Vedtaksbrevet ligg under «Dine offisielle dokument» lenger nede på sida.",
        "outcomes": {
          "granted": "Innvilga",
          "partially_granted": "Delvis innvilga",
          "denied": "Avslått",
          "returned": "Returnert",
          "written_off": "Henlagd",
          "upheld": "Stadfesta",
          "overturned": "Omgjort",
          "partially_upheld": "Delvis stadfesta"
        },
        "bodies": {
          "secretariat": "Sekretariatet",
          "board": "Nemnda",
          "appeals_board": "Klagenemnda"
        }
      },
      "branch": {
        "exemption_count": "Tal på fritak",
        "institution": "Utdanningsinstitusjon",
        "grade": "Karakter",
        "origin_country": "Opphavsland",
        "translation_provided": "Omsetjing vedlagt",
        "self_assessment_uploaded": "Eigenvurdering lasta opp",
        "grounds": "Grunngjeving"
      },
      "documents": {
        "delete": "Slett",
        "states": {
          "received": "Motteke",
          "processing": "Vert behandla",
          "archived": "Arkivert",
          "failed": "Feila"
        },
        "bundle": {
          "empty": "Ingen dokument lasta opp endå.",
          "upload": "Last opp dokument",
          "choose": "Vel filer",
          "add": "Legg til dokument",
          "drop_hint": "eller dra éi eller fleire filer hit",
          "open": "Opne",
          "uploaded_count": {
            "one": "Eitt dokument lasta opp",
            "other": "%{count} dokument lasta opp"
          },
          "uploaded": "Lasta opp",
          "uploading": "Lastar opp…",
          "received": "%{filename} er motteken."
        },
        "errors": {
          "content_type_not_allowed": "Filtypen er ikkje tillaten.",
          "file_too_large": "Fila er for stor.",
          "bundle_full": "Maksimalt tal på filer er nådd.",
          "upload_failed": "Opplastinga mislykkast.",
          "save_before_upload": "Opplysningane vart ikkje lagra. Prøv å laste opp på nytt.",
          "delete_failed": "Sletting mislukkast."
        },
        "kinds": {
          "practice_certificate": "Praksisattest",
          "diploma": "Vitnemål",
          "decision_pdf": "Vedtak (PDF)",
          "appeal_filing": "Klage",
          "board_minutes": "Møteprotokoll",
          "application_attachment": "Søknadsvedlegg",
          "prior_notice_pdf": "Førehandsvarsel (PDF)",
          "preliminary_response_pdf": "Førebels svar (PDF)",
          "correspondence": "Korrespondanse",
          "assessment_note": "Vurderingsnotat",
          "master_certificate": "Mesterbrev",
          "application_summary": "Søknadssamandrag",
          "business_registration": "Næringsoppgåve/næringsspesifikasjon/årsrekneskap",
          "company_certificate": "Firmaattest",
          "course_certificate": "Kurs og utdanning",
          "trade_certificate": "Fag-/sveinebrev",
          "self_assessment": "Eigenvurdering",
          "documentation_request_letter": "Mangelbrev",
          "closure_letter": "Avslutningsbrev"
        },
        "upload": "Last opp"
      },
      "egenvurdering": {
        "business": {
          "guidance": "Skildra kompetansen du har opparbeidd i bedriftsleiing, målt mot læringsutbytta i studieplanen. Vel modulane eigenvurderinga di dekkjer."
        },
        "leadership": {
          "guidance": "Skildra kompetansen du har opparbeidd i fagleg leiing, målt mot læringsutbytta i studieplanen."
        },
        "specialization": {
          "guidance": "Skildra kompetansen du har opparbeidd i fagleg fordjuping for meisterfaget, målt mot læringsutbytta i studieplanen."
        },
        "modules": {
          "organisation_leadership_administration": "Organisasjon, leiing og administrasjon",
          "economy_management": "Økonomistyring",
          "marketing_management": "Marknadsføringsleiing",
          "professional_leadership": "Fagleg leiing",
          "professional_specialization": "Fagleg fordjuping"
        }
      },
      "egenerklaering": {
        "confirm_label": "Eg stadfestar herved at:",
        "point_read_forskrift": "eg har lese forskrift om søknad om meisterbrev på bakgrunn av realkompetanse",
        "point_studied_outcomes": "eg har sett meg inn i læreplanane sine læringsutbytte og hovudtema",
        "point_covers_roles": "eg i eigenvurderinga mi skildrar eiga erfaring og kompetanse i faget både som utøvande og næringsdrivande eller leiar, med fagleg og forretningsmessig ansvar",
        "point_docs_correct": "dokumentasjonen eg har lagt ved søknaden er korrekt",
        "point_plagiarism_check": "at dokumentasjonen eg har levert kan kontrollerast ved «plagiatkontroll»",
        "third_party_label": "Eg gir Meisterbrevnemnda fullmakt til eventuelt å kontakte tredjepart for å verifisere dokumentasjonen som er vedlagt min søknad om meisterbrev.",
        "consequence": "Dersom det er gitt uriktige opplysningar i søknaden vil søknaden kunne avslåast.",
        "confirmation_required": "Du må stadfeste eigenerklæringa for å gå vidare.",
        "consent_required": "Du må gi samtykke til kontroll hos tredjepart for å gå vidare."
      },
      "realkompetanse": {
        "fields": {
          "arbeidssted": "Arbeidsstad",
          "fra_aar": "Frå år",
          "til_aar": "Til år",
          "from_date": "Frå dato",
          "to_date": "Til dato",
          "firma": "Firma",
          "aar": "År",
          "beskrivelse": "Skildring",
          "module": "Vel modul",
          "role": "Rolle"
        },
        "roles": {
          "self_employed": "Næringsdrivande",
          "leader": "Leiar"
        },
        "self_assessment": {
          "template_required": "Du må bruke malen frå Mesterbrevnemnda når du skriv eigenvurderinga. Malen blir tilgjengeleg her når han er klar.",
          "supplementary_heading": "Supplerande dokumentasjon",
          "supplementary_description": "Du kan også leggje ved dokumentasjon på relevante kurs, utdanning og andre opplysningar."
        }
      },
      "entry": {
        "add": "Legg til",
        "remove": "Fjern",
        "empty": "Ingen dokument lasta opp enno.",
        "attachment_count": "%{count} vedlegg",
        "add_title": "Legg til oppføring",
        "cancel": "Avbryt"
      },
      "guidance": {
        "personal_and_declaration": "Kontroller at personopplysningane stemmer før du stadfestar eigenerklæringa.",
        "trade_and_practice": "Last opp fag- eller sveinebrevet ditt og attestar som dokumenterer praksisen i faget, jf. forskrifta § 2 a–b.",
        "leadership_practice": "Registrer praksis som næringsdrivande eller leiar frå dei siste ti åra. Legg ved minst eitt relevant dokument for kvar oppføring, til dømes firmaattest, næringsoppgåve eller attest, jf. forskrifta § 2 c.",
        "self_assessment": "Fyll ut eigenvurderinga for bedriftsleiing, fagleg leiing og fagleg fordjuping, jf. forskrifta § 2 d. Legg ved eigenvurderinga og dokumentasjonen som høyrer til kvart fagområde.",
        "practice_employed": "Krav til praksis, jf. forskrift om søknad om mesterbrev på bakgrunn av realkompetanse pkt. 2b. Praksiskrav er 2 års praksis i faget etter bestått fag-/svenneprøve, alternativt 6 års praksis i faget. Praksis som ansatt dokumenteres med attest fra arbeidsgiver. Fyll ut feltene på nytt for hvert arbeidssted.",
        "business_registration": "Krav til praksis som næringsdrivende eller leder, jf. pkt. 2c. Last opp næringsoppgaver (del 2) for 6 av de siste 10 årene for bedriften du har hatt forretningsmessig ansvar i.",
        "company_certificate": "Last opp firmaattester/registerutskrift fra Brønnøysundregisteret for 6 av de siste 10 årene — samme år og bedrift som næringsoppgavene.",
        "self_assessment_business": "Egenvurdering i fagområdet bedriftsledelse (studieplanens tre moduler: organisasjon/ledelse/administrasjon, økonomistyring, markedsføringsledelse). Beskriv kompetansen din målt mot læringsutbyttene. Dokumentasjonen skal være nummerert og det skal henvises til den i egenvurderingen.",
        "self_assessment_leadership": "Egenvurdering i fagområdet faglig ledelse. Beskriv kompetansen du har opparbeidet gjennom yrkeserfaring som leder, målt mot læringsutbyttene i studieplanen.",
        "self_assessment_specialization": "Egenvurdering i fagområdet faglig fordypning (tilpasset det enkelte mesterfag). Beskriv kompetansen målt mot læringsutbyttene i studieplanen.",
        "course_certificate": "Oppgi eventuelle kurs og utdanninger som er relevante for søknaden. Alle kurs/utdanninger må dokumenteres med beskrivelse av innhold og bevis på gjennomføring; for utdanninger legg ved studieplaner og karakterutskrift eller vitnemål.",
        "other_relevant_information": "Her kan du laste opp annen dokumentasjon som du mener er relevant for søknaden."
      },
      "unified": {
        "name": "Namn",
        "contact": "Kontaktopplysningar",
        "required": "Påkravd"
      }
    },
    "account": {
      "mastership_states": {
        "awaiting_first_fee": "Ventar på første årsgebyr",
        "granted": "Aktivt",
        "lapsed": "Bortfalle",
        "revoked": "Tilbakekalla",
        "revoked_administrative": "Tilbakekalla",
        "deceased": "Avslutta",
        "passive": "Passivt"
      },
      "awaiting_first_fee_body": "Søknaden er innvilga. Mesterbrevet blir aktivt når betalinga av første årsgebyr er registrert. Fakturaen blir send separat.",
      "title": "Mine opplysningar",
      "name_label": "Namn",
      "masterships_heading": {
        "one": "Meisterbrevet mitt",
        "other": "Meisterbreva mine"
      },
      "no_masterships": "Du har ingen registrerte meisterbrev.",
      "no_masterships_subtitle": "Når du har fått eit meisterbrev, vert det vist her.",
      "preferences_heading": "Preferansane mine",
      "notification_channel_label": "Føretrekt kanal for varsel",
      "notification_channel_hint": "Gjeld e-post og SMS. Reservasjon i Kontakt- og reservasjonsregisteret gjeld uansett.",
      "notification_channel_none": "Inga preferanse",
      "notification_channel_email": "E-post",
      "notification_channel_sms": "SMS",
      "notification_channel_saved": "Lagra",
      "notification_channel_error": "Kunne ikkje lagre varslingskanalen. Prøv igjen.",
      "register_reservation": {
        "heading": "Oppføring i Mesterregisteret",
        "explanation": "Mesterregisteret er eit offentleg søkbart register over meistrar. Du kan reservere deg mot å stå oppført. Reservasjonen gjeld til du fjernar han, og påverkar ikkje meisterbrevet ditt.",
        "status_listed": "Oppført i registeret",
        "status_not_listed": "Ikkje oppført i registeret",
        "status_reserved": "Reservert mot oppføring",
        "reserve": "Reserver meg mot oppføring",
        "unreserve": "Fjern reservasjonen",
        "error": "Kunne ikkje lagre reservasjonen. Prøv igjen."
      },
      "contact": {
        "heading": "Personopplysningar",
        "error_summary": "Rett opp desse felta før du lagrar",
        "register_explain": "Namn og adresse hentar vi frå Folkeregisteret, og dei kan ikkje endrast her. Stemmer noko ikkje, må du melde det til Folkeregisteret.",
        "register_missing": "Denne opplysninga har vi ikkje frå Folkeregisteret enno. Fyll henne inn her, så bruker vi henne.",
        "edit": "Rediger",
        "save": "Lagre",
        "cancel": "Avbryt",
        "saved": "Lagra",
        "error": "Kunne ikkje lagre. Kontroller felta og prøv igjen.",
        "empty": "—",
        "given_name": "Førenamn",
        "middle_name": "Mellomnamn",
        "family_name": "Etternamn",
        "street_address": "Adresse",
        "co_address": "C/O-adresse",
        "postcode": "Postnr",
        "city": "Poststad",
        "country": "Land",
        "email": "E-post",
        "mobile_number": "Mobilnummer",
        "country_code": "Landkode",
        "errors": {
          "invalid": "Dette ser ikkje rett ut. Sjekk kva du har skrive.",
          "blank": "Feltet må fyllast ut.",
          "too_long": "Teksten er for lang."
        }
      },
      "mastership_detail": {
        "master_number": "Meisternr",
        "granted_at": "Tildelt",
        "fee_paid_through": "Årsavgift betalt for",
        "svennebrev": "Sveinebrev"
      },
      "master_mark": {
        "heading": "Mestermerket",
        "body": "Som aktiv meister kan du laste ned mestermerket og bruke det i marknadsføringa di.",
        "download": "Last ned mestermerket"
      },
      "invoices_heading": "Fakturaer",
      "invoices_empty": "Du har ingen fakturaer.",
      "invoice_period": "År %{year}",
      "invoice_amount": "Beløp",
      "invoice_status": "Status",
      "invoice_due_on": "Forfall",
      "invoice_kid": "KID",
      "invoice_fag": "Fag",
      "invoice_download": "Last ned faktura (PDF)",
      "invoice_download_unavailable": "Faktura-PDF er ikkje tilgjengeleg.",
      "invoice_download_error": "Vi kunne ikkje hente fakturaen. Prøv igjen om litt.",
      "invoice_demo": {
        "title": "Demofaktura – ikkje eit betalingskrav",
        "body": "Dette er ei eksempelfil frå testmiljøet. Fakturareferanse: %{reference}"
      },
      "invoice_payment": {
        "paid": "Betalt",
        "credited": "Kreditert",
        "unpaid": "Ikkje betalt"
      }
    },
    "landing": {
      "can": {
        "apply": "Søkje om mesterbrev, eller om fritak og godkjenning av utdanning frå andre land.",
        "track": "Følgje søknaden din, laste opp dokumentasjon og lese vedtaket når det er fatta.",
        "company": "Melde frå om kva firma du er fagleg leiar for."
      },
      "idporten_note": "Du loggar inn med ID-porten. Vi hentar namn og adresse frå Folkeregisteret og kontaktopplysningar frå Kontaktregisteret — namn og adresse vert endra hos Folkeregisteret, e-post og mobilnummer kan du endre sjølv.",
      "title": "Mitt mesterbrev",
      "intro": "Velkomen til Mesterbrevnemndas sjølvbeteningsportal. Her kan du sjå meisterbreva dine og meldingar frå nemnda.",
      "login_cta": "Logg inn"
    },
    "dashboard": {
      "title": "Mi side",
      "greeting": "Hei, %{name}",
      "lede": {
        "new": "Her søkjer du om meisterbrev og følgjer saka di undervegs.",
        "applicant": "Her følgjer du søknaden din og beskjedar frå Mesterbrevnemnda.",
        "master": "Her finn du meisterbrevet ditt og beskjedar frå Mesterbrevnemnda."
      },
      "status": {
        "new_title": "Du har ingen søknadar enno",
        "new_body": "Her kan du søkje om meisterbrev, om fritak eller om godkjenning av utdanning frå andre land. Utkastet vert lagra automatisk, så du kan fylle ut litt om gongen.",
        "start": "Start ny søknad",
        "draft_title": "Du har eit påbyrja utkast",
        "draft_progress": "%{done} av %{total} steg fullførte",
        "draft_continue": "Hald fram med utkastet",
        "draft_pay": "Betal gebyret og send inn",
        "in_progress_title": "Søknaden din er under behandling",
        "decided_title": "Søknaden din er avgjord",
        "documentation_title": "Vi ventar på dokumentasjon frå deg",
        "documentation_body": "Sakshandsamaren har bede om meir dokumentasjon. Last opp dokumentasjonen på søknaden.",
        "see_application": "Sjå søknaden og dokumenta dine",
        "stage": {
          "received": "Innsend",
          "in_review": "Under behandling",
          "decided": "Vedtak"
        },
        "stage_done": "Fullført",
        "stage_current": "Noverande steg",
        "master_title": "Meister i %{trade}",
        "master_number_short": "Meisternr %{number}",
        "granted_on": "Tildelt %{date}",
        "fee_paid_until": "Årsgebyr betalt til 31.12.%{year}",
        "fee_due": "Faktura for årsgebyr %{year} forfell %{date}.",
        "fee_unpaid": "Årsgebyret for %{year} er ikkje betalt.",
        "see_invoice": "Sjå faktura",
        "received_body": "Vi har motteke søknaden din. Du får beskjed under Meldingar når saka er behandla.",
        "decided_body": "Saka er avgjord. Vedtaket finn du under Mine dokument.",
        "case_number": "Saksnr. %{number}"
      },
      "tasks": {
        "heading": "Kva vil du gjere?",
        "start": "Start ny søknad",
        "start_sub": "Meisterbrev, fritak eller godkjenning av utdanning frå andre land",
        "continue_draft": "Hald fram med utkastet mitt",
        "continue_draft_sub": "%{done} av %{total} steg fullførte",
        "see_application": "Sjå søknaden min",
        "see_application_sub": "Status, dokument og meldingar på saka",
        "documentation": "Send inn etterspurd dokumentasjon",
        "documentation_sub": "Saksbehandlaren ventar på deg",
        "notifications": "Les meldingar",
        "notifications_sub": "Beskjedar frå Mesterbrevnemnda",
        "documents": "Dokumenta mine",
        "documents_sub": "Vedtak og brev vi har sendt deg",
        "applications": "Sjå søknadene mine",
        "applications_sub": "Tidlegare og pågåande søknader",
        "invoices": "Sjå fakturaer",
        "invoices_sub": "Årsgebyr med forfall og KID",
        "master_mark": "Last ned mestermerket",
        "master_mark_sub": "Bruk merket i marknadsføringa di som aktiv meister",
        "profile": "Sjå og endre opplysningane dine",
        "profile_sub": "Adresse, e-post, mobilnummer, varslingskanal og registeroppføring",
        "profile_sub_no_master": "Adresse, e-post, mobilnummer og varslingskanal",
        "company": "Meld firmatilknyting",
        "company_sub": "Meld frå om kva firma du er fagleg leiar for",
        "company_sub_no_master": "Krev registrert meisterbrev"
      }
    },
    "notifications": {
      "title": "Meldingar",
      "empty": "Du har ingen meldingar.",
      "empty_subtitle": "Når nemnda sender deg ei melding, vert ho vist her.",
      "mark_read": "Merk som lesen",
      "read_error": "Kunne ikkje merke meldinga som lesen. Prøv igjen med «Merk som lesen».",
      "mark_all_read": "Merk alle som lesne",
      "loading": "Hentar meldingar …",
      "menu_error": "Kunne ikkje oppdatere meldingane. Lukk menyen og prøv igjen.",
      "unread": "Ulesen",
      "context": {
        "application": "Søknad: %{kind}",
        "documentation_title": "Vi treng %{documents}",
        "document_title": "Nytt dokument: %{document}",
        "deadline": "Frist %{date}"
      },
      "titles": {
        "mastership": {
          "granted": "Meisterbrev tildelt",
          "lapsed": "Meisterbrev bortfalle"
        },
        "case": {
          "submitted": "Søknad motteken",
          "documentation_requested": "Vi treng dokumentasjon",
          "decided": "Søknaden er avgjord"
        },
        "document": {
          "shared": "Nytt dokument"
        },
        "fallback": "Ny melding"
      },
      "unread_badge": "%{count} ulesen",
      "templates": {
        "mastership": {
          "granted": "Meisterbrevet ditt er tildelt.",
          "lapsed": "Eitt av meisterbreva dine er bortfalle."
        },
        "case": {
          "submitted": "Søknaden din er motteken.",
          "documentation_requested": "Saksbehandlaren treng meir dokumentasjon frå deg.",
          "decided": "Søknaden din er avgjort."
        },
        "document": {
          "shared": "Eit nytt dokument er tilgjengeleg på Mi side."
        },
        "fallback": "Du har ei ny melding."
      }
    },
    "documents": {
      "title": "Dokumenta mine",
      "empty": "Du har ingen delte dokument.",
      "empty_subtitle": "Her samlar vi dokumenta Mesterbrevnemnda har delt med deg i sakene dine. Når nemnda deler eit dokument, finn du det her.",
      "case_link": "Gå til saka",
      "shared_on": "Delt %{date}",
      "case_types": {
        "application": "Søknad",
        "appeal": "Klage",
        "sanction": "Sanksjon",
        "change": "Endring",
        "access_request": "Innsynskrav"
      }
    },
    "nav": {
      "home": "Heim",
      "account": "Mi side",
      "notifications": "Meldingar",
      "company_membership": "Meld firmatilknyting",
      "documents": "Dokumenta mine",
      "back_to_min_side": "Tilbake til Mi side",
      "bell_label": {
        "one": "Meldingar, 1 ulesen",
        "other": "Meldingar, %{count} ulesne"
      }
    },
    "footer": {
      "org": "© %{year} Mesterbrevnemnda",
      "nav_label": "Botntekst",
      "personvern": "Personvernerklæring",
      "tilgjengelighet": "Tilgjengelegheitserklæring",
      "kontakt": "Kontakt oss",
      "kontakt_email": "post@mesterbrev.no"
    },
    "accessibility": {
      "title": "Tilgjengelegheitserklæring",
      "intro": "Mesterbrevnemnda arbeider for at «Mitt mesterbrev» og Mesterregisteret skal kunne brukast av alle. Denne sida skildrar kvar løysinga står i dag.",
      "status": {
        "heading": "Status",
        "body": "Løysinga er under utvikling og er enno ikkje fullt ut vurdert mot WCAG 2.1 nivå AA. Ei formell tilgjengelegheitserklæring blir publisert på uustatus.no når vurderinga er gjennomført."
      },
      "known": {
        "heading": "Kjende manglar",
        "body": "Vi kjenner til at enkelte sider manglar overskrift, at nokre skjemafelt kan vere vanskelege å bruke med tastatur åleine, og at kontrasten i enkelte statusmerke ikkje er kontrollert. Vi rettar dette fortløpande."
      },
      "feedback": {
        "heading": "Sei frå om noko ikkje verkar",
        "body": "Får du ikkje tak i informasjon eller utført noko du har rett til, vil vi gjerne høyre frå deg. Vi svarar så raskt vi kan, og hjelper deg vidare på ein annan måte i mellomtida.",
        "contact": "Kontakt: post@mesterbrev.no"
      }
    },
    "privacy": {
      "title": "Personvernerklæring",
      "intro": "Denne personvernerklæringa forklarar korleis Mesterbrevnemnda handsamar personopplysningar i søknadsportalen «Mitt mesterbrev», i sakshandsaminga og i det offentlege mesterregisteret.",
      "controller": {
        "heading": "Handsamingsansvarleg",
        "body": "Mesterbrevnemnda er handsamingsansvarleg for personopplysningane som blir handsama i denne løysinga. Nemnda er oppnemnd i medhald av lov om mesterbrev i handverk og anna næring (mesterbrevlova).",
        "contact": "Kontakt: post@mesterbrev.no. Har du spørsmål om personvern, kan du vende deg til oss på denne adressa."
      },
      "processing": {
        "heading": "Kva opplysningar vi handsamar, og kvifor",
        "login": "Innlogging. Du loggar inn med ID-porten, til dømes med BankID. Ved innlogging blir fødselsnummeret ditt brukt til å identifisere deg og til oppslag mot offentlege register. Vi lagrar fødselsnummeret kryptert, slik at vi kan halde opplysningane dine oppdaterte mot Folkeregisteret og kjenne deg att om du søkjer på nytt. Berre saksbehandlarar som treng det, kan sjå nummeret, og kvar visning blir logga.",
        "application": "Søknad om mesterbrev. Når du søkjer, handsamar vi opplysningane du sjølv oppgir: namn, kontaktopplysningar, utdanning, praksis og vedlagde dokument som vitnemål og praksisattestar. Føremålet er å handsame søknaden din etter mesterbrevlova med forskrifter. Handsaminga er nødvendig for å utøve offentleg mynde, jf. personvernforordninga artikkel 6 nr. 1 bokstav e.",
        "lookups": "Oppslag i offentlege register. For å sikre rette opplysningar hentar vi namn og adresse frå Folkeregisteret, og digital kontaktinformasjon og reservasjonsstatus frå Kontakt- og reservasjonsregisteret (KRR). Opplysningar om firma blir henta frå Einingsregisteret.",
        "register": "Det offentlege mesterregisteret. Når du har fått mesterbrev, blir namnet ditt, faget og eventuell firmatilknyting publisert i det offentlege mesterregisteret. Registeret gjer det mogleg for allmenta å kontrollere kven som har gyldig mesterbrev, jf. mesterbrevlova § 1.",
        "fees": "Gebyr og fakturering. Ved søknad betaler du behandlingsgebyr gjennom betalingsleverandøren vår. Meistrar blir fakturerte årleg gebyr, og namn, adresse og fakturaopplysningar blir handsama i rekneskapssystemet vårt. Lagring av rekneskapsmateriale følgjer bokføringslova.",
        "notifications": "Varsel. Vi sender deg varsel om saka di på e-post eller SMS. Har du reservert deg mot digital kommunikasjon i KRR, blir dette respektert, og du får informasjonen per brev.",
        "appeals": "Klagehandsaming. Klagar du på eit vedtak, blir klaga handsama etter forvaltningslova, og opplysningane i saka inngår i klagehandsaminga."
      },
      "retention": {
        "heading": "Arkivering, journalføring og lagringstid",
        "body": "Mesterbrevnemnda er eit forvaltningsorgan. Saksdokument blir journalførte og arkiverte i samsvar med arkivlovgivinga, og kan difor ikkje slettast sjølv om saka er avslutta. Opplysningar som ikkje er arkivpliktige, blir berre lagra så lenge det er nødvendig for føremålet."
      },
      "sharing": {
        "heading": "Kven vi deler opplysningar med",
        "body": "Vi bruker databehandlarar for drift av løysinga. Løysinga blir drifta i skytenester med lagring i Noreg. Arkivtenesta blir levert av Documaster, rekneskapstenesta av Tripletex, og betaling blir gjennomført av betalingsleverandøren vår. Databehandlarane handsamar opplysningar berre etter avtale med nemnda og ikkje for eigne føremål. Utover dette blir opplysningar berre utleverte der nemnda har rettsleg plikt til det, til dømes ved innsyn etter offentleglova, med dei unntaka som gjeld for teiepliktige opplysningar."
      },
      "rights": {
        "heading": "Rettane dine",
        "body": "Du har rett til innsyn i opplysningane vi handsamar om deg, og rett til å få retta urette opplysningar. Retten til sletting er avgrensa av arkiv- og journalføringsplikta. Du kan òg ha rett til avgrensing av handsaminga. Vend deg til kontaktpunktet over for å bruke rettane dine. Meiner du at handsaminga er i strid med regelverket, kan du klage til Datatilsynet."
      },
      "cookies": {
        "heading": "Informasjonskapslar (cookies)",
        "body": "Løysinga bruker berre éin nødvendig informasjonskapsel: ein sesjonskapsel som held deg innlogga. Han inneheld ikkje sporingsinformasjon og blir sletta når sesjonen blir avslutta. Vi bruker ingen analyse- eller marknadsføringskapslar."
      },
      "changes": {
        "heading": "Endringar",
        "body": "Denne erklæringa blir oppdatert ved endringar i handsaminga. Vesentlege endringar blir varsla i portalen."
      }
    },
    "errors": {
      "not_found": {
        "title": "Fann ikkje sida",
        "body": "Sida du leitar etter finst ikkje, eller ho er flytta.",
        "back": "Til Mi side"
      },
      "forbidden": {
        "title": "Ingen tilgang",
        "body": "Du har ikkje tilgang til denne sida.",
        "back": "Til Mi side"
      },
      "server_error": {
        "title": "Noko gjekk gale",
        "body": "Det oppstod ein uventa feil. Prøv igjen seinare.",
        "back": "Til Mi side"
      }
    },
    "company_membership": {
      "new": {
        "title": "Meld firmatilknyting",
        "intro": "Knyt eitt av faga dine til eit firma som fagleg leiar eller anna rolle.",
        "mastership_label": "Fag (meisterbrev)",
        "company_label": "Organisasjonsnummer",
        "company_hint": "Oppgi organisasjonsnummeret til firmaet (9 siffer).",
        "lookup_found": "Firma: %{name}",
        "lookup_pending": "Hentar firma frå Einingsregisteret …",
        "validation_summary": "Kontroller felta før du sender inn",
        "role_label": "Rolle",
        "position_label": "Stillingsprosent",
        "position_hint": "Del av full stilling, mellom 1 og 100.",
        "position_hint_optional": "Del av full stilling, mellom 1 og 100. Valfritt for denne rolla.",
        "submit": "Send inn",
        "cancel": "Avbryt",
        "select_placeholder": "Vel…",
        "no_masterships": "Du har ingen fag å knyte til eit firma.",
        "no_masterships_subtitle": "Du må ha minst eitt meisterbrev før du kan melde ei firmatilknyting.",
        "errors": {
          "required": "Feltet må fyllast ut.",
          "invalid_organization_number": "Skriv eit gyldig organisasjonsnummer. Kontroller sifra og prøv igjen.",
          "company_not_found": "Fann ikkje firmaet i Einingsregisteret.",
          "register_unavailable": "Einingsregisteret svarar ikkje no. Prøv igjen seinare.",
          "position_percent_range": "Stillingsprosenten må vere mellom 1 og 100.",
          "conflict": "Nokon andre endra denne firmatilknytinga medan du fylte ut. Last sida på nytt og prøv igjen.",
          "failed": "Vi klarte ikkje å registrere firmatilknytinga. Sjå om noko manglar i felta over."
        }
      },
      "flash": {
        "created": "Firmatilknyting registrert for %{company}"
      }
    }
  },
  "auth": {
    "failed": "Innlogging mislukkast.",
    "entra": {
      "no_account": "Du har ikkje tilgang til saksbehandlingsflata. Kontakt sekretariatet for å få oppretta ein brukar.",
      "identity_conflict": "Innlogginga kunne ikkje fullførast. Sekretariatet har fått beskjed og følgjer opp.",
      "user_cancelled": "Innlogginga vart avbroten. Prøv igjen."
    },
    "idporten": {
      "sign_in": "Logg inn med ID-porten",
      "acr_too_low": "Innloggingsnivået er for lågt. Prøv igjen med BankID eller anna godkjend metode.",
      "user_cancelled": "Innlogginga vart avbroten. Prøv igjen.",
      "logged_out": {
        "heading": "Du er logga ut",
        "body": "Du er no logga ut av Mitt mesterbrev.",
        "login_again": "Logg inn igjen"
      }
    }
  },
  "events": {
    "invoice": {
      "credit_reconciled": {
        "title": "Kreditering stadfesta i Tripletex"
      },
      "transfer_confirmed": {
        "title": "Tripletex-overføring avklart"
      },
      "issued": {
        "title": "Faktura utferda"
      },
      "sent": {
        "title": "Faktura sendt"
      },
      "paid": {
        "title": "Faktura betalt"
      },
      "reconciled": {
        "title": "Faktura avstemt"
      },
      "credited": {
        "title": "Faktura kreditert"
      },
      "error": {
        "title": "Fakturafeil"
      }
    },
    "billing_run": {
      "prepared": {
        "title": "Fakturagrunnlag kontrollert"
      },
      "started": {
        "title": "Fakturakøyring starta"
      },
      "completed": {
        "title": "Fakturakøyring ferdig behandla"
      }
    },
    "case": {
      "deficiency_reviewed": {
        "title": "Dokumentasjonskrav behandla"
      },
      "deficiency_supplement_requested": {
        "title": "Supplerande dokumentasjon etterspurt"
      },
      "assessment_saved": {
        "title": "Vurdering lagra"
      },
      "created": {
        "title": "Sak oppretta"
      },
      "submitted": {
        "title": "Søknad send inn"
      },
      "picked_up": {
        "title": "Sak teken til behandling"
      },
      "deficiency_registered": {
        "title": "Mangel registrert"
      },
      "documentation_requested": {
        "title": "Dokumentasjon etterspurd"
      },
      "documentation_received": {
        "title": "Dokumentasjon motteken"
      },
      "decision_prepared": {
        "title": "Vedtak førebudd"
      },
      "referred_to_board": {
        "title": "Vist til nemnda"
      },
      "advance_notice_sent": {
        "title": "Førehandsvarsel sendt"
      },
      "decided": {
        "title": "Vedtak fatta"
      },
      "notified": {
        "title": "Underretning registrert"
      },
      "closed": {
        "title": "Sak avslutta"
      },
      "withdrawn": {
        "title": "Søknad trekt"
      },
      "written_off": {
        "title": "Sak avskriven"
      },
      "appeal_filed": {
        "title": "Klage registrert"
      },
      "reopened": {
        "title": "Sak gjenopna"
      },
      "transitioned": {
        "title": "Statusendring"
      },
      "list_exported": {
        "title": "Saksliste eksportert"
      },
      "sanction_closure_prepared": {
        "title": "Avslutningsbrev klargjort"
      },
      "sanction_closure_review_requested": {
        "title": "Avslutningsbrev sendt til godkjenning"
      },
      "sanction_closure_approved": {
        "title": "Avslutningsbrev godkjent"
      },
      "sanction_closure_returned": {
        "title": "Avslutningsbrev returnert for endringar"
      },
      "sanction_closure_dispatched": {
        "title": "Avslutningsbrev sendt og saka avslutta"
      },
      "sanction_closure_cancelled": {
        "title": "Klargjering av avslutningsbrev avbroten"
      },
      "sanction_response_recorded": {
        "title": "Tilsvar registrert"
      },
      "sanction_notice_review_requested": {
        "title": "Varsel sendt til godkjenning"
      },
      "sanction_notice_approved": {
        "title": "Varsel godkjent"
      },
      "sanction_notice_returned": {
        "title": "Varsel returnert for endringar"
      },
      "sanction_updated": {
        "title": "Saksgrunnlag eller oppfølging oppdatert"
      },
      "sanction_notice_recorded": {
        "title": "Utsending av varsel om mogleg gebyr registrert"
      },
      "sanction_closed": {
        "title": "Sak om ulovleg bruk avslutta utan gebyr"
      }
    },
    "document": {
      "withdrawn": {
        "title": "Dokument trekt"
      },
      "issued": {
        "title": "Dokument utferda"
      },
      "uploaded": {
        "title": "Dokument lasta opp"
      },
      "shared_with_applicant": {
        "title": "Dokument delt med søkjar"
      },
      "unshared_with_applicant": {
        "title": "Deling med søkjar fjerna"
      },
      "archival_started": {
        "title": "Arkivering av dokument starta"
      },
      "archived": {
        "title": "Dokument arkivert"
      },
      "archival_failed": {
        "title": "Arkivering av dokument mislukka"
      }
    },
    "comment": {
      "added": {
        "title": "Kommentar lagd til"
      }
    },
    "user": {
      "passivated": {
        "title": "Sett passiv"
      },
      "reactivated": {
        "title": "Reaktivert"
      },
      "passivation_scheduled": {
        "title": "Passivering planlagd"
      },
      "passivation_rescheduled": {
        "title": "Passivering omplanlagd"
      },
      "passivation_cancelled": {
        "title": "Planlagd passivering avbroten"
      },
      "data_exported": {
        "title": "Persondata eksportert"
      },
      "register_opt_out_changed": {
        "title": "Registerreservasjon endra"
      },
      "national_id_recorded": {
        "title": "Fødselsnummer registrert"
      },
      "national_id_revealed": {
        "title": "Fødselsnummer vist"
      },
      "national_id_copied": {
        "title": "Fødselsnummer kopiert"
      },
      "national_id_access_refused": {
        "title": "Innsyn i fødselsnummer avvist"
      }
    },
    "mastership": {
      "became_current": {
        "title": "Aktiv i Mesterregisteret"
      },
      "demand_sent": {
        "title": "Krav om årsavgift sendt"
      },
      "fee_paid_still_lapsed": {
        "title": "Årsavgift betalt – framleis bortfalt"
      },
      "lapsed": {
        "title": "Meisterbrev bortfalle"
      },
      "marked_deceased": {
        "title": "Markert som død"
      },
      "reinstated": {
        "title": "Meisterbrev gjeninnsett"
      },
      "revoked": {
        "title": "Meisterbrev tilbakekalla"
      },
      "revoked_administrative": {
        "title": "Meisterbrev tilbakekalla (administrativt)"
      }
    },
    "archive": {
      "case_opened": {
        "title": "Saksmappe oppretta i arkivet"
      },
      "case_attached": {
        "title": "Kopla til eksisterande saksmappe"
      },
      "case_closed": {
        "title": "Saksmappe avslutta i arkivet"
      },
      "case_reopened": {
        "title": "Saksmappe gjenopna i arkivet"
      },
      "bundle_stored": {
        "title": "Dokumentpakke journalført"
      },
      "records_pulled": {
        "title": "Journalpostar henta frå arkivet"
      },
      "legacy_import": {
        "title": "Historisk arkivsak importert"
      },
      "sync_failed": {
        "title": "Arkivering mislukka"
      },
      "sync_retried": {
        "title": "Arkivering prøvd på nytt"
      },
      "sync_drift_detected": {
        "title": "Avvik mot arkivet oppdaga"
      },
      "dead_letter": {
        "title": "Arkivering sett til manuell oppfølging"
      }
    },
    "auth": {
      "login_succeeded": {
        "title": "Logga inn"
      },
      "logged_out": {
        "title": "Logga ut"
      },
      "login_failed": {
        "title": "Innlogging mislukka"
      },
      "acr_too_low": {
        "title": "Innlogging avvist – for lågt tryggleiksnivå"
      },
      "token_validation_failed": {
        "title": "Tokenvalidering mislukka"
      },
      "m2m_token_minted": {
        "title": "Maskinporten-token utferda"
      }
    },
    "company": {
      "brreg_snapshot_updated": {
        "title": "Firmaopplysningar oppdaterte frå Einingsregisteret"
      }
    },
    "company_membership": {
      "created": {
        "title": "Firmatilknyting registrert"
      },
      "revoked": {
        "title": "Firmatilknyting avslutta"
      }
    },
    "notification": {
      "dispatched": {
        "title": "Varsel sendt"
      },
      "delivered": {
        "title": "Varsel levert"
      },
      "failed": {
        "title": "Varsel mislukka"
      },
      "retried": {
        "title": "Varsel prøvd sendt på nytt"
      },
      "routed_to_paper": {
        "title": "Varsel sendt til papirutsending"
      }
    },
    "payment": {
      "requested": {
        "title": "Krav om behandlingsgebyr oppretta"
      },
      "captured": {
        "title": "Behandlingsgebyr betalt"
      },
      "manually_registered": {
        "title": "Behandlingsgebyr registrert manuelt"
      },
      "credited": {
        "title": "Behandlingsgebyr refundert"
      },
      "capture_orphaned": {
        "title": "Betaling sett til manuell oppfølging"
      }
    },
    "review_task": {
      "created": {
        "title": "Kontrolloppgåve oppretta"
      },
      "resolved": {
        "title": "Kontrolloppgåve løyst"
      }
    },
    "public_register": {
      "refresh_started": {
        "title": "Oppdatering av Mesterregisteret starta"
      },
      "refresh_completed": {
        "title": "Oppdatering av Mesterregisteret fullført"
      }
    },
    "register": {
      "brreg_sweep_completed": {
        "title": "Registersjekk mot Einingsregisteret fullført"
      },
      "freg_sweep_completed": {
        "title": "Registersjekk mot Folkeregisteret fullført"
      }
    },
    "municipality": {
      "list_refreshed": {
        "title": "Kommuneliste oppdatert"
      }
    },
    "trade_group": {
      "list_refreshed": {
        "title": "Faggruppeliste oppdatert"
      }
    },
    "report": {
      "exported": {
        "title": "Rapport eksportert"
      }
    },
    "setting": {
      "changed": {
        "title": "Innstilling endra"
      }
    },
    "system": {
      "bootstrap": {
        "title": "Systemet initialisert"
      },
      "config_validated": {
        "title": "Konfigurasjon validert"
      }
    },
    "verifier": {
      "ok": {
        "title": "Hendingslogg verifisert"
      },
      "break_detected": {
        "title": "Brot i hendingsloggen oppdaga"
      }
    },
    "letter": {
      "dispatch_requested": {
        "title": "Brev publisert og varsling bestilt"
      },
      "paper_sent": {
        "title": "Papirutsending registrert"
      },
      "receipt_recorded": {
        "title": "Brevmottak registrert"
      },
      "draft_saved": {
        "title": "Brevutkast lagra"
      }
    },
    "document_template": {
      "changed": {
        "title": "Brevmal endra"
      }
    }
  },
  "locale_name": {
    "nb": "Norsk (bokmål)",
    "nn": "Norsk (nynorsk)",
    "en": "English"
  },
  "locale_switcher": {
    "label": "Vel språk"
  },
  "app": {
    "name": "Mesterbrev"
  },
  "common": {
    "skip_to_content": "Hopp til hovudinnhald",
    "errors": {
      "not_found": {
        "title": "Fann ikkje sida",
        "body": "Sida du leitar etter finst ikkje, eller ho er flytta.",
        "back": "Til framsida"
      }
    }
  },
  "greeting": "Hei %{name}",
  "items": {
    "one": "%{count} element",
    "other": "%{count} element"
  },
  "chrome": {
    "combobox": {
      "open": "Vis val for %{label}",
      "close": "Skjul val for %{label}",
      "clear": "Nullstill %{label}",
      "remove": "Fjern %{label}",
      "results": "Tilgjengelege val: %{count}.",
      "selected": "Valt: %{count}."
    },
    "dialog": {
      "label": "Dialogvindauge",
      "panel_label": "Sidepanel"
    },
    "table": {
      "select_all": "Vel alle rader",
      "select_row": "Vel rad %{id}",
      "resize_column": "Endre breidda på kolonnen %{column}",
      "scroll_hint": "Rull sidelengs for å sjå alle kolonnane."
    },
    "document_strip": {
      "previous": "Vis tidlegare dokument",
      "next": "Vis fleire dokument"
    },
    "topbar": {
      "search_placeholder": "Søk saker, personar, føretak…",
      "search_hint": "Søk i saker og sider",
      "search_shortcut": "⌘ K",
      "search_no_results": "Ingen treff for «%{query}»",
      "search_group_cases": "Saker",
      "search_group_people": "Personar",
      "search_group_companies": "Føretak",
      "search_group_documents": "Dokument",
      "search_group_pages": "Gå til",
      "user_menu_label": "Brukarmeny",
      "display_settings": "Visning og tema",
      "display_settings_readability": "Visning",
      "help": "Hjelp og lovgrunnlag",
      "profile": "Min profil",
      "switch_role": "Byt rolle/eining",
      "sign_out": "Logg ut"
    },
    "sidebar": {
      "collapse": "Gøym meny",
      "expand": "Vis meny",
      "resize": "Endre breidda på menyen"
    },
    "nav": {
      "label": "Navigasjon",
      "groups": {
        "cases": "Saksbehandling"
      }
    },
    "toast": {
      "dismiss": "Lukk varsel"
    },
    "breadcrumb": {
      "label": "Brødsmule"
    },
    "actions": {
      "close": "Lukk",
      "reset_to_default": "Tilbakestill til standard"
    },
    "filter_bar": {
      "filters": "Filter",
      "clear_all": "Nullstill filter"
    }
  },
  "register": {
    "brand_subtitle": "Mesterregisteret",
    "retired": {
      "title": "Mesterregisteret er flytta",
      "body": "Denne visinga av Mesterregisteret er avvikla. Du finn registeret på mesterbrev.no.",
      "link": "Gå til mesterbrev.no"
    },
    "landing": {
      "title": "Mesterregisteret",
      "intro": "Søk etter meistrar og meisterbedrifter registrerte hos Mesterbrevnemnda.",
      "search_cta": "Søk i registeret"
    },
    "errors": {
      "not_found": {
        "title": "Fann ikkje sida",
        "body": "Sida du leitar etter finst ikkje, eller ho er flytta.",
        "back": "Til framsida"
      }
    },
    "trade_groups": {
      "byggfag": "Byggfag",
      "mat_og_servicefag": "Mat- og servicefag",
      "designfag": "Designfag",
      "ovrige_handverksfag": "Øvrige handverksfag"
    },
    "lookup": {
      "title": "Søk i Mesterregisteret",
      "intro": "Søk etter meistrar og meisterbedrifter. Du kan filtrere på fag, fagområde, kommune og fylke.",
      "search_label": "Søk",
      "search_placeholder": "Namn, fag eller organisasjonsnummer",
      "search_hint": "Søk på namn, fag eller organisasjonsnummer.",
      "kind_label": "Type",
      "kind_all": "Alle",
      "kind_mester": "Meister",
      "kind_mesterbedrift": "Meisterbedrift",
      "trade_group_label": "Fagområde",
      "trade_label": "Fag",
      "county_label": "Fylke",
      "municipality_label": "Kommune",
      "municipality_hint": "Vel fylke først",
      "facet_all": "Alle",
      "filters_heading": "Filter",
      "results_heading": "Treff",
      "result_count": "Viser %{shown} av om lag %{total} treff",
      "result_count_exact": "Viser %{shown} av %{total} treff",
      "load_more": "Vis fleire",
      "loading": "Lastar…",
      "col_name": "Namn",
      "col_kind": "Type",
      "col_trades": "Fag",
      "col_place": "Stad",
      "empty_title": "Ingen treff",
      "empty_subtitle": "Prøv eit anna søkeord eller fjern nokre filter.",
      "error_title": "Klarte ikkje å hente treff",
      "error_subtitle": "Noko gjekk gale. Prøv igjen.",
      "retry": "Prøv igjen",
      "view_details": "Vis detaljar",
      "back_to_results": "Tilbake til treff",
      "detail_kind": "Type",
      "detail_place": "Stad",
      "detail_trades": "Fag",
      "detail_trade_groups": "Fagområde",
      "detail_not_found_title": "Fann ikkje oppføringa",
      "detail_not_found_subtitle": "Oppføringa finst ikkje eller er ikkje lenger synleg i registeret."
    }
  },
  "design_forms": {
    "title": "Formelement",
    "intro": "Prøv felta med mus og tastatur. Bruk Tab for å sjå fokus. Alle felt skal fyllast ut med mindre dei er merkte «valfritt». Døma blir ikkje lagra.",
    "state": "Vis tilstand",
    "normal": "Normal",
    "error": "Feil",
    "readonly": "Skriveverna",
    "disabled": "Deaktivert",
    "readonly_hint": "Tekst kan markerast og kopierast. Nedtrekk, avkryssing og radioval er deaktiverte fordi dei ikkje støttar skrivevern.",
    "text": "Tekstfelt",
    "email": "E-postadresse",
    "email_hint": "Bruk ei adresse du les jamleg.",
    "email_error": "Skriv inn ei gyldig e-postadresse.",
    "native_select": "Nedtrekk – innebygd i nettlesaren",
    "custom_select": "Nedtrekk – eigen meny",
    "trade": "Fag",
    "trade_hint": "Vel faget du søkjer meisterbrev i.",
    "choose": "Vel fag",
    "carpenter": "Tømrarfaget",
    "plumber": "Røyrleggjarfaget",
    "trade_error": "Vel eit fag.",
    "textarea": "Tekstområde",
    "notes": "Tilleggsopplysningar (valfritt)",
    "notes_hint": "Ta med opplysningar som er relevante for søknaden.",
    "notes_error": "Kort ned teksten.",
    "widths": "Breidder tilpassa innhaldet",
    "postcode": "Postnummer",
    "phone": "Telefonnummer",
    "date": "Frå dato",
    "choices": "Avkryssing og radioval",
    "consent": "Eg stadfestar at opplysningane er rette.",
    "consent_hint": "Les gjennom opplysningane før du stadfestar.",
    "consent_error": "Du må stadfeste at opplysningane er rette.",
    "attachments": "Vel vedlegg (valfritt)",
    "select_all": "Vel alle vedlegg",
    "diploma": "Fagbrev",
    "practice": "Praksisattest",
    "radio_plain": "Radioval",
    "radio_cards": "Radiokort",
    "radio_hint": "Vel eitt alternativ. Bruk piltastane for å byte val.",
    "uploads": {
      "title": "Dokumentopplasting",
      "intro": "Prøv filveljaren, dra inn éi fil om gongen, eller slett eit dømevedlegg. Filene blir ikkje sende til serveren. Framdrift og feil er demonstrasjonstilstandar.",
      "compact": "Kompakt opplasting",
      "compact_hint": "For eitt bestemt dokument, som fagbrev eller vitnemål. Den opplasta fila erstattar filveljaren.",
      "list": "Vedleggsliste",
      "list_hint": "For praksisattestar og andre vedlegg. Dømet har plass til fem filer.",
      "empty": "Tom",
      "upload": "Last opp dokument",
      "choose": "Vel fil",
      "add": "Legg til eit dokument",
      "remove": "Slett",
      "drop_hint": "eller dra fila hit",
      "uploaded": "Lasta opp",
      "uploading": "Lastar opp…",
      "failure": "Opplastinga mislukkast. Prøv igjen."
    }
  },
  "design_product": {
    "reference_title": "Mesterbrev – profilreferanse",
    "reference_notice": "Her er temaet, komponentane og dei interaktive døma samla. Referansen bruker dei same komponentane som løysinga.",
    "reference_components": "Komponentgalleri",
    "reference_logo_label": "Mesternemnda",
    "reference_navigation": "Innhald i designreferansen",
    "reference_theme": "Felles tema",
    "reference_theme_hint": "Fargane nedanfor kjem frå det genererte Mesterbrev-temaet i Designsystemet. Kjelde for temaet er designsystemet.config.json.",
    "title": "Komponentar i bruk",
    "page_intro": "Profil, byggjeklossar og interaktive døme frå løysingane til Mesterbrevnemnda.",
    "intro": "Tilrådde mønster med komponentane som blir brukte i løysinga. Døma bruker fiktive data og blir ikkje lagra.",
    "list_standard": "Bruk luftige lister i sjølvbetening og kompakte lister i tette arbeidsflater for saksbehandling.",
    "status_standard": "Vis status med tekst og ikon. Bruk rolege omriss til vanlege statusar og farga bakgrunn når noko krev oppfølging.",
    "controls_standard": "Korte lister treng få kontrollar. Legg til søk, filter og sortering når mengda innhald gjer det nyttig.",
    "documents": "Dokumentveljar",
    "preview_mode": "Vis dokumentkort med",
    "preview_pages": "Sideminiatyr (tilrådd)",
    "preview_fallback": "Filtypeikon (reserve)",
    "preview_hint": "Illustrerte dømesider. I løysinga blir første side av dokumentet vist når førehandsvising er tilgjengeleg. Filnamnet er alltid leseleg under miniatyren.",
    "fallback_hint": "Når førehandsvising manglar, blir filikon og filtype viste. Dokumentet kan framleis veljast.",
    "documents_hint": "Vel eit dokument med mus eller tastatur. Heile filnamnet blir vist. Når lista ikkje får plass, kan du rulle sidelengs eller bruke pilknappane.",
    "selected_document": "Valt dokument",
    "sample": "Fiktivt samandrag for å vise samspelet mellom komponentane.",
    "certificate_summary": "Fagbrevet dokumenterer bestått fagprøve i tømrarfaget.",
    "practice_summary": "Attesten beskriv arbeidsoppgåver og praksisperiode. Dokumentet ventar på vurdering.",
    "education_summary": "Vitnemålet manglar ei side. Fullstendig dokumentasjon må ettersendast.",
    "education": "Meisterutdanning",
    "approved": "Godkjent",
    "received": "Motteke",
    "incomplete": "Må supplerast",
    "list": "Lister og statusmerke",
    "list_hint": "Vel bruksområde og datamengd for å prøve standardane. Innstillingane nedanfor høyrer til galleriet.",
    "demo_settings": "Prøv mønsteret",
    "context": "Bruksområde",
    "portal": "Sjølvbetening",
    "admin": "Saksbehandling",
    "portal_hint": "Luftig liste med god leseavstand.",
    "admin_hint": "Kompakt liste for å få oversikt over meir informasjon samtidig.",
    "example": "Døme",
    "few": "Kort liste – 3 dokument",
    "many": "Lang liste – 12 dokument",
    "empty": "Ingen dokument enno",
    "empty_title": "Ingen dokument enno",
    "empty_hint": "Når du lastar opp eit dokument, blir det vist her.",
    "try_upload": "Prøv dokumentopplasting",
    "search": "Søk i dokument",
    "search_help": "Søket finn treff i både filnamn og dokumenttype. Prøv «fagbrev», eller skriv noko som ikkje finst for å sjå tomtilstanden.",
    "status": "Status",
    "all": "Alle statusar",
    "results": {
      "one": "%{count} dokument",
      "other": "%{count} dokument"
    },
    "filename": "Filnamn",
    "kind": "Dokumenttype",
    "no_results": "Ingen dokument passar søket og filtera.",
    "reset": "Nullstill søk og filter"
  },
  "display": {
    "panel": {
      "title": "Visning",
      "subtitle": "Tilpass tema, skrift og leselegheit",
      "subtitle_readability": "Tilpass tekst og leselegheit"
    },
    "section": {
      "theme": "Tema",
      "font": "Skrift",
      "readability": "Leselegheit"
    },
    "theme": {
      "label": "Modus",
      "options": {
        "light": "Lyst",
        "dark": "Mørkt",
        "system": "System"
      }
    },
    "accent": {
      "label": "Fargetema",
      "hint": "Fargar på flater, navigasjon og knappar",
      "options": {
        "authority": "Standard",
        "fjord": "Fjord",
        "sand": "Sand",
        "slate": "Skifer",
        "aurora": "Nordlys",
        "gold": "Gull",
        "terminal": "Terminal",
        "civic": "Burgunder",
        "friday": "Fredag"
      }
    },
    "color_intensity": {
      "label": "Fargeintensitet"
    },
    "font": {
      "label": "Skrifttype",
      "options": {
        "source": {
          "name": "Inter",
          "note": "Standard"
        },
        "plex": {
          "name": "IBM Plex Sans",
          "note": "Teknisk"
        },
        "atkinson": {
          "name": "Atkinson",
          "note": "Lesevennleg"
        },
        "system": {
          "name": "System",
          "note": "Native"
        }
      }
    },
    "text_size": {
      "label": "Tekststorleik",
      "hint": "Skalerer heile grensesnittet",
      "options": {
        "sm": "Liten",
        "md": "Standard",
        "lg": "Stor"
      }
    },
    "density": {
      "label": "Tettheit",
      "hint": "Plass mellom element og rader",
      "options": {
        "compact": "Kompakt",
        "normal": "Normal",
        "comfy": "Luftig"
      }
    },
    "crisp": {
      "label": "Skarpheit",
      "hint_on": "Skarp tekstkant",
      "hint_off": "Mjuk, glatta tekst",
      "options": {
        "false": "Mjuk",
        "true": "Skarp"
      }
    },
    "contrast": {
      "label": "Høg kontrast",
      "hint": "Mørkare tekst og tydelegare kantar"
    },
    "motion": {
      "label": "Reduser rørsle",
      "hint": "Slår av animasjonar og overgangar"
    },
    "reset": {
      "label": "Tilbakestill til standard"
    }
  },
  "documents": {
    "generate": {
      "kinds": {
        "documentation_request_letter": "Mangelbrev",
        "decision_pdf": "Vedtaksbrev",
        "master_certificate": "Mesterbrev",
        "application_summary": "Søknadssamandrag"
      },
      "heading": "Generer dokument",
      "language_label": "Språk",
      "preview": "Førehandsvis",
      "issue_vedtak": "Generer vedtaksbrev",
      "issue_mesterbrev": "Generer mesterbrev",
      "mesterbrev_blocked": "Mesterbrev kan utferdast når saka er innvilga og mesternummer er tildelt.",
      "issue_copy": "Generer gjenpart",
      "copy_blocked": "Gjenpart kan utferdast når eit mesterbrev er utferda.",
      "issue_summary": "Generer samandrag",
      "summary_blocked": "Samandrag kan genererast etter at søknaden er sendt inn.",
      "download": "Last ned",
      "needs_decision": "Vedtaksbrevet kan genererast når det er gjort eit vedtak i saka.",
      "none_issued": "Ingen offisielle dokument er genererte enno.",
      "error": "Klarte ikkje å generere dokumentet. Prøv igjen.",
      "languages": {
        "nb": "Bokmål",
        "nn": "Nynorsk",
        "en": "Engelsk"
      }
    },
    "request_letter": {
      "title": "Vi treng meir dokumentasjon",
      "case_label": "Saksnummer",
      "date_label": "Dato for førespurnaden",
      "deadline_label": "Frist for å sende dokumentasjonen",
      "documents_label": "Dokumentasjon vi ber om",
      "preview": "Førehandsvis mangelbrev",
      "issue": "Opprett brev og del på Mi side",
      "working": "Lagar brevet …"
    },
    "withdraw": {
      "action": "Trekk dokument",
      "withdrawn": "Trekt dokument",
      "explanation": "Dokumentet blir fjerna frå Mi side og blir ikkje lenger rekna som innsend dokumentasjon. Originalen og grunngjevinga blir verande i saka og arkivet.",
      "reason": "Grunngjeving",
      "error": "Dokumentet kunne ikkje trekkjast. Prøv igjen."
    },
    "errors": {
      "unavailable": "Dokumentet er ikkje tilgjengeleg."
    },
    "authority": {
      "name": "Mesterbrevnemnda",
      "address": "Mesterbrevnemnda, Oslo",
      "footer": "Mesterbrevnemnda"
    },
    "states": {
      "received": "Motteke",
      "processing": "Vert behandla",
      "archived": "Arkivert",
      "failed": "Feila"
    },
    "vedtak": {
      "title": "Vedtak",
      "case_label": "Saksnummer",
      "date_label": "Vedtaksdato",
      "outcome_label": "Resultat",
      "rationale_heading": "Grunngjeving",
      "legal_basis_heading": "Rettsleg grunnlag",
      "appeal": {
        "heading": "Klagerett",
        "body": "Du kan klage på dette vedtaket etter forvaltningslova § 28. Klagefristen er tre veker rekna frå den dagen du tok imot dette vedtaket. Klagen sender du til Mesterbrevnemnda, som kan gjere om vedtaket eller sende saka vidare til klagenemnda for mesterbrevordninga. Klagen må vere skriftleg, vise til vedtaket du klagar på, og grunngje kva endringar du ønskjer."
      },
      "inspect": {
        "heading": "Innsyn i saksdokumenta",
        "body": "Du har etter forvaltningslova § 18, jf. § 19, rett til å gjere deg kjend med dokumenta i saka. Ta kontakt med Mesterbrevnemnda dersom du ønskjer innsyn."
      }
    },
    "mesterbrev": {
      "title": "Mesterbrev",
      "preamble": "Mesterbrevnemnda tildeler med dette mesterbrev i samsvar med mesterbrevlova § 1. Innehavaren har rett til å kalle seg mester i faget sitt.",
      "number_label": "Mesternummer",
      "date_label": "Utstedt",
      "signature": "Mesterbrevnemnda",
      "copy_mark": "GJENPART"
    },
    "application_summary": {
      "title": "Søknadssamandrag",
      "applicant_label": "Søkjar",
      "trade_label": "Fag",
      "status_label": "Status",
      "created_label": "Oppretta",
      "submitted_label": "Innsendt",
      "practice_heading": "Praksis i faget",
      "leadership_heading": "Praksis som næringsdrivande eller leiar",
      "subject_areas_heading": "Registrerte fagområde",
      "documents_heading": "Innsende dokument",
      "no_documents": "Ingen dokument er lasta opp."
    }
  },
  "feedback": {
    "trigger": "Meld feil",
    "title": "Meld feil",
    "intro": "Fann du noko som ikkje verkar? Fortel oss kva som skjedde, så kan vi rette feilen.",
    "category_label": "Kva gjeld det?",
    "body_label": "Kva skjedde?",
    "body_placeholder": "Skildre kva du gjorde og kva du venta skulle skje.",
    "body_required": "Skriv ei kort skildring før du sender.",
    "screenshot_label": "Legg ved skjermbilete",
    "screenshot_hint": "Skjermbiletet viser sida slik ho såg ut då du klikka.",
    "screenshot_alt": "Skjermbilete av sida",
    "submit": "Send",
    "submitting": "Sender …",
    "cancel": "Avbryt",
    "close": "Lukk",
    "success_title": "Takk for meldinga",
    "success_body": "Vi svarar ikkje på denne meldinga. Treng du svar, kontakt oss på post@mesterbrev.no.",
    "error": "Vi klarte ikkje å sende meldinga. Prøv igjen om litt."
  },
  "letters": {
    "delivery": {
      "unsent": "Ferdigstilt – ikkje sendt",
      "published": "Publisert for søkjaren",
      "unsent_hint": "Brevet er låst. Kontroller PDF-en og send når du er klar.",
      "send": "Send til søkjaren",
      "preview": "Førehandsvis ferdig brev",
      "confirm_title": "Send brevet til søkjaren",
      "confirm_body": "Den lagra PDF-en blir tilgjengeleg for søkjaren i portalen, og varsling blir bestilt. Kontaktopplysningar og reservasjon blir kontrollerte i varslingsløpet. Eventuelt papirbehov må følgjast opp.",
      "confirm_receipt": "Sending stadfestar ikkje mottak. Registrer når brevet kom fram før klagefristen kan reknast ut.",
      "refresh": "Oppdater utsendingsstatus",
      "retry": "Prøv varslinga på nytt",
      "retry_queued": "Nytt varslingsforsøk er bestilt. Oppdater status om litt.",
      "queued": "Varsel i kø",
      "sending": "Varsling klargjord – overlevering ikkje stadfesta",
      "sent": "Varsel sendt – mottak av brevet er ikkje stadfesta",
      "failed": "Varslinga mislukkast",
      "uncertain": "Varslingsresultatet er uavklart – følg opp før ny sending",
      "routed_paper": "Papirutsending må følgjast opp",
      "portal_ready": "Melding tilgjengeleg i portalen",
      "portal_pending": "Portalmelding blir behandla",
      "paper_sent": "Papirutsending registrert",
      "register_paper": "Registrer papirutsending",
      "paper_date": "Dato brevet blei sendt på papir",
      "register_receipt": "Registrer mottak",
      "edit_receipt": "Rett mottaksregistrering",
      "received_on": "Dato brevet kom fram",
      "receipt_basis": "Grunnlag for mottaksdatoen",
      "receipt_hint": "Beskriv korleis mottaksdatoen er dokumentert. Ved retting må du òg forklare kvifor registreringa blir endra.",
      "save_receipt": "Lagre mottaksregistrering",
      "save_paper": "Lagre papirutsending",
      "missing_receipt": "Mottak er ikkje registrert. Klagefristen er ikkje stadfesta av denne utsendinga.",
      "appeal_deadline": "Klagefrist for vedtaket",
      "previous_receipt": "Vedtaket var allereie underretta. Mottak av dette brevet endrar ikkje den registrerte klagefristen.",
      "paper_hint": "Registrer faktisk papirutsending før mottak når varslinga er ruta til papir.",
      "choose_template_link": "Vel relevant mal frå saka. Eksisterande vedtak blir valt uttrykkeleg."
    },
    "backend": {
      "letter_file_unavailable": "Den lagra PDF-en er ikkje tilgjengeleg. Brevet er ikkje publisert eller varsla. Få fila gjenoppretta før du prøver igjen.",
      "dispatch_unavailable": "Dette dokumentet kan ikkje sendast gjennom vedtaksbrevløpet.",
      "recipient_changed": "Saks- eller mottakaropplysningar er endra sidan brevet blei ferdigstilt. Kontroller grunnlaget og opprett eit korrigert brev før sending.",
      "stale_delivery": "Utsendingsopplysningane er endra. Oppdater status før du lagrar på nytt. Inndata er bevarte.",
      "invalid_delivery_date": "Oppgi ein gyldig dato frå utsendingsbestillinga til og med i dag. Papirutsending kan ikkje vere etter registrert mottak.",
      "receipt_basis_required": "Oppgi grunnlaget for mottaksdatoen, maksimalt 2500 teikn.",
      "paper_not_required": "Denne utsendinga er ikkje ruta til papir.",
      "paper_not_sent": "Registrer papirutsending før mottak. Mottaksdatoen kan ikkje vere før papirutsendinga.",
      "retry_unavailable": "Varslinga kan ikkje gjentakast automatisk. Oppdater status og kontroller resultatet.",
      "birth_date": "Fødselsdato",
      "decided_by_body": "Vedtaksorgan",
      "invalid_value": "Vel eller oppgje ein gyldig verdi.",
      "too_long": "Teksten er for lang (maksimalt 20 000 teikn).",
      "required": "Fyll ut feltet.",
      "unknown_field": "Feltet er ikkje tillate i denne malen.",
      "locked": "Dette feltet er henta frå vedtaket og kan ikkje endrast.",
      "invalid_date": "Oppgje ein gyldig dato.",
      "area_mismatch": "Fordel alle omsøkte fagområde mellom innvilga og avslått, utan overlapp.",
      "missing_source": "Ei påkravd opplysning manglar i saka eller brevet. Kontroller mottakar, adresse, datoar og fag.",
      "invalid_input": "Kontroller felta før du held fram.",
      "unavailable": "Malen er ikkje tilgjengeleg for denne saka.",
      "issued": "Brevet er ferdigstilt og kan ikkje endrast.",
      "revision_changed": "Malen er oppdatert. Opprett eit nytt utkast med gjeldande mal.",
      "wrong_outcome": "Malen passar ikkje til utfallet i det valde vedtaket.",
      "appeals_board_unsupported": "Denne malen gjeld vedtak i første instans. Klagenemnda sitt endelege vedtak må bruke sin eigen brevtekst.",
      "decision_not_ready": "Saka må vere klar for vedtak eller ha eit valt eksisterande vedtak før brevet blir ferdigstilt.",
      "grant_decision_required": "Innvilgingsbrevet krev eit eksisterande innvilgingsvedtak og tildelt meisternummer. Gjer vedtak frå saka og vel vedtaket når du opprettar brevet.",
      "notice_not_ready": "Førehandsvarsel kan ferdigstillast medan saka er under vurdering, ventar på dokumentasjon eller er klar for vedtak.",
      "appeal_not_ready": "Registrer klaga i saka før mottaksbrevet blir ferdigstilt.",
      "stale_draft": "Utkastet er endra. Last inn siste versjon før du held fram.",
      "stale_preview": "Saksopplysningar eller brevgrunnlag er endra. Oppdater førehandsvisinga og kontroller brevet på nytt.",
      "render_failed": "PDF-en kunne ikkje ferdigstillast. Endringane er ikkje fullførte. Prøv igjen."
    },
    "title": "Brev",
    "create_link": "Lag brev",
    "catalogue_title": "Brevmalar",
    "catalogue_hint": "Sjå bruksområde, felt og PDF-døme. Opprett brevet frå saka for å bruke ein mal.",
    "template": "Mal",
    "category": "Kategori",
    "language": "Språk",
    "revision": "Revisjon",
    "status": "Status",
    "ready": "Klar",
    "awaiting_sanctions": "Ventar på sanksjonsløp",
    "sanctions_hint": "Denne malen kan førehandsvisast med dømedata. Brev kan opprettast når sanksjonsløpet er tilgjengeleg.",
    "search": "Søk i brevmalar",
    "all_categories": "Alle kategoriar",
    "count": "%{count} av %{total} malar",
    "no_templates": "Ingen malar passar til søket",
    "example": "Dømebrev",
    "view_example": "Sjå døme",
    "view_template": "Sjå mal",
    "preview_actions": "Førehandsvising",
    "preview_choices": "Malalternativ",
    "placeholder_hint": "Tekst i [klammer] blir fylt inn frå saka eller av saksbehandlaren. Malalternativa avgjer kva faste avsnitt som blir viste.",
    "fields": "Opplysningar og tekstval",
    "about_template": "Om malen",
    "available_choices": "Tilgjengelege val",
    "required_when_applicable": "Påkravd når aktuelt",
    "required": "Påkravd",
    "optional": "Valfritt",
    "condition": "Blir vist når %{field}: %{values}",
    "loading": "Lastar PDF …",
    "categories": {
      "application": "Søknad om meisterbrev",
      "foreign": "Utanlandske kvalifikasjonar",
      "prior_learning": "Realkompetanse",
      "exemption": "Fritak",
      "appeal": "Klage",
      "sanction": "Ulovleg tittelbruk"
    },
    "field_types": {
      "text": "Tekstfelt",
      "textarea": "Fritekst",
      "date": "Dato",
      "select": "Eitt val",
      "multiselect": "Fleire val"
    },
    "choose": "Vel …",
    "locked_field": "Henta frå det tilknytte vedtaket. Kan ikkje endrast i brevet.",
    "fields_hint": "Felt merkte * må fyllast ut før ferdigstilling. Du kan lagre eit uferdig utkast. Felta og innhaldet i brevet er på bokmål.",
    "language_hint": "Brevmalane og dei ferdige breva er på bokmål, uavhengig av språk i brukargrensesnittet.",
    "saved_letters": "Lagra brev",
    "choose_draft": "Vel eit brev …",
    "new_letter": "Nytt brev",
    "choose_template": "Vel ein mal …",
    "decision": "Tilknyting til vedtak",
    "decision_hint": "Vel eit eksisterande vedtak uttrykkjeleg, eller la brevet gjelde eit nytt vedtak. Eit utkast fattar ikkje vedtak.",
    "new_decision": "Nytt vedtak – blir fatta ved ferdigstilling",
    "linked_decision": "Tilknytt vedtak",
    "outcome": "Utfall",
    "create_draft": "Opprett utkast",
    "no_applicable_templates": "Ingen tilgjengelege malar for denne saka.",
    "no_drafts": "Ingen lagra brev",
    "draft": "Utkast",
    "read_only": "Berre lesetilgang",
    "issued": "Ferdigstilt brev",
    "saved": "Utkast lagra",
    "unsaved": "Ulagra endringar",
    "working": "Arbeider …",
    "source_title": "Opplysningar frå saka",
    "source_hint": "Desse opplysningane blir henta frå saka og kan ikkje endrast her. Eventuelle feil må rettast i saka eller i rett register.",
    "not_available": "Ikkje registrert",
    "source": {
      "applicant_name": "Mottakar",
      "recipient_address": "Mottakaradresse",
      "case_number": "Saksnummer",
      "trade_name": "Fag",
      "application_date": "Søknadsdato",
      "caseworker_name": "Sakshandsamar"
    },
    "save": "Lagre utkast",
    "preview": "Førehandsvising",
    "refresh_preview": "Oppdater førehandsvising",
    "save_before_preview": "Endringane er ikkje lagra. Lagre utkastet før du oppdaterer førehandsvisinga.",
    "preview_current": "Førehandsvisinga gjeld det lagra utkastet. Kontroller PDF-en før ferdigstilling.",
    "preview_required": "Kontroller PDF-førehandsvisinga før brevet blir ferdigstilt.",
    "preview_incomplete": "Førehandsvisinga viser eit uferdig brev. Fullfør påkravde felt og kontroller vala før ferdigstilling.",
    "no_preview": "Inga oppdatert førehandsvising",
    "master_number_hint": "Innvilgingsbrevet bruker meisternummeret som er registrert etter innvilgingsvedtaket.",
    "issue": "Ferdigstill brev",
    "decide_and_issue": "Fatt vedtak og ferdigstill brev",
    "confirm_decision": "Du fattar eit nytt vedtak med utfallet nedanfor og ferdigstiller brevet med grunnlaget frå førehandsvisinga. Vedtaket og brevet kan ikkje redigerast etterpå.",
    "confirm_issue": "Du ferdigstiller brevet med grunnlaget frå førehandsvisinga. Brevet kan ikkje redigerast etterpå. Det blir ikkje oppretta eit nytt vedtak.",
    "confirm_not_sent": "Ferdigstilling sender ikkje brevet. Vedtaksbrev blir publiserte og varsla gjennom det separate sendesteget.",
    "not_sent": "Brevet er generert. Sjå dokumentdeling og kommunikasjonsstatus i saka.",
    "download_pdf": "Last ned PDF",
    "back_to_case": "Til saka",
    "cancel": "Avbryt",
    "leave_dirty": "Du har ulagra endringar. Vil du forkaste dei og halde fram?",
    "invalid_input": "Kontroller felta nedanfor. Endringane dine er bevarte.",
    "error_summary": "Handlinga kunne ikkje fullførast",
    "general_error": "Kontroller brevet og opplysningane i saka: %{message}",
    "request_failed": "Handlinga kunne ikkje fullførast. Prøv igjen. Endringane dine er bevarte.",
    "conflict": "Utkastet eller grunnlaget for førehandsvisinga er endra.",
    "conflict_hint": "Endringane dine er bevarte her. Kopier tekst du vil ta vare på, og last inn siste versjon før du held fram. Innlasting erstattar dei lokale endringane.",
    "stale_preview_hint": "Førehandsvisinga er utdatert. Oppdater henne og kontroller PDF-en på nytt. Last inn siste versjon dersom utkastet er endra.",
    "reload": "Last inn siste versjon",
    "delivery_date_required": "Oppgi datoen."
  },
  "notifications": {
    "templates": {
      "fallback": "Du har motteke ei ny melding frå Mesterbrevnemnda vedrørande sak %{case_number}.",
      "decision_notice": {
        "label": "Vedtaksunderretning",
        "email": {
          "subject": "Vedtak i sak %{case_number}",
          "body": "Hei %{applicant_name},\n\nMesterbrevnemnda har gjort vedtak i saka di %{case_number}. Du finn vedtaket og grunngjevinga på Mi side i mesterbrevportalen.\n\nMed vennleg helsing\nMesterbrevnemnda\n"
        }
      },
      "request_more_information": {
        "label": "Førespurnad om meir informasjon",
        "email": {
          "subject": "Vi treng meir informasjon i sak %{case_number}",
          "body": "Hei %{applicant_name},\n\nMesterbrevnemnda treng meir informasjon for å behandle saka di %{case_number}. Logg inn på Mi side i mesterbrevportalen for å sjå kva som manglar og laste opp dokumentasjon.\n\nMed vennleg helsing\nMesterbrevnemnda\n"
        },
        "sms": {
          "body": "Mesterbrevnemnda treng meir informasjon i sak %{case_number}. Logg inn på Mi side for detaljar."
        }
      },
      "appeal_received": {
        "label": "Stadfesting på motteken klage",
        "email": {
          "subject": "Vi har motteke klaga di i sak %{case_number}",
          "body": "Hei %{applicant_name},\n\nMesterbrevnemnda har motteke klaga di på vedtaket i sak %{case_number}. Klaga blir behandla, og du vil bli varsla når det ligg føre ei avgjerd.\n\nMed vennleg helsing\nMesterbrevnemnda\n"
        }
      },
      "arsgebyr_paakrav": {
        "label": "Påkrav om årsgebyr",
        "email": {
          "subject": "Påkrav – ubetalt årsgebyr for meisterbrev i %{trade}",
          "body": "Hei,\n\nVi har ikkje registrert betaling av årsgebyret for meisterbrevet ditt i %{trade} for %{fee_period}.\n\nBetal snarast med KID-nummer %{kid}. Dersom årsgebyret framleis er ubetalt éin månad etter dette påkravet, fell meisterbrevet bort etter meisterbrevlova § 5.\n\nMed vennleg helsing\nMesterbrevnemnda\n"
        },
        "sms": {
          "body": "Påkrav: årsgebyret for meisterbrevet ditt (%{trade}, %{fee_period}) er ubetalt. Betal med KID %{kid}. Framleis ubetalt éin månad etter dette medfører bortfall (meisterbrevlova § 5)."
        }
      }
    }
  },
  "template_management": {
    "baseline_summary": "Oppretta frå kodegrunnlaget for Azure dev/test.",
    "library": {
      "hint": "Finn og rediger brevmalar eller opprett ein ny.",
      "new": "Ny brevmal",
      "create": "Opprett brevmal",
      "name": "Namn på brevmal",
      "create_hint": "Vel maltype og gi brevmalen eit namn. Malen blir oppretta som eit utkast. Du må publisere han før han kan brukast i brev.",
      "template": "Brevmal",
      "categories": "Kategoriar",
      "search_hint": "Søk etter namn, maltype eller bruksområde",
      "filters": "Filter",
      "remove_filter": "Fjern filter: %{label}",
      "count": {
        "one": "%{count} brevmal",
        "other": "%{count} brevmalar"
      },
      "sort": "Sortering",
      "sort_name": "Namn A–Å",
      "sort_changed": "Sist endra først",
      "edit": "Rediger",
      "preview": "Førehandsvis",
      "original": "Opphavleg mal",
      "about_type": "Om maltypen",
      "empty": "Ingen aktive brevmalar i dette utvalet",
      "no_matches": "Ingen brevmalar passar med søket eller filtera",
      "first": "Opprett første brevmal"
    },
    "validation_summary": "Rett feila før du publiserer",
    "title": "Malforvaltning",
    "variants": "Malvariantar",
    "manage": "Forvalt variantar",
    "pilot": "Alle maltypar kan opprettast som redigerbare variantar.",
    "create": "Opprett variant",
    "create_from_template": "Opprett variant frå denne malen",
    "items_from": "Gjenta listepunkt for",
    "fixed_items": "Fast punktliste",
    "current_item": "Gjeldande val i lista",
    "items_from_hint": "Kvart listepunkt blir gjenteke for dei valde verdiane. Bruk item i Liquid-vilkår for å velje tekst for kvart val.",
    "name": "Namn på brevmal",
    "description": "Blir brukt når",
    "owner": "Ansvarleg",
    "type": "Maltype",
    "version": "Versjon",
    "history": "Versjonshistorikk",
    "published": "Publisert",
    "draft": "Arbeidsutkast",
    "archived": "Arkivert",
    "default": "Standard",
    "set_default": "Bruk som standard",
    "archive": "Arkiver brevmal",
    "restore": "Opne brevmalen att",
    "revise": "Ny versjon frå denne",
    "save": "Lagre arbeidsutkast",
    "saved": "Arbeidsutkast lagra",
    "unsaved": "Ulagra endringar",
    "publish": "Publiser versjon",
    "confirm_publish": "Publiser denne versjonen for nye brev? Eksisterande brevutkast beheld sin versjon.",
    "confirm_archive": "Vil du arkivere brevmalen? Då kan han ikkje veljast til nye brev. Eksisterande brev og malversjonar blir bevarte.",
    "summary": "Endringsomtale",
    "subject": "Emne",
    "sections": "Seksjonar",
    "section": "Seksjon %{number}",
    "heading": "Overskrift",
    "paragraph": "Avsnitt %{number}",
    "item": "Listepunkt %{number}",
    "add_section": "Legg til seksjon",
    "add_paragraph": "Legg til avsnitt",
    "add_item": "Legg til listepunkt",
    "remove": "Fjern",
    "up": "Flytt opp",
    "down": "Flytt ned",
    "insert_field": "Set inn opplysning",
    "choose_field": "Vel felt …",
    "fields": "Tilgjengelege flettefelt",
    "liquid_help": "Bruk flettefelta for saksopplysningar. Avanserte tekstval kan bruke Liquid if, unless, case og for. Verdiar er tekst; HTML og Typst-kode blir ikkje køyrde.",
    "preview": "PDF med eksempeldata",
    "preview_hint": "Lagre for å oppdatere PDF-en. Eksemplet bruker fiktive opplysningar.",
    "back": "Til maloversikta",
    "working": "Arbeider …",
    "leave": "Du har ulagra endringar. Vil du halde fram utan å lagre?",
    "usage": "Brev som bruker versjonen",
    "author": "Oppretta av",
    "publisher": "Publisert av",
    "published_at": "Publisert dato",
    "legacy": "Opphavleg kodemal",
    "choose_variant": "Malvariant",
    "placeholder": "[Manglar opplysning]",
    "content": "Innhald",
    "details": "Detaljar",
    "current": "Gjeldande",
    "previous": "Tidlegare versjon",
    "edit": "Rediger mal",
    "continue_draft": "Rediger utkast",
    "actions": "Fleire handlingar",
    "section_actions": "Seksjonshandlingar",
    "add_heading": "Legg til overskrift",
    "section_removed": "Seksjonen er fjerna.",
    "content_removed": "Teksten er fjerna.",
    "section_actions_for": "Handlingar for seksjon %{number}",
    "remove_paragraph": "Fjern avsnitt %{number}",
    "remove_item": "Fjern listepunkt %{number}",
    "undo": "Angre fjerning",
    "confirm_publication": "Stadfest publisering",
    "cancel": "Avbryt",
    "paper_hint": "Eksemplet bruker fiktive opplysningar. PDF-arket beheld utskriftsprofilen til brevet, medan verktøya følgjer temaet ditt.",
    "preview_stale": "Viser førre førehandsvising. Endringane er ikkje med enno.",
    "preview_invalid": "Rett feila i teksten for å oppdatere PDF-en.",
    "saving": "Lagrar …",
    "save_failed": "Ikkje lagra – prøv igjen",
    "retry_save": "Prøv lagring igjen",
    "preview_current": "PDF-en er oppdatert",
    "preview_loading": "Oppdaterer PDF …",
    "preview_waiting": "Ventar på gyldig, lagra innhald",
    "preview_error": "PDF-en kunne ikkje visast. Prøv igjen.",
    "retry_preview": "Prøv førehandsvising på nytt",
    "scenario": "Eksempel",
    "scenarios": {
      "without_optional": "Utan valfrie opplysningar",
      "all_choices": "Alle listeval",
      "reversed_choices": "Listeval i motsett rekkjefølgje",
      "standard": "Standardeksempel",
      "long_recipient": "Langt namn og adresse",
      "long_rationale": "Lang grunngiving"
    },
    "search_fields": "Søk etter opplysning",
    "no_fields": "Ingen opplysningar passar med søket.",
    "example": "Eksempel: %{value}",
    "line": "Linje %{number}",
    "technical_detail": "Teknisk forklaring",
    "pdf": "PDF",
    "fullscreen": "Fullskjerm",
    "exit_fullscreen": "Avslutt fullskjerm",
    "fullscreen_error": "Fullskjerm kunne ikkje opnast. PDF-en er framleis tilgjengeleg her.",
    "status": "Status",
    "letter_count": "Brev",
    "property": "Opplysning",
    "value": "Verdi",
    "example_label": "Eksempel",
    "drag_section": "Dra seksjon %{number}",
    "reorder_help": "Dra handtaket for å flytte seksjonen. Du kan òg bruke pil opp og pil ned når handtaket har fokus.",
    "section_moved": "Seksjonen er flytta til plass %{number} av %{count}.",
    "catalogue_hint": "Finn maltype og variant, eller opprett ein ny variant.",
    "catalogue_count": "%{types} maltypar · %{variants} variantar",
    "search_catalogue": "Søk",
    "all_types": "Alle maltypar",
    "clear_filters": "Fjern søk og filter",
    "last_changed": "Sist endra",
    "versions": "Versjonar",
    "draft_version": "Utkast v%{number}",
    "code_based": "Kodebasert",
    "copy": "Kopier brevmal",
    "copy_suffix": " – kopi",
    "copy_source": "Vel versjonen du vil kopiere",
    "copy_hint": "Kopien får same maltype og språk som originalen. Han blir oppretta som eit utkast og må publiserast før bruk.",
    "create_copy": "Opprett kopi",
    "variant_actions": "Handlingar for %{name}",
    "retry_versions": "Hent versjonar på nytt",
    "edit_metadata": "Rediger namn og beskriving",
    "save_metadata": "Lagre endringar",
    "metadata_name_hint": "Du endrar namnet i maloversikta. Namnet i eksisterande versjonar blir ikkje endra.",
    "version_name": "Namn i denne versjonen",
    "based_on": "Basert på",
    "compare": {
      "title": "Samanlikn versjonar",
      "open": "Sjå endringar",
      "from": "Frå",
      "to": "Til",
      "text": "Tekst og struktur",
      "await_save": "Kladden må vere lagra før han kan samanliknast. Lukk denne visinga for å rette eventuelle lagringsfeil.",
      "no_source": "Denne versjonen har ingen lagra versjon å samanlikne med.",
      "retry": "Prøv samanlikning igjen",
      "summary": "Nye seksjonar: %{added} · Fjerna: %{removed} · Flytta: %{moved} · Tekstendringar: %{text} · Endra opplysningar: %{metadata}",
      "identical": "Ingen endringar mellom desse versjonane.",
      "show_all": "Vis heile innhaldet",
      "added": "Lagt til",
      "removed": "Fjerna",
      "changed": "Endra",
      "unchanged": "Uendra",
      "moved": "Flytta frå plass %{from} til %{to}",
      "paragraphs": "Avsnitt",
      "items": "Listepunkt",
      "empty_text": "Tom tekst",
      "variant_name": "Versjonsnamn endra",
      "definition": "Felt- eller prosesskontrakt endra",
      "layout_revision": "Layoutrevisjon endra",
      "pdf_hint": "Begge PDF-ar bruker same fiktive eksempel. Dette er nye førehandsvisingar, ikkje historiske utferda brev."
    },
    "status_filters": {
      "active": "Alle aktive",
      "drafts": "Med arbeidsutkast",
      "published": "Publiserte",
      "draft_only": "Berre utkast",
      "archived": "Arkiverte"
    },
    "groups": {
      "recipient": "Mottakar",
      "case": "Sak",
      "decision": "Vedtak",
      "sender": "Avsendar"
    },
    "errors": {
      "structure": "Ugyldig malstruktur eller for mykje innhald.",
      "immutable": "Publiserte versjonar kan ikkje endrast. Opprett ein ny versjon.",
      "field": "Ukjent eller utilgjengeleg flettefelt: %{field}",
      "filter": "Malen bruker eit filter som ikkje er tilgjengeleg.",
      "missing": "Ei påkravd opplysning manglar i teksten.",
      "empty": "Malen må ha emne og synleg innhald.",
      "unsupported": "Denne maltypen er ikkje overført til Liquid enno.",
      "version": "Vel ein publisert versjon som høyrer til varianten.",
      "archived": "Varianten er arkivert.",
      "operation": "Ugyldig handling.",
      "conflict": "Nokon har endra malen. Last sida på nytt før du prøver igjen. Endringane dine er bevarte her.",
      "request": "Handlinga kunne ikkje fullførast. Prøv igjen.",
      "scenario": "Vel eit tilgjengeleg eksempel.",
      "syntax": "Ugyldig Liquid-uttrykk. Kontroller feltnamn, vilkår og avsluttande teikn eller taggar.",
      "layout": "Denne layoutrevisjonen kan ikkje førehandsvisast med tilgjengeleg brevprofil."
    }
  }
}
